! function(e, t) {
    "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.AOS = t() : e.AOS = t()
}(this, function() {
    return o = [function(e, t, i) {
        "use strict";

        function o(e) {
            return e && e.__esModule ? e : {
                default: e
            }
        }

        function n() {
            f = (0, h.default)(), v()
        }
        var s = Object.assign || function(e) {
                for (var t = 1; t < arguments.length; t++) {
                    var i, o = arguments[t];
                    for (i in o) Object.prototype.hasOwnProperty.call(o, i) && (e[i] = o[i])
                }
                return e
            },
            r = (o(i(1)), i(6)),
            a = o(r),
            l = o(i(7)),
            c = o(i(8)),
            d = o(i(9)),
            u = o(i(10)),
            p = o(i(11)),
            h = o(i(14)),
            f = [],
            m = !1,
            g = {
                offset: 120,
                delay: 0,
                easing: "ease",
                duration: 400,
                disable: !1,
                once: !1,
                startEvent: "DOMContentLoaded",
                throttleDelay: 99,
                debounceDelay: 50,
                disableMutationObserver: !1
            },
            v = function() {
                if (m = 0 < arguments.length && void 0 !== arguments[0] && arguments[0] ? !0 : m) return f = (0, p.default)(f, g), (0, u.default)(f, g.once), f
            };
        e.exports = {
            init: function(e) {
                g = s(g, e), f = (0, h.default)();
                var t, e = document.all && !window.atob;
                return !0 === (t = g.disable) || "mobile" === t && d.default.mobile() || "phone" === t && d.default.phone() || "tablet" === t && d.default.tablet() || "function" == typeof t && !0 === t() || e ? void f.forEach(function(e, t) {
                    e.node.removeAttribute("data-aos"), e.node.removeAttribute("data-aos-easing"), e.node.removeAttribute("data-aos-duration"), e.node.removeAttribute("data-aos-delay")
                }) : (g.disableMutationObserver || c.default.isSupported() || (console.info('\n      aos: MutationObserver is not supported on this browser,\n      code mutations observing has been disabled.\n      You may have to call "refreshHard()" by yourself.\n    '), g.disableMutationObserver = !0), document.querySelector("body").setAttribute("data-aos-easing", g.easing), document.querySelector("body").setAttribute("data-aos-duration", g.duration), document.querySelector("body").setAttribute("data-aos-delay", g.delay), "DOMContentLoaded" === g.startEvent && -1 < ["complete", "interactive"].indexOf(document.readyState) ? v(!0) : ("load" === g.startEvent ? window : document).addEventListener(g.startEvent, function() {
                    v(!0)
                }), window.addEventListener("resize", (0, l.default)(v, g.debounceDelay, !0)), window.addEventListener("orientationchange", (0, l.default)(v, g.debounceDelay, !0)), window.addEventListener("scroll", (0, a.default)(function() {
                    (0, u.default)(f, g.once)
                }, g.throttleDelay)), g.disableMutationObserver || c.default.ready("[data-aos]", n), f)
            },
            refresh: v,
            refreshHard: n
        }
    }, function(e, t) {}, , , , , function(h, e) {
        ! function(e) {
            "use strict";

            function s(o, i, e) {
                function n(e) {
                    var t = l,
                        i = c;
                    return l = c = void 0, f = e, u = o.apply(i, t)
                }

                function s(e) {
                    var t = e - h;
                    return void 0 === h || i <= t || t < 0 || g && d <= e - f
                }

                function r() {
                    var e, t = $();
                    return s(t) ? a(t) : void(p = setTimeout(r, (e = i - ((t = t) - h), g ? C(e, d - (t - f)) : e)))
                }

                function a(e) {
                    return p = void 0, v && l ? n(e) : (l = c = void 0, u)
                }

                function t() {
                    var e = $(),
                        t = s(e);
                    if (l = arguments, c = this, h = e, t) {
                        if (void 0 === p) return f = e = h, p = setTimeout(r, i), m ? n(e) : u;
                        if (g) return p = setTimeout(r, i), n(h)
                    }
                    return void 0 === p && (p = setTimeout(r, i)), u
                }
                var l, c, d, u, p, h, f = 0,
                    m = !1,
                    g = !1,
                    v = !0;
                if ("function" != typeof o) throw new TypeError(b);
                return i = w(i) || 0, y(e) && (m = !!e.leading, g = "maxWait" in e, d = g ? k(w(e.maxWait) || 0, i) : d, v = "trailing" in e ? !!e.trailing : v), t.cancel = function() {
                    void 0 !== p && clearTimeout(p), l = h = c = p = void(f = 0)
                }, t.flush = function() {
                    return void 0 === p ? u : a($())
                }, t
            }

            function y(e) {
                var t = void 0 === e ? "undefined" : o(e);
                return e && ("object" == t || "function" == t)
            }

            function i(e) {
                return "symbol" == (void 0 === e ? "undefined" : o(e)) || !!(t = e) && "object" == (void 0 === t ? "undefined" : o(t)) && "[object Symbol]" == p.call(e);
                var t
            }

            function w(e) {
                if ("number" == typeof e) return e;
                if (i(e)) return n;
                if ("string" != typeof(e = y(e) ? y(t = "function" == typeof e.valueOf ? e.valueOf() : e) ? t + "" : t : e)) return 0 === e ? e : +e;
                e = e.replace(r, "");
                var t = l.test(e);
                return t || c.test(e) ? d(e.slice(2), t ? 2 : 8) : a.test(e) ? n : +e
            }
            var o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
                },
                b = "Expected a function",
                n = NaN,
                r = /^\s+|\s+$/g,
                a = /^[-+]0x[0-9a-f]+$/i,
                l = /^0b[01]+$/i,
                c = /^0o[0-7]+$/i,
                d = parseInt,
                e = "object" == (void 0 === e ? "undefined" : o(e)) && e && e.Object === Object && e,
                t = "object" == ("undefined" == typeof self ? "undefined" : o(self)) && self && self.Object === Object && self,
                u = e || t || Function("return this")(),
                p = Object.prototype.toString,
                k = Math.max,
                C = Math.min,
                $ = function() {
                    return u.Date.now()
                };
            h.exports = function(e, t, i) {
                var o = !0,
                    n = !0;
                if ("function" != typeof e) throw new TypeError(b);
                return y(i) && (o = "leading" in i ? !!i.leading : o, n = "trailing" in i ? !!i.trailing : n), s(e, t, {
                    leading: o,
                    maxWait: t,
                    trailing: n
                })
            }
        }.call(e, function() {
            return this
        }())
    }, function(h, e) {
        ! function(e) {
            "use strict";

            function y(e) {
                var t = void 0 === e ? "undefined" : o(e);
                return e && ("object" == t || "function" == t)
            }

            function i(e) {
                return "symbol" == (void 0 === e ? "undefined" : o(e)) || !!(t = e) && "object" == (void 0 === t ? "undefined" : o(t)) && p.call(e) == s;
                var t
            }

            function w(e) {
                if ("number" == typeof e) return e;
                if (i(e)) return n;
                if ("string" != typeof(e = y(e) ? y(t = "function" == typeof e.valueOf ? e.valueOf() : e) ? t + "" : t : e)) return 0 === e ? e : +e;
                e = e.replace(r, "");
                var t = l.test(e);
                return t || c.test(e) ? d(e.slice(2), t ? 2 : 8) : a.test(e) ? n : +e
            }

            function b() {
                return u.Date.now()
            }
            var o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
                },
                n = NaN,
                s = "[object Symbol]",
                r = /^\s+|\s+$/g,
                a = /^[-+]0x[0-9a-f]+$/i,
                l = /^0b[01]+$/i,
                c = /^0o[0-7]+$/i,
                d = parseInt,
                e = "object" == (void 0 === e ? "undefined" : o(e)) && e && e.Object === Object && e,
                t = "object" == ("undefined" == typeof self ? "undefined" : o(self)) && self && self.Object === Object && self,
                u = e || t || Function("return this")(),
                p = Object.prototype.toString,
                k = Math.max,
                C = Math.min;
            h.exports = function(o, i, e) {
                function n(e) {
                    var t = l,
                        i = c;
                    return l = c = void 0, f = e, u = o.apply(i, t)
                }

                function s(e) {
                    var t = e - h;
                    return void 0 === h || i <= t || t < 0 || g && d <= e - f
                }

                function r() {
                    var e, t = b();
                    return s(t) ? a(t) : void(p = setTimeout(r, (e = i - ((t = t) - h), g ? C(e, d - (t - f)) : e)))
                }

                function a(e) {
                    return p = void 0, v && l ? n(e) : (l = c = void 0, u)
                }

                function t() {
                    var e = b(),
                        t = s(e);
                    if (l = arguments, c = this, h = e, t) {
                        if (void 0 === p) return f = e = h, p = setTimeout(r, i), m ? n(e) : u;
                        if (g) return p = setTimeout(r, i), n(h)
                    }
                    return void 0 === p && (p = setTimeout(r, i)), u
                }
                var l, c, d, u, p, h, f = 0,
                    m = !1,
                    g = !1,
                    v = !0;
                if ("function" != typeof o) throw new TypeError("Expected a function");
                return i = w(i) || 0, y(e) && (m = !!e.leading, g = "maxWait" in e, d = g ? k(w(e.maxWait) || 0, i) : d, v = "trailing" in e ? !!e.trailing : v), t.cancel = function() {
                    void 0 !== p && clearTimeout(p), l = h = c = p = void(f = 0)
                }, t.flush = function() {
                    return void 0 === p ? u : a(b())
                }, t
            }
        }.call(e, function() {
            return this
        }())
    }, function(e, t) {
        "use strict";

        function n() {
            return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver
        }

        function s(e) {
            e && e.forEach(function(e) {
                var t = Array.prototype.slice.call(e.addedNodes),
                    e = Array.prototype.slice.call(e.removedNodes);
                if (function e(t) {
                        for (var i, o = void 0, o = 0; o < t.length; o += 1) {
                            if ((i = t[o]).dataset && i.dataset.aos) return !0;
                            if (i.children && e(i.children)) return !0
                        }
                        return !1
                    }(t.concat(e))) return r()
            })
        }
        Object.defineProperty(t, "__esModule", {
            value: !0
        });
        var r = function() {};
        t.default = {
            isSupported: function() {
                return !!n()
            },
            ready: function(e, t) {
                var i = window.document,
                    o = new(n())(s);
                r = t, o.observe(i.documentElement, {
                    childList: !0,
                    subtree: !0,
                    removedNodes: !0
                })
            }
        }
    }, function(e, t) {
        "use strict";

        function i() {
            return navigator.userAgent || navigator.vendor || window.opera || ""
        }
        Object.defineProperty(t, "__esModule", {
            value: !0
        });
        var o = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
            n = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
            s = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i,
            r = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
            a = (function(e, t, i) {
                return t && c(e.prototype, t), i && c(e, i), e
            }(l, [{
                key: "phone",
                value: function() {
                    var e = i();
                    return !(!o.test(e) && !n.test(e.substr(0, 4)))
                }
            }, {
                key: "mobile",
                value: function() {
                    var e = i();
                    return !(!s.test(e) && !r.test(e.substr(0, 4)))
                }
            }, {
                key: "tablet",
                value: function() {
                    return this.mobile() && !this.phone()
                }
            }]), l);

        function l() {
            if (!(this instanceof l)) throw new TypeError("Cannot call a class as a function")
        }

        function c(e, t) {
            for (var i = 0; i < t.length; i++) {
                var o = t[i];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o)
            }
        }
        t.default = new a
    }, function(e, t) {
        "use strict";
        Object.defineProperty(t, "__esModule", {
            value: !0
        });
        t.default = function(e, s) {
            var r = window.pageYOffset,
                a = window.innerHeight;
            e.forEach(function(e, t) {
                var i, o, n;
                i = a + r, o = s, n = (e = e).node.getAttribute("data-aos-once"), i > e.position ? e.node.classList.add("aos-animate") : void 0 === n || "false" !== n && (o || "true" === n) || e.node.classList.remove("aos-animate")
            })
        }
    }, function(e, t, i) {
        "use strict";
        Object.defineProperty(t, "__esModule", {
            value: !0
        });
        var i = i(12),
            o = (i = i) && i.__esModule ? i : {
                default: i
            };
        t.default = function(e, i) {
            return e.forEach(function(e, t) {
                e.node.classList.add("aos-init"), e.position = (0, o.default)(e.node, i.offset)
            }), e
        }
    }, function(e, t, i) {
        "use strict";
        Object.defineProperty(t, "__esModule", {
            value: !0
        });
        var i = i(13),
            r = (i = i) && i.__esModule ? i : {
                default: i
            };
        t.default = function(e, t) {
            var i = 0,
                o = 0,
                n = window.innerHeight,
                s = {
                    offset: e.getAttribute("data-aos-offset"),
                    anchor: e.getAttribute("data-aos-anchor"),
                    anchorPlacement: e.getAttribute("data-aos-anchor-placement")
                };
            switch (s.offset && !isNaN(s.offset) && (o = parseInt(s.offset)), s.anchor && document.querySelectorAll(s.anchor) && (e = document.querySelectorAll(s.anchor)[0]), i = (0, r.default)(e).top, s.anchorPlacement) {
                case "top-bottom":
                    break;
                case "center-bottom":
                    i += e.offsetHeight / 2;
                    break;
                case "bottom-bottom":
                    i += e.offsetHeight;
                    break;
                case "top-center":
                    i += n / 2;
                    break;
                case "bottom-center":
                    i += n / 2 + e.offsetHeight;
                    break;
                case "center-center":
                    i += n / 2 + e.offsetHeight / 2;
                    break;
                case "top-top":
                    i += n;
                    break;
                case "bottom-top":
                    i += e.offsetHeight + n;
                    break;
                case "center-top":
                    i += e.offsetHeight / 2 + n
            }
            return i + (o = s.anchorPlacement || s.offset || isNaN(t) ? o : t)
        }
    }, function(e, t) {
        "use strict";
        Object.defineProperty(t, "__esModule", {
            value: !0
        });
        t.default = function(e) {
            for (var t = 0, i = 0; e && !isNaN(e.offsetLeft) && !isNaN(e.offsetTop);) t += e.offsetLeft - ("BODY" != e.tagName ? e.scrollLeft : 0), i += e.offsetTop - ("BODY" != e.tagName ? e.scrollTop : 0), e = e.offsetParent;
            return {
                top: i,
                left: t
            }
        }
    }, function(e, t) {
        "use strict";
        Object.defineProperty(t, "__esModule", {
            value: !0
        });
        t.default = function(e) {
            return e = e || document.querySelectorAll("[data-aos]"), Array.prototype.map.call(e, function(e) {
                return {
                    node: e
                }
            })
        }
    }], n = {}, i.m = o, i.c = n, i.p = "dist/", i(0);

    function i(e) {
        if (n[e]) return n[e].exports;
        var t = n[e] = {
            exports: {},
            id: e,
            loaded: !1
        };
        return o[e].call(t.exports, t, t.exports, i), t.loaded = !0, t.exports
    }
    var o, n
}),
function(e) {
    "function" == typeof define && define.amd ? define(["jquery"], e) : "object" == typeof exports ? e(require("jquery")) : e(window.jQuery || window.Zepto)
}(function(c) {
    function e() {}

    function d(e, t) {
        f.ev.on("mfp" + e + $, t)
    }

    function u(e, t, i, o) {
        var n = document.createElement("div");
        return n.className = "mfp-" + e, i && (n.innerHTML = i), o ? t && t.appendChild(n) : (n = c(n), t && n.appendTo(t)), n
    }

    function p(e, t) {
        f.ev.triggerHandler("mfp" + e, t), f.st.callbacks && (e = e.charAt(0).toLowerCase() + e.slice(1), f.st.callbacks[e] && f.st.callbacks[e].apply(f, c.isArray(t) ? t : [t]))
    }

    function h(e) {
        return e === i && f.currTemplate.closeBtn || (f.currTemplate.closeBtn = c(f.st.closeMarkup.replace("%title%", f.st.tClose)), i = e), f.currTemplate.closeBtn
    }

    function s() {
        c.magnificPopup.instance || ((f = new e).init(), c.magnificPopup.instance = f)
    }

    function r() {
        y && (v.after(y.addClass(l)).detach(), y = null)
    }

    function n() {
        w && c(document.body).removeClass(w)
    }

    function t() {
        n(), f.req && f.req.abort()
    }
    var f, o, m, a, g, i, l, v, y, w, b = "Close",
        j = "BeforeClose",
        k = "MarkupParse",
        C = "Open",
        $ = ".mfp",
        S = "mfp-ready",
        M = "mfp-removing",
        T = "mfp-prevent-close",
        x = !!window.jQuery,
        _ = c(window),
        A = (c.magnificPopup = {
            instance: null,
            proto: e.prototype = {
                constructor: e,
                init: function() {
                    var e = navigator.appVersion;
                    f.isLowIE = f.isIE8 = document.all && !document.addEventListener, f.isAndroid = /android/gi.test(e), f.isIOS = /iphone|ipad|ipod/gi.test(e), f.supportsTransition = function() {
                        var e = document.createElement("p").style,
                            t = ["ms", "O", "Moz", "Webkit"];
                        if (void 0 !== e.transition) return !0;
                        for (; t.length;)
                            if (t.pop() + "Transition" in e) return !0;
                        return !1
                    }(), f.probablyMobile = f.isAndroid || f.isIOS || /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent), m = c(document), f.popupsCache = {}
                },
                open: function(e) {
                    if (!1 === e.isObj) {
                        f.items = e.items.toArray(), f.index = 0;
                        for (var t, i = e.items, o = 0; o < i.length; o++)
                            if ((t = (t = i[o]).parsed ? t.el[0] : t) === e.el[0]) {
                                f.index = o;
                                break
                            }
                    } else f.items = c.isArray(e.items) ? e.items : [e.items], f.index = e.index || 0;
                    if (!f.isOpen) {
                        f.types = [], g = "", e.mainEl && e.mainEl.length ? f.ev = e.mainEl.eq(0) : f.ev = m, e.key ? (f.popupsCache[e.key] || (f.popupsCache[e.key] = {}), f.currTemplate = f.popupsCache[e.key]) : f.currTemplate = {}, f.st = c.extend(!0, {}, c.magnificPopup.defaults, e), f.fixedContentPos = "auto" === f.st.fixedContentPos ? !f.probablyMobile : f.st.fixedContentPos, f.st.modal && (f.st.closeOnContentClick = !1, f.st.closeOnBgClick = !1, f.st.showCloseBtn = !1, f.st.enableEscapeKey = !1), f.bgOverlay || (f.bgOverlay = u("bg").on("click" + $, function() {
                            f.close()
                        }), f.wrap = u("wrap").attr("tabindex", -1).on("click" + $, function(e) {
                            f._checkIfClose(e.target) && f.close()
                        }), f.container = u("container", f.wrap)), f.contentContainer = u("content"), f.st.preloader && (f.preloader = u("preloader", f.container, f.st.tLoading));
                        var n = c.magnificPopup.modules;
                        for (o = 0; o < n.length; o++) {
                            var s = (s = n[o]).charAt(0).toUpperCase() + s.slice(1);
                            f["init" + s].call(f)
                        }
                        p("BeforeOpen"), f.st.showCloseBtn && (f.st.closeBtnInside ? (d(k, function(e, t, i, o) {
                            i.close_replaceWith = h(o.type)
                        }), g += " mfp-close-btn-in") : f.wrap.append(h())), f.st.alignTop && (g += " mfp-align-top"), f.fixedContentPos ? f.wrap.css({
                            overflow: f.st.overflowY,
                            overflowX: "hidden",
                            overflowY: f.st.overflowY
                        }) : f.wrap.css({
                            top: _.scrollTop(),
                            position: "absolute"
                        }), !1 !== f.st.fixedBgPos && ("auto" !== f.st.fixedBgPos || f.fixedContentPos) || f.bgOverlay.css({
                            height: m.height(),
                            position: "absolute"
                        }), f.st.enableEscapeKey && m.on("keyup" + $, function(e) {
                            27 === e.keyCode && f.close()
                        }), _.on("resize" + $, function() {
                            f.updateSize()
                        }), f.st.closeOnContentClick || (g += " mfp-auto-cursor"), g && f.wrap.addClass(g);
                        var r = f.wH = _.height(),
                            a = {},
                            l = (f.fixedContentPos && f._hasScrollBar(r) && (l = f._getScrollbarSize()) && (a.marginRight = l), f.fixedContentPos && (f.isIE7 ? c("body, html").css("overflow", "hidden") : a.overflow = "hidden"), f.st.mainClass);
                        return f.isIE7 && (l += " mfp-ie7"), l && f._addClassToMFP(l), f.updateItemHTML(), p("BuildControls"), c("html").css(a), f.bgOverlay.add(f.wrap).prependTo(f.st.prependTo || c(document.body)), f._lastFocusedEl = document.activeElement, setTimeout(function() {
                            f.content ? (f._addClassToMFP(S), f._setFocus()) : f.bgOverlay.addClass(S), m.on("focusin" + $, f._onFocusIn)
                        }, 16), f.isOpen = !0, f.updateSize(r), p(C), e
                    }
                    f.updateItemHTML()
                },
                close: function() {
                    f.isOpen && (p(j), f.isOpen = !1, f.st.removalDelay && !f.isLowIE && f.supportsTransition ? (f._addClassToMFP(M), setTimeout(function() {
                        f._close()
                    }, f.st.removalDelay)) : f._close())
                },
                _close: function() {
                    p(b);
                    var e = M + " " + S + " ";
                    f.bgOverlay.detach(), f.wrap.detach(), f.container.empty(), f.st.mainClass && (e += f.st.mainClass + " "), f._removeClassFromMFP(e), f.fixedContentPos && (e = {
                        marginRight: ""
                    }, f.isIE7 ? c("body, html").css("overflow", "") : e.overflow = "", c("html").css(e)), m.off("keyup.mfp focusin" + $), f.ev.off($), f.wrap.attr("class", "mfp-wrap").removeAttr("style"), f.bgOverlay.attr("class", "mfp-bg"), f.container.attr("class", "mfp-container"), !f.st.showCloseBtn || f.st.closeBtnInside && !0 !== f.currTemplate[f.currItem.type] || f.currTemplate.closeBtn && f.currTemplate.closeBtn.detach(), f.st.autoFocusLast && f._lastFocusedEl && c(f._lastFocusedEl).focus(), f.currItem = null, f.content = null, f.currTemplate = null, f.prevHeight = 0, p("AfterClose")
                },
                updateSize: function(e) {
                    var t;
                    f.isIOS ? (t = document.documentElement.clientWidth / window.innerWidth, t = window.innerHeight * t, f.wrap.css("height", t), f.wH = t) : f.wH = e || _.height(), f.fixedContentPos || f.wrap.css("height", f.wH), p("Resize")
                },
                updateItemHTML: function() {
                    var e = f.items[f.index],
                        t = (f.contentContainer.detach(), f.content && f.content.detach(), (e = e.parsed ? e : f.parseEl(f.index)).type),
                        i = (p("BeforeChange", [f.currItem ? f.currItem.type : "", t]), f.currItem = e, f.currTemplate[t] || (i = !!f.st[t] && f.st[t].markup, p("FirstMarkupParse", i), f.currTemplate[t] = !i || c(i)), a && a !== e.type && f.container.removeClass("mfp-" + a + "-holder"), f["get" + t.charAt(0).toUpperCase() + t.slice(1)](e, f.currTemplate[t]));
                    f.appendContent(i, t), e.preloaded = !0, p("Change", e), a = e.type, f.container.prepend(f.contentContainer), p("AfterChange")
                },
                appendContent: function(e, t) {
                    (f.content = e) ? f.st.showCloseBtn && f.st.closeBtnInside && !0 === f.currTemplate[t] ? f.content.find(".mfp-close").length || f.content.append(h()) : f.content = e: f.content = "", p("BeforeAppend"), f.container.addClass("mfp-" + t + "-holder"), f.contentContainer.append(f.content)
                },
                parseEl: function(e) {
                    var t, i = f.items[e];
                    if ((i = i.tagName ? {
                            el: c(i)
                        } : (t = i.type, {
                            data: i,
                            src: i.src
                        })).el) {
                        for (var o = f.types, n = 0; n < o.length; n++)
                            if (i.el.hasClass("mfp-" + o[n])) {
                                t = o[n];
                                break
                            } i.src = i.el.attr("data-mfp-src"), i.src || (i.src = i.el.attr("href"))
                    }
                    return i.type = t || f.st.type || "inline", i.index = e, i.parsed = !0, f.items[e] = i, p("ElementParse", i), f.items[e]
                },
                addGroup: function(t, i) {
                    function e(e) {
                        e.mfpEl = this, f._openClick(e, t, i)
                    }
                    var o = "click.magnificPopup";
                    (i = i || {}).mainEl = t, i.items ? (i.isObj = !0, t.off(o).on(o, e)) : (i.isObj = !1, i.delegate ? t.off(o).on(o, i.delegate, e) : (i.items = t).off(o).on(o, e))
                },
                _openClick: function(e, t, i) {
                    var o = (void 0 !== i.midClick ? i : c.magnificPopup.defaults).midClick;
                    if (o || !(2 === e.which || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey)) {
                        o = (void 0 !== i.disableOn ? i : c.magnificPopup.defaults).disableOn;
                        if (o)
                            if (c.isFunction(o)) {
                                if (!o.call(f)) return !0
                            } else if (_.width() < o) return !0;
                        e.type && (e.preventDefault(), f.isOpen && e.stopPropagation()), i.el = c(e.mfpEl), i.delegate && (i.items = t.find(i.delegate)), f.open(i)
                    }
                },
                updateStatus: function(e, t) {
                    var i;
                    f.preloader && (o !== e && f.container.removeClass("mfp-s-" + o), i = {
                        status: e,
                        text: t = t || "loading" !== e ? t : f.st.tLoading
                    }, p("UpdateStatus", i), e = i.status, f.preloader.html(t = i.text), f.preloader.find("a").on("click", function(e) {
                        e.stopImmediatePropagation()
                    }), f.container.addClass("mfp-s-" + e), o = e)
                },
                _checkIfClose: function(e) {
                    if (!c(e).hasClass(T)) {
                        var t = f.st.closeOnContentClick,
                            i = f.st.closeOnBgClick;
                        if (t && i) return !0;
                        if (!f.content || c(e).hasClass("mfp-close") || f.preloader && e === f.preloader[0]) return !0;
                        if (e === f.content[0] || c.contains(f.content[0], e)) {
                            if (t) return !0
                        } else if (i && c.contains(document, e)) return !0;
                        return !1
                    }
                },
                _addClassToMFP: function(e) {
                    f.bgOverlay.addClass(e), f.wrap.addClass(e)
                },
                _removeClassFromMFP: function(e) {
                    this.bgOverlay.removeClass(e), f.wrap.removeClass(e)
                },
                _hasScrollBar: function(e) {
                    return (f.isIE7 ? m.height() : document.body.scrollHeight) > (e || _.height())
                },
                _setFocus: function() {
                    (f.st.focus ? f.content.find(f.st.focus).eq(0) : f.wrap).focus()
                },
                _onFocusIn: function(e) {
                    if (e.target !== f.wrap[0] && !c.contains(f.wrap[0], e.target)) return f._setFocus(), !1
                },
                _parseMarkup: function(n, e, t) {
                    var s;
                    t.data && (e = c.extend(t.data, e)), p(k, [n, e, t]), c.each(e, function(e, t) {
                        if (void 0 === t || !1 === t) return !0;
                        var i, o;
                        1 < (s = e.split("_")).length ? 0 < (i = n.find($ + "-" + s[0])).length && ("replaceWith" === (o = s[1]) ? i[0] !== t[0] && i.replaceWith(t) : "img" === o ? i.is("img") ? i.attr("src", t) : i.replaceWith(c("<img>").attr("src", t).attr("class", i.attr("class"))) : i.attr(s[1], t)) : n.find($ + "-" + e).html(t)
                    })
                },
                _getScrollbarSize: function() {
                    var e;
                    return void 0 === f.scrollbarSize && ((e = document.createElement("div")).style.cssText = "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;", document.body.appendChild(e), f.scrollbarSize = e.offsetWidth - e.clientWidth, document.body.removeChild(e)), f.scrollbarSize
                }
            },
            modules: [],
            open: function(e, t) {
                return s(), (e = e ? c.extend(!0, {}, e) : {}).isObj = !0, e.index = t || 0, this.instance.open(e)
            },
            close: function() {
                return c.magnificPopup.instance && c.magnificPopup.instance.close()
            },
            registerModule: function(e, t) {
                t.options && (c.magnificPopup.defaults[e] = t.options), c.extend(this.proto, t.proto), this.modules.push(e)
            },
            defaults: {
                disableOn: 0,
                key: null,
                midClick: !1,
                mainClass: "",
                preloader: !0,
                focus: "",
                closeOnContentClick: !1,
                closeOnBgClick: !0,
                closeBtnInside: !0,
                showCloseBtn: !0,
                enableEscapeKey: !0,
                modal: !1,
                alignTop: !1,
                removalDelay: 0,
                prependTo: null,
                fixedContentPos: "auto",
                fixedBgPos: "auto",
                overflowY: "auto",
                closeMarkup: '<button title="%title%" type="button" class="mfp-close">&#215;</button>',
                tClose: "Close (Esc)",
                tLoading: "Loading...",
                autoFocusLast: !0
            }
        }, c.fn.magnificPopup = function(e) {
            s();
            var t, i, o, n = c(this);
            return "string" == typeof e ? "open" === e ? (t = x ? n.data("magnificPopup") : n[0].magnificPopup, i = parseInt(arguments[1], 10) || 0, o = t.items ? t.items[i] : (o = n, (o = t.delegate ? o.find(t.delegate) : o).eq(i)), f._openClick({
                mfpEl: o
            }, n, t)) : f.isOpen && f[e].apply(f, Array.prototype.slice.call(arguments, 1)) : (e = c.extend(!0, {}, e), x ? n.data("magnificPopup", e) : n[0].magnificPopup = e, f.addGroup(n, e)), n
        }, "inline"),
        O = (c.magnificPopup.registerModule(A, {
            options: {
                hiddenClass: "hide",
                markup: "",
                tNotFound: "Content not found"
            },
            proto: {
                initInline: function() {
                    f.types.push(A), d(b + "." + A, function() {
                        r()
                    })
                },
                getInline: function(e, t) {
                    var i, o, n;
                    return r(), e.src ? (i = f.st.inline, (o = c(e.src)).length ? ((n = o[0].parentNode) && n.tagName && (v || (l = i.hiddenClass, v = u(l), l = "mfp-" + l), y = o.after(v).detach().removeClass(l)), f.updateStatus("ready")) : (f.updateStatus("error", i.tNotFound), o = c("<div>")), e.inlineElement = o) : (f.updateStatus("ready"), f._parseMarkup(t, {}, e), t)
                }
            }
        }), "ajax");
    c.magnificPopup.registerModule(O, {
        options: {
            settings: null,
            cursor: "mfp-ajax-cur",
            tError: '<a href="%url%">The content</a> could not be loaded.'
        },
        proto: {
            initAjax: function() {
                f.types.push(O), w = f.st.ajax.cursor, d(b + "." + O, t), d("BeforeChange." + O, t)
            },
            getAjax: function(o) {
                w && c(document.body).addClass(w), f.updateStatus("loading");
                var e = c.extend({
                    url: o.src,
                    success: function(e, t, i) {
                        e = {
                            data: e,
                            xhr: i
                        };
                        p("ParseAjax", e), f.appendContent(c(e.data), O), o.finished = !0, n(), f._setFocus(), setTimeout(function() {
                            f.wrap.addClass(S)
                        }, 16), f.updateStatus("ready"), p("AjaxContentAdded")
                    },
                    error: function() {
                        n(), o.finished = o.loadError = !0, f.updateStatus("error", f.st.ajax.tError.replace("%url%", o.src))
                    }
                }, f.st.ajax.settings);
                return f.req = c.ajax(e), ""
            }
        }
    });
    var E;
    c.magnificPopup.registerModule("image", {
        options: {
            markup: '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',
            cursor: "mfp-zoom-out-cur",
            titleSrc: "title",
            verticalFit: !0,
            tError: '<a href="%url%">The image</a> could not be loaded.'
        },
        proto: {
            initImage: function() {
                var e = f.st.image,
                    t = ".image";
                f.types.push("image"), d(C + t, function() {
                    "image" === f.currItem.type && e.cursor && c(document.body).addClass(e.cursor)
                }), d(b + t, function() {
                    e.cursor && c(document.body).removeClass(e.cursor), _.off("resize" + $)
                }), d("Resize" + t, f.resizeImage), f.isLowIE && d("AfterChange", f.resizeImage)
            },
            resizeImage: function() {
                var e, t = f.currItem;
                t && t.img && f.st.image.verticalFit && (e = 0, f.isLowIE && (e = parseInt(t.img.css("padding-top"), 10) + parseInt(t.img.css("padding-bottom"), 10)), t.img.css("max-height", f.wH - e))
            },
            _onImageHasSize: function(e) {
                e.img && (e.hasSize = !0, E && clearInterval(E), e.isCheckingImgSize = !1, p("ImageHasSize", e), e.imgHidden && (f.content && f.content.removeClass("mfp-loading"), e.imgHidden = !1))
            },
            findImageSize: function(t) {
                function i(e) {
                    E && clearInterval(E), E = setInterval(function() {
                        0 < n.naturalWidth ? f._onImageHasSize(t) : (200 < o && clearInterval(E), 3 === ++o ? i(10) : 40 === o ? i(50) : 100 === o && i(500))
                    }, e)
                }
                var o = 0,
                    n = t.img[0];
                i(1)
            },
            getImage: function(e, t) {
                function i() {
                    e && (e.img[0].complete ? (e.img.off(".mfploader"), e === f.currItem && (f._onImageHasSize(e), f.updateStatus("ready")), e.hasSize = !0, e.loaded = !0, p("ImageLoadComplete")) : ++s < 200 ? setTimeout(i, 100) : o())
                }

                function o() {
                    e && (e.img.off(".mfploader"), e === f.currItem && (f._onImageHasSize(e), f.updateStatus("error", r.tError.replace("%url%", e.src))), e.hasSize = !0, e.loaded = !0, e.loadError = !0)
                }
                var n, s = 0,
                    r = f.st.image,
                    a = t.find(".mfp-img");
                return a.length && ((n = document.createElement("img")).className = "mfp-img", e.el && e.el.find("img").length && (n.alt = e.el.find("img").attr("alt")), e.img = c(n).on("load.mfploader", i).on("error.mfploader", o), n.src = e.src, a.is("img") && (e.img = e.img.clone()), 0 < (n = e.img[0]).naturalWidth ? e.hasSize = !0 : n.width || (e.hasSize = !1)), f._parseMarkup(t, {
                    title: function(e) {
                        if (e.data && void 0 !== e.data.title) return e.data.title;
                        var t = f.st.image.titleSrc;
                        if (t) {
                            if (c.isFunction(t)) return t.call(f, e);
                            if (e.el) return e.el.attr(t) || ""
                        }
                        return ""
                    }(e),
                    img_replaceWith: e.img
                }, e), f.resizeImage(), e.hasSize ? (E && clearInterval(E), e.loadError ? (t.addClass("mfp-loading"), f.updateStatus("error", r.tError.replace("%url%", e.src))) : (t.removeClass("mfp-loading"), f.updateStatus("ready"))) : (f.updateStatus("loading"), e.loading = !0, e.hasSize || (e.imgHidden = !0, t.addClass("mfp-loading"), f.findImageSize(e))), t
            }
        }
    });

    function D(e) {
        var t;
        f.currTemplate[P] && (t = f.currTemplate[P].find("iframe")).length && (e || (t[0].src = "//about:blank"), f.isIE8 && t.css("display", e ? "block" : "none"))
    }

    function I(e) {
        var t = f.items.length;
        return t - 1 < e ? e - t : e < 0 ? t + e : e
    }

    function q(e, t, i) {
        return e.replace(/%curr%/gi, t + 1).replace(/%total%/gi, i)
    }
    c.magnificPopup.registerModule("zoom", {
        options: {
            enabled: !1,
            easing: "ease-in-out",
            duration: 300,
            opener: function(e) {
                return e.is("img") ? e : e.find("img")
            }
        },
        proto: {
            initZoom: function() {
                var e, t, i, o, n, s, r = f.st.zoom,
                    a = ".zoom";
                r.enabled && f.supportsTransition && (t = r.duration, i = function(e) {
                    var e = e.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),
                        t = "all " + r.duration / 1e3 + "s " + r.easing,
                        i = {
                            position: "fixed",
                            zIndex: 9999,
                            left: 0,
                            top: 0,
                            "-webkit-backface-visibility": "hidden"
                        },
                        o = "transition";
                    return i["-webkit-" + o] = i["-moz-" + o] = i["-o-" + o] = i[o] = t, e.css(i), e
                }, o = function() {
                    f.content.css("visibility", "visible")
                }, d("BuildControls" + a, function() {
                    f._allowZoom() && (clearTimeout(n), f.content.css("visibility", "hidden"), (e = f._getItemToZoom()) ? ((s = i(e)).css(f._getOffset()), f.wrap.append(s), n = setTimeout(function() {
                        s.css(f._getOffset(!0)), n = setTimeout(function() {
                            o(), setTimeout(function() {
                                s.remove(), e = s = null, p("ZoomAnimationEnded")
                            }, 16)
                        }, t)
                    }, 16)) : o())
                }), d(j + a, function() {
                    if (f._allowZoom()) {
                        if (clearTimeout(n), f.st.removalDelay = t, !e) {
                            if (!(e = f._getItemToZoom())) return;
                            s = i(e)
                        }
                        s.css(f._getOffset(!0)), f.wrap.append(s), f.content.css("visibility", "hidden"), setTimeout(function() {
                            s.css(f._getOffset())
                        }, 16)
                    }
                }), d(b + a, function() {
                    f._allowZoom() && (o(), s && s.remove(), e = null)
                }))
            },
            _allowZoom: function() {
                return "image" === f.currItem.type
            },
            _getItemToZoom: function() {
                return !!f.currItem.hasSize && f.currItem.img
            },
            _getOffset: function(e) {
                var e = e ? f.currItem.img : f.st.zoom.opener(f.currItem.el || f.currItem),
                    t = e.offset(),
                    i = parseInt(e.css("padding-top"), 10),
                    o = parseInt(e.css("padding-bottom"), 10),
                    e = (t.top -= c(window).scrollTop() - i, {
                        width: e.width(),
                        height: (x ? e.innerHeight() : e[0].offsetHeight) - o - i
                    });
                return (L = void 0 === L ? void 0 !== document.createElement("p").style.MozTransform : L) ? e["-moz-transform"] = e.transform = "translate(" + t.left + "px," + t.top + "px)" : (e.left = t.left, e.top = t.top), e
            }
        }
    });
    var L, P = "iframe",
        z = (c.magnificPopup.registerModule(P, {
            options: {
                markup: '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',
                srcAction: "iframe_src",
                patterns: {
                    youtube: {
                        index: "youtube.com",
                        id: "v=",
                        src: "//www.youtube.com/embed/%id%?autoplay=1"
                    },
                    vimeo: {
                        index: "vimeo.com/",
                        id: "/",
                        src: "//player.vimeo.com/video/%id%?autoplay=1"
                    },
                    gmaps: {
                        index: "//maps.google.",
                        src: "%id%&output=embed"
                    }
                }
            },
            proto: {
                initIframe: function() {
                    f.types.push(P), d("BeforeChange", function(e, t, i) {
                        t !== i && (t === P ? D() : i === P && D(!0))
                    }), d(b + "." + P, function() {
                        D()
                    })
                },
                getIframe: function(e, t) {
                    var i = e.src,
                        o = f.st.iframe,
                        n = (c.each(o.patterns, function() {
                            if (-1 < i.indexOf(this.index)) return this.id && (i = "string" == typeof this.id ? i.substr(i.lastIndexOf(this.id) + this.id.length, i.length) : this.id.call(this, i)), i = this.src.replace("%id%", i), !1
                        }), {});
                    return o.srcAction && (n[o.srcAction] = i), f._parseMarkup(t, n, e), f.updateStatus("ready"), t
                }
            }
        }), c.magnificPopup.registerModule("gallery", {
            options: {
                enabled: !1,
                arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
                preload: [0, 2],
                navigateByImgClick: !0,
                arrows: !0,
                tPrev: "Previous (Left arrow key)",
                tNext: "Next (Right arrow key)",
                tCounter: "%curr% of %total%"
            },
            proto: {
                initGallery: function() {
                    var s = f.st.gallery,
                        e = ".mfp-gallery";
                    if (f.direction = !0, !s || !s.enabled) return !1;
                    g += " mfp-gallery", d(C + e, function() {
                        s.navigateByImgClick && f.wrap.on("click" + e, ".mfp-img", function() {
                            if (1 < f.items.length) return f.next(), !1
                        }), m.on("keydown" + e, function(e) {
                            37 === e.keyCode ? f.prev() : 39 === e.keyCode && f.next()
                        })
                    }), d("UpdateStatus" + e, function(e, t) {
                        t.text && (t.text = q(t.text, f.currItem.index, f.items.length))
                    }), d(k + e, function(e, t, i, o) {
                        var n = f.items.length;
                        i.counter = 1 < n ? q(s.tCounter, o.index, n) : ""
                    }), d("BuildControls" + e, function() {
                        var e, t;
                        1 < f.items.length && s.arrows && !f.arrowLeft && (t = s.arrowMarkup, e = f.arrowLeft = c(t.replace(/%title%/gi, s.tPrev).replace(/%dir%/gi, "left")).addClass(T), t = f.arrowRight = c(t.replace(/%title%/gi, s.tNext).replace(/%dir%/gi, "right")).addClass(T), e.click(function() {
                            f.prev()
                        }), t.click(function() {
                            f.next()
                        }), f.container.append(e.add(t)))
                    }), d("Change" + e, function() {
                        f._preloadTimeout && clearTimeout(f._preloadTimeout), f._preloadTimeout = setTimeout(function() {
                            f.preloadNearbyImages(), f._preloadTimeout = null
                        }, 16)
                    }), d(b + e, function() {
                        m.off(e), f.wrap.off("click" + e), f.arrowRight = f.arrowLeft = null
                    })
                },
                next: function() {
                    f.direction = !0, f.index = I(f.index + 1), f.updateItemHTML()
                },
                prev: function() {
                    f.direction = !1, f.index = I(f.index - 1), f.updateItemHTML()
                },
                goTo: function(e) {
                    f.direction = e >= f.index, f.index = e, f.updateItemHTML()
                },
                preloadNearbyImages: function() {
                    for (var e = f.st.gallery.preload, t = Math.min(e[0], f.items.length), i = Math.min(e[1], f.items.length), o = 1; o <= (f.direction ? i : t); o++) f._preloadItem(f.index + o);
                    for (o = 1; o <= (f.direction ? t : i); o++) f._preloadItem(f.index - o)
                },
                _preloadItem: function(e) {
                    var t;
                    e = I(e), f.items[e].preloaded || ((t = f.items[e]).parsed || (t = f.parseEl(e)), p("LazyLoad", t), "image" === t.type && (t.img = c('<img class="mfp-img" />').on("load.mfploader", function() {
                        t.hasSize = !0
                    }).on("error.mfploader", function() {
                        t.hasSize = !0, t.loadError = !0, p("LazyLoadError", t)
                    }).attr("src", t.src)), t.preloaded = !0)
                }
            }
        }), "retina");
    c.magnificPopup.registerModule(z, {
        options: {
            replaceSrc: function(e) {
                return e.src.replace(/\.\w+$/, function(e) {
                    return "@2x" + e
                })
            },
            ratio: 1
        },
        proto: {
            initRetina: function() {
                var i, o;
                1 < window.devicePixelRatio && (i = f.st.retina, o = i.ratio, 1 < (o = isNaN(o) ? o() : o) && (d("ImageHasSize." + z, function(e, t) {
                    t.img.css({
                        "max-width": t.img[0].naturalWidth / o,
                        width: "100%"
                    })
                }), d("ElementParse." + z, function(e, t) {
                    t.src = i.replaceSrc(t, o)
                })))
            }
        }
    }), s()
}),
function(a) {
    a(document).ready(function() {
        if (l(), c(), a("section.product-related").length) {
            let e = document.getElementById("container");
            gsap.to(e, {
                x: () => -(e.scrollWidth - document.documentElement.clientWidth) + "px",
                ease: "none",
                scrollTrigger: {
                    trigger: e,
                    invalidateOnRefresh: !0,
                    pin: !0,
                    scrub: .2,
                    start: "top top",
                    end: () => "+=" + (e.scrollWidth - document.documentElement.clientWidth)
                }
            })
        }
        a(".banner-slide-container").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: !0,
            arrows: !1,
            dots: !0
        }), a(".reviews-slider").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: !0,
            arrows: !0,
            dots: !0
        }), a(".collection-slider").slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: !0,
            arrows: !0,
            dots: !1,
            responsive: [{
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3
                }
            }, {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 2
                }
            }, {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1
                }
            }]
        }), a(".collection-slider").on("beforeChange", function(e, t, i, o) {
            a(".collection-slider").addClass("clicked"), a(".collection-slider .slick-slide").addClass("first-click"), a(".collection-slider button.slick-prev").addClass("active")
        }), a(".partner-slider").slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: !0,
            arrows: !0,
            dots: !1,
            responsive: [{
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2
                }
            }, {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1
                }
            }]
        }), a(".partner-slider").on("beforeChange", function(e, t, i, o) {
            a(".partner-slider").addClass("clicked"), a(".partner-slider .slick-slide").addClass("first-click"), a(".partner-slider button.slick-prev").addClass("active")
        }), a(".team-slider").slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: !0,
            arrows: !0,
            dots: !1,
            responsive: [{
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2
                }
            }, {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1
                }
            }]
        }), a(".team-slider").on("beforeChange", function(e, t, i, o) {
            a(".team-slider").addClass("clicked"), a(".team-slider .slick-slide").addClass("first-click"), a(".team-slider button.slick-prev").addClass("active")
        }), a(".product-slider").slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: !0,
            arrows: !0,
            dots: !1,
            responsive: [{
                breakpoint: 1400,
                settings: {
                    slidesToShow: 3
                }
            }, {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 2
                }
            }, {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1
                }
            }]
        }), a(".product-slider").on("beforeChange", function(e, t, i, o) {
            a(".product-slider").addClass("clicked"), a(".product-slider .slick-slide").addClass("first-click"), a(".product-slider button.slick-prev").addClass("active")
        }), a(".product__media-gallery .slider-buttons .slider-button--prev").on("click", function(e) {
            750 <= a(window).width() && a(".thumbnail[aria-current]").parents("li").prevAll("li:visible:first").children(".thumbnail").trigger("click")
        }), a(".product__media-gallery .slider-buttons .slider-button--next").on("click", function(e) {
            750 <= a(window).width() && a(".thumbnail[aria-current]").parents("li").nextAll("li:visible:first").children(".thumbnail").trigger("click")
        }), a(document).on("change", "fieldset.Size input[type=radio]", function() {
            0 == ($checkedVal = a("input[name='Size']:checked").val()).indexOf("1kg") ? (a("input[name='Grind'][value='Wholebeans']").length && a("input[name='Grind'][value='Wholebeans']").trigger("click"), a("input[name='Grind'][value='Whole Beans']").length && a("input[name='Grind'][value='Whole Beans']").trigger("click"), a("fieldset.Grind").hide()) : a("fieldset.Grind").show()
        }), a(".variant-products").length && a(document).on("change", ".variant-products fieldset.Blend input[type=radio]", function() {
            $checkedValVariant = a(this).val(), console.log($checkedValVariant), "Belaroma No 25" === $checkedValVariant && a("input[name='Size'][value='1kg']").trigger("click")
        }), a(".reset-form-trigger").on("click", function(e) {
            e.preventDefault(), a(this).hasClass("active") ? (a(this).removeClass("active"), a(".reset-form-inner").slideUp(300)) : (a(this).addClass("active"), a(".reset-form-inner").slideDown(300))
        });
        var t, i = "",
            o = "",
            n = "",
            s = "",
            e = (a(".guided-search-button").on("click", function(e) {
                e.preventDefault(), a(".blend-finder-search").addClass("active")
            }), a('a[href="#guidedSearch"]').each(function(e) {
                a(this).on("click", function(e) {
                    e.preventDefault(), a(".blend-finder-search").addClass("active")
                })
            }), a('a[href="#blendFinder"]').each(function(e) {
                a(this).on("click", function(e) {
                    e.preventDefault(), a(".blend-finder-search").addClass("active")
                })
            }), a(".blend-finder-close").on("click", function(e) {
                e.preventDefault(), a(".blend-finder-search").removeClass("active"), a(".question-card").removeClass("active"), a(".finder-card").removeClass("active"), a(".blend-finder-title-card").addClass("active")
            }), a(".get-started-button").on("click", function(e) {
                e.preventDefault(), a(".blend-finder-title-card").removeClass("active"), a(".question-card.first-card").addClass("active")
            }), a(".button-wrapper input[type=radio]").change(function(e) {
                a(this).parent(".button-wrapper").siblings(".continue-button").removeClass("disabled")
            }), a(".continue-button").on("click", function(e) {
                e.preventDefault(), a(this).hasClass("question-one-button") && (i = a(this).siblings(".button-wrapper").children("input[name='question_one']:checked").val(), a(this).parent(".button-column").parents(".card-inner").parents(".question-card").removeClass("active"), (a(this).siblings(".button-wrapper").children("input[name='question_one']:checked").hasClass("pod") ? a(".finder-card.fourth-card") : a(this).parent(".button-column").parents(".card-inner").parents(".question-card").next(".finder-card")).addClass("active")), a(this).hasClass("question-two-button") && (o = a(this).siblings(".button-wrapper").children("input[name='question_two']:checked").val(), a(this).parent(".button-column").parents(".card-inner").parents(".question-card").removeClass("active"), a(this).parent(".button-column").parents(".card-inner").parents(".question-card").next(".finder-card").addClass("active")), a(this).hasClass("question-three-button") && (n = a(this).siblings(".button-wrapper").children("input[name='question_three']:checked").val(), a(this).parent(".button-column").parents(".card-inner").parents(".question-card").removeClass("active"), a(this).parent(".button-column").parents(".card-inner").parents(".question-card").next(".finder-card").addClass("active")), a(this).hasClass("question-four-button") && (1 == ($rangeVal = document.getElementById("question_four").value) && (s = "&filter.p.m.roast.type=mild-1"), 2 == $rangeVal && (s = "&filter.p.m.roast.type=mild-2"), 3 == $rangeVal && (s = "&filter.p.m.roast.type=balanced"), 4 == $rangeVal && (s = "&filter.p.m.roast.type=punchy-1"), 5 == $rangeVal && (s = "&filter.p.m.roast.type=punchy-2"), a(this).parent(".button-column").parents(".card-inner").parents(".question-card").removeClass("active"), a(this).parent(".button-column").parents(".card-inner").parents(".question-card").next(".finder-card").addClass("active"), setTimeout(function() {
                    window.location.href = "/collections/blend-finder" + i + o + n + s
                }, 3e3))
            }), document.createElement("style")),
            r = a(".range input");
        document.body.appendChild(e), r.on("input", function() {
            e.textContent = function(e) {
                e = e.value, a(".range-labels li").removeClass("active selected"), e = a(".range-labels").find("li:nth-child(" + e + ")");
                return e.addClass("active selected"), e.prevAll().addClass("selected"), ""
            }(this)
        }), a(".range-labels li").on("click", function() {
            var e = a(this).index();
            r.val(e + 1).trigger("input")
        }), a(".question-card .back").on("click", function(e) {
            e.preventDefault(), a(this).parent(".question-card").removeClass("active"), a(this).parent(".question-card").prev(".finder-card").addClass("active")
        }), a(".form-popup").magnificPopup({
            mainClass: "mfp-popup-form",
            removalDelay: 160,
            preloader: !1
        }), a(".video-button").magnificPopup({
            type: "iframe",
            mainClass: "mfp-video",
            removalDelay: 160,
            preloader: !1,
            fixedContentPos: !1,
            iframe: {
                patterns: {
                    youtube: {
                        index: "youtube.com",
                        id: "v=",
                        src: "https://www.youtube.com/embed/%id%?rel=0&autoplay=1"
                    }
                },
                markup: '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe><div class="mfp-title"></div></div>'
            },
            callbacks: {
                markupParse: function(e, t, i) {
                    t.title = i.el.attr("title")
                }
            }
        }), a(".recipe-switch-title-container .recipe-switch").on("click", function(e) {
            e.preventDefault(), $thisIndex = a(this).index(), a(this).hasClass("active") || (a(this).siblings().removeClass("active"), a(this).addClass("active"), a(".recipe-switch-container .recipe").removeClass("active"), a(".recipe-switch-container .recipe").eq($thisIndex).addClass("active"))
        }), a(".filter-trigger-container a.filter-dropdown-button").on("click", function(e) {
            e.preventDefault(), a(this).hasClass("active") ? (a(this).parent().parent(".filter-trigger-container").next().slideUp(500), a(this).removeClass("active")) : (a(this).parent().parent(".filter-trigger-container").next().slideDown(500), a(this).addClass("active"))
        }), a(".accordion-title").on("click", function(e) {
            e.preventDefault(), a(this).hasClass("open") ? (a(this).parent(".faq").removeClass("open"), a(this).next().slideUp(500), a(this).removeClass("open")) : (a(this).next().slideDown(500), a(this).parent(".faq").addClass("open"), a(this).addClass("open"))
        });
        a(".mobile-tag-trigger").on("click", function(e) {
            e.preventDefault(), a(this).hasClass("open") ? (a(this).parent(".tag-container").removeClass("open"), a(this).next().slideUp(500), a(this).removeClass("open")) : (a(this).next().slideDown(500), a(this).parent(".tag-container").addClass("open"), a(this).addClass("open"))
        }), a(window).width() <= 767 && a(".product-filter-container .column-title").on("click", function(e) {
            e.preventDefault(), a(this).hasClass("open") ? (a(this).parent(".column").removeClass("open"), a(this).next().slideUp(500), a(this).removeClass("open")) : (a(this).next().slideDown(500), a(this).parent(".column").addClass("open"), a(this).addClass("open"))
        }), a("header a.menu-toggle").on("click", function(e) {
            e.preventDefault(), a(this).addClass("active"), a("header .mobile-menu").addClass("active"), a("body").addClass("menu-open"), a("#shopify-section-header").removeClass("scrolledUp")
        }), a("header a.menu-close").on("click", function(e) {
            e.preventDefault(), a(this).removeClass("active"), a("header .mobile-menu").removeClass("active"), a("body").removeClass("menu-open")
        }), a("a.shop-menu").on("click", function(e) {
            a(".dropdown").removeClass("active"), a("header").removeClass("dark-header"), a(".mega-menu.about-mega-menu").removeClass("active"), a(".mega-menu.learn-mega-menu").removeClass("active"), a(".mega-menu.wholesale-mega-menu").removeClass("active"), a(".mega-menu.location-mega-menu").removeClass("active"), a(".mega-menu.shop-mega-menu").removeClass("active"), e.preventDefault(), a(this).hasClass("active") ? (a(this).removeClass("active"), a(".header").removeClass("shop-menu"), a(".shop-mega-menu").removeClass("active"), a(".click-outside").removeClass("active")) : (a(".click-outside").addClass("active"), a(this).addClass("active"), a(".header").addClass("shop-menu"), a(".shop-mega-menu").addClass("active"))
        }), a("a.shop-menu").on("mouseover", function(e) {
            1024 <= a(window).width() && (clearTimeout(t), a(".dropdown").removeClass("active"), a("header").removeClass("dark-header"), a(".mega-menu.about-mega-menu").removeClass("active"), a(".mega-menu.learn-mega-menu").removeClass("active"), a(".mega-menu.wholesale-mega-menu").removeClass("active"), a(".mega-menu.location-mega-menu").removeClass("active"), a(this).addClass("active"), a(".header").addClass("shop-menu"), a(".shop-mega-menu").addClass("active"), a(".click-outside").addClass("active"))
        }), a("a.shop-menu").on("mouseout", function(e) {
            1024 <= a(window).width() && (t = setTimeout(function() {
                a(this).removeClass("active"), a(".header").removeClass("shop-menu"), a(".shop-mega-menu").removeClass("active"), a(".click-outside").removeClass("active")
            }, 500))
        }), a(".shop-mega-menu").on("mouseover", function(e) {
            1024 <= a(window).width() && clearTimeout(t)
        }), a(".shop-mega-menu").on("mouseout", function(e) {
            1024 <= a(window).width() && (t = setTimeout(function() {
                a(".shop-mega-menu").removeClass("active"), a(".header").removeClass("shop-menu"), a("a.shop-menu").removeClass("active"), a(".click-outside").removeClass("active")
            }, 500))
        }), a(".click-outside").on("click", function(e) {
            a(".dropdown").removeClass("active"), a("header").removeClass("dark-header"), a(".mega-menu.about-mega-menu").removeClass("active"), a(".mega-menu.learn-mega-menu").removeClass("active"), a(".mega-menu.wholesale-mega-menu").removeClass("active"), a(".mega-menu.location-mega-menu").removeClass("active"), a(".mega-menu.shop-mega-menu").removeClass("active"), a(".header").removeClass("shop-menu"), a(".shop-mega-menu").removeClass("active"), a(".click-outside").removeClass("active")
        }), a(".scroll-to-link").on("click", function(e) {
            e.preventDefault(), $section = a(this).attr("href"), 900 < a(window).width() ? a("html, body").animate({
                scrollTop: a($section).offset().top - 80
            }, 1e3) : a("html, body").animate({
                scrollTop: a($section).offset().top - 60
            }, 1e3)
        }), a(".dropdown").on("click", function(e) {
            e.preventDefault(), a(this).hasClass("active") ? (a(".mega-menu").removeClass("active"), a(".dropdown").removeClass("active"), a("a.shop-menu").removeClass("active"), a("header").removeClass("dark-header"), a(".click-outside").removeClass("active")) : (a(".click-outside").addClass("active"), a(this).hasClass("about") && (a("header").addClass("dark-header"), a("a.shop-menu").removeClass("active"), a(this).parents("li").siblings().children(".dropdown").removeClass("active"), a(this).addClass("active"), a(".mega-menu.about-mega-menu").addClass("active"), a(".mega-menu.learn-mega-menu").removeClass("active"), a(".mega-menu.wholesale-mega-menu").removeClass("active"), a(".mega-menu.location-mega-menu").removeClass("active"), a(".mega-menu.shop-mega-menu").removeClass("active")), a(this).hasClass("learn") && (a("header").addClass("dark-header"), a("a.shop-menu").removeClass("active"), a(this).parents("li").siblings().children(".dropdown").removeClass("active"), a(this).addClass("active"), a(".mega-menu.learn-mega-menu").addClass("active"), a(".mega-menu.about-mega-menu").removeClass("active"), a(".mega-menu.wholesale-mega-menu").removeClass("active"), a(".mega-menu.location-mega-menu").removeClass("active"), a(".mega-menu.shop-mega-menu").removeClass("active")), a(this).hasClass("wholesale") && (a("header").addClass("dark-header"), a("a.shop-menu").removeClass("active"), a(this).parents("li").siblings().children(".dropdown").removeClass("active"), a(this).addClass("active"), a(".mega-menu.wholesale-mega-menu").addClass("active"), a(".mega-menu.about-mega-menu").removeClass("active"), a(".mega-menu.learn-mega-menu").removeClass("active"), a(".mega-menu.location-mega-menu").removeClass("active"), a(".mega-menu.shop-mega-menu").removeClass("active")), a(this).hasClass("find-us") && (a("header").addClass("dark-header"), a("a.shop-menu").removeClass("active"), a(this).parents("li").siblings().children(".dropdown").removeClass("active"), a(this).addClass("active"), a(".mega-menu.location-mega-menu").addClass("active"), a(".mega-menu.about-mega-menu").removeClass("active"), a(".mega-menu.wholesale-mega-menu").removeClass("active"), a(".mega-menu.learn-mega-menu").removeClass("active"), a(".mega-menu.shop-mega-menu").removeClass("active")))
        }), a(".grind-popup").magnificPopup({
            mainClass: "mfp-grind-info"
        }), a("a.close-popup").on("click", function(e) {
            e.preventDefault(), a.magnificPopup.close()
        }), a(".product-slider .slider").slick({
            arrows: !0,
            dots: !0,
            autoplay: !0,
            autoplaySpeed: 8e3,
            slidesToShow: 1,
            responsive: [{
                breakpoint: 1023,
                settings: {
                    arrows: !1,
                    slidesToShow: 1
                }
            }]
        }), a(".product-gallery-slider").slick({
            arrows: !0,
            dots: !0,
            autoplay: !1,
            autoplaySpeed: 8e3,
            slidesToShow: 1
        })
    });
    var t = 0;

    function l() {
        a("select").not(".address-select,.loop-selling-plan-selector,.globo-form-input select").select2({
            minimumResultsForSearch: -1
        })
    }

    function c() {
        AOS.init({
            disable: "mobile",
            once: !0
        })
    }
    a(window).on("scroll", function() {
        var e = a(this).scrollTop();
        !(t <= e) && 200 <= e ? a("#shopify-section-header").addClass("scrolledUp") : a("#shopify-section-header").removeClass("scrolledUp"), t = e, a(".animated-packs").each(function() {
            var e, t;
            e = (e = this).getBoundingClientRect(), t = e.top, e = e.bottom, t < window.innerHeight && 0 <= e ? a(this).children(".moving-images-container").children(".moving-packets-container").addClass("visible") : a(this).children(".moving-images-container").children(".moving-packets-container").removeClass("visible")
        }), 990 <= a(window).width() && a(".mega-menu").hasClass("active") && (a(".dropdown").removeClass("active"), a("header").removeClass("dark-header"), a(".mega-menu.about-mega-menu").removeClass("active"), a(".mega-menu.learn-mega-menu").removeClass("active"), a(".mega-menu.wholesale-mega-menu").removeClass("active"), a(".mega-menu.location-mega-menu").removeClass("active"), a(".mega-menu.shop-mega-menu").removeClass("active"), a(".header").removeClass("shop-menu"), a(".shop-mega-menu").removeClass("active"), a(".click-outside").removeClass("active"))
    }), a(window).on("load", function() {
        c(), l(), a(".accordion-container").length && 767 <= a(window).width() && a(".accordion-container").hasClass("first-open") && (a(".accordion-container").children(".accordion-content-container:first-child").children(".accordion-title").addClass("open"), a(".accordion-container").children(".accordion-content-container:first-child").children(".faq").addClass("open"), a(".accordion-container").children(".accordion-content-container:first-child").children(".accordion-title").next().show()), -1 < window.location.href.indexOf("#blendfinder") && a(".blend-finder-search").addClass("active")
    })
}(window.jQuery),
function(i) {
    "function" == typeof define && define.amd ? define(["jquery"], i) : "object" == typeof module && module.exports ? module.exports = function(e, t) {
        return void 0 === t && (t = "undefined" != typeof window ? require("jquery") : require("jquery")(e)), i(t), t
    } : i(jQuery)
}(function(t) {
    (e = t && t.fn && t.fn.select2 && t.fn.select2.amd ? t.fn.select2.amd : e) && e.requirejs || (e ? i = e : e = {}, m = {}, g = {}, v = {}, y = {}, o = Object.prototype.hasOwnProperty, n = [].slice, w = /\.js$/, h = function(e, t) {
        var i, o, n = c(e),
            s = n[0],
            t = t[1];
        return e = n[1], s && (i = C(s = l(s, t))), s ? e = i && i.normalize ? i.normalize(e, (o = t, function(e) {
            return l(e, o)
        })) : l(e, t) : (s = (n = c(e = l(e, t)))[0], e = n[1], s && (i = C(s))), {
            f: s ? s + "!" + e : e,
            n: e,
            pr: s,
            p: i
        }
    }, f = {
        require: function(e) {
            return k(e)
        },
        exports: function(e) {
            var t = m[e];
            return void 0 !== t ? t : m[e] = {}
        },
        module: function(e) {
            return {
                id: e,
                uri: "",
                exports: m[e],
                config: (t = e, function() {
                    return v && v.config && v.config[t] || {}
                })
            };
            var t
        }
    }, s = function(e, t, i, o) {
        var n, s, r, a, l, c = [],
            d = typeof i,
            u = S(o = o || e);
        if ("undefined" == d || "function" == d) {
            for (t = !t.length && i.length ? ["require", "exports", "module"] : t, a = 0; a < t.length; a += 1)
                if ("require" === (s = (r = h(t[a], u)).f)) c[a] = f.require(e);
                else if ("exports" === s) c[a] = f.exports(e), l = !0;
            else if ("module" === s) n = c[a] = f.module(e);
            else if (b(m, s) || b(g, s) || b(y, s)) c[a] = C(s);
            else {
                if (!r.p) throw new Error(e + " missing " + s);
                r.p.load(r.n, k(o, !0), function(t) {
                    return function(e) {
                        m[t] = e
                    }
                }(s), {}), c[a] = m[s]
            }
            d = i ? i.apply(m[e], c) : void 0, e && (n && n.exports !== p && n.exports !== m[e] ? m[e] = n.exports : d === p && l || (m[e] = d))
        } else e && (m[e] = i)
    }, a = i = r = function(e, t, i, o, n) {
        if ("string" == typeof e) return f[e] ? f[e](t) : C(h(e, S(t)).f);
        if (!e.splice) {
            if ((v = e).deps && r(v.deps, v.callback), !t) return;
            t.splice ? (e = t, t = i, i = null) : e = p
        }
        return t = t || function() {}, "function" == typeof i && (i = o, o = n), o ? s(p, e, t, i) : setTimeout(function() {
            s(p, e, t, i)
        }, 4), r
    }, r.config = function(e) {
        return r(e)
    }, a._defined = m, (d = function(e, t, i) {
        if ("string" != typeof e) throw new Error("See almond README: incorrect module build, no module name");
        t.splice || (i = t, t = []), b(m, e) || b(g, e) || (g[e] = [e, t, i])
    }).amd = {
        jQuery: !0
    }, e.requirejs = a, e.require = i, e.define = d), e.define("almond", function() {}), e.define("jquery", [], function() {
        var e = t || $;
        return null == e && console && console.error && console.error("Select2: An instance of jQuery or a jQuery-compatible library was not found. Make sure that you are including jQuery before Select2 on your web page."), e
    }), e.define("select2/utils", ["jquery"], function(s) {
        var o = {};

        function c(e) {
            var t, i = e.prototype,
                o = [];
            for (t in i) "function" == typeof i[t] && "constructor" !== t && o.push(t);
            return o
        }
        o.Extend = function(e, t) {
            var i, o = {}.hasOwnProperty;

            function n() {
                this.constructor = e
            }
            for (i in t) o.call(t, i) && (e[i] = t[i]);
            return n.prototype = t.prototype, e.prototype = new n, e.__super__ = t.prototype, e
        }, o.Decorate = function(o, n) {
            var e = c(n),
                t = c(o);

            function s() {
                var e = Array.prototype.unshift,
                    t = n.prototype.constructor.length,
                    i = o.prototype.constructor;
                0 < t && (e.call(arguments, o.prototype.constructor), i = n.prototype.constructor), i.apply(this, arguments)
            }
            n.displayName = o.displayName, s.prototype = new function() {
                this.constructor = s
            };
            for (var i = 0; i < t.length; i++) {
                var r = t[i];
                s.prototype[r] = o.prototype[r]
            }
            for (var a = 0; a < e.length; a++) {
                var l = e[a];
                s.prototype[l] = function(e) {
                    var t = function() {},
                        i = (e in s.prototype && (t = s.prototype[e]), n.prototype[e]);
                    return function() {
                        return Array.prototype.unshift.call(arguments, t), i.apply(this, arguments)
                    }
                }(l)
            }
            return s
        };

        function e() {
            this.listeners = {}
        }
        e.prototype.on = function(e, t) {
            this.listeners = this.listeners || {}, e in this.listeners ? this.listeners[e].push(t) : this.listeners[e] = [t]
        }, e.prototype.trigger = function(e) {
            var t = Array.prototype.slice,
                i = t.call(arguments, 1);
            this.listeners = this.listeners || {}, 0 === (i = null == i ? [] : i).length && i.push({}), (i[0]._type = e) in this.listeners && this.invoke(this.listeners[e], t.call(arguments, 1)), "*" in this.listeners && this.invoke(this.listeners["*"], arguments)
        }, e.prototype.invoke = function(e, t) {
            for (var i = 0, o = e.length; i < o; i++) e[i].apply(this, t)
        }, o.Observable = e, o.generateChars = function(e) {
            for (var t = "", i = 0; i < e; i++) t += Math.floor(36 * Math.random()).toString(36);
            return t
        }, o.bind = function(e, t) {
            return function() {
                e.apply(t, arguments)
            }
        }, o._convertData = function(e) {
            for (var t in e) {
                var i = t.split("-"),
                    o = e;
                if (1 !== i.length) {
                    for (var n = 0; n < i.length; n++) {
                        var s = i[n];
                        (s = s.substring(0, 1).toLowerCase() + s.substring(1)) in o || (o[s] = {}), n == i.length - 1 && (o[s] = e[t]), o = o[s]
                    }
                    delete e[t]
                }
            }
            return e
        }, o.hasScroll = function(e, t) {
            var i = s(t),
                o = t.style.overflowX,
                n = t.style.overflowY;
            return (o !== n || "hidden" !== n && "visible" !== n) && ("scroll" === o || "scroll" === n || (i.innerHeight() < t.scrollHeight || i.innerWidth() < t.scrollWidth))
        }, o.escapeMarkup = function(e) {
            var t = {
                "\\": "&#92;",
                "&": "&amp;",
                "<": "&lt;",
                ">": "&gt;",
                '"': "&quot;",
                "'": "&#39;",
                "/": "&#47;"
            };
            return "string" != typeof e ? e : String(e).replace(/[&<>"'\/\\]/g, function(e) {
                return t[e]
            })
        }, o.__cache = {};
        var i = 0;
        return o.GetUniqueElementId = function(e) {
            var t = e.getAttribute("data-select2-id");
            return null != t || (t = e.id ? "select2-data-" + e.id : "select2-data-" + (++i).toString() + "-" + o.generateChars(4), e.setAttribute("data-select2-id", t)), t
        }, o.StoreData = function(e, t, i) {
            e = o.GetUniqueElementId(e);
            o.__cache[e] || (o.__cache[e] = {}), o.__cache[e][t] = i
        }, o.GetData = function(e, t) {
            var i = o.GetUniqueElementId(e);
            return t ? o.__cache[i] && null != o.__cache[i][t] ? o.__cache[i][t] : s(e).data(t) : o.__cache[i]
        }, o.RemoveData = function(e) {
            var t = o.GetUniqueElementId(e);
            null != o.__cache[t] && delete o.__cache[t], e.removeAttribute("data-select2-id")
        }, o.copyNonInternalCssClasses = function(e, t) {
            var i = (i = e.getAttribute("class").trim().split(/\s+/)).filter(function(e) {
                    return 0 === e.indexOf("select2-")
                }),
                t = (t = t.getAttribute("class").trim().split(/\s+/)).filter(function(e) {
                    return 0 !== e.indexOf("select2-")
                }),
                i = i.concat(t);
            e.setAttribute("class", i.join(" "))
        }, o
    }), e.define("select2/results", ["jquery", "./utils"], function(u, p) {
        function o(e, t, i) {
            this.$element = e, this.data = i, this.options = t, o.__super__.constructor.call(this)
        }
        return p.Extend(o, p.Observable), o.prototype.render = function() {
            var e = u('<ul class="select2-results__options" role="listbox"></ul>');
            return this.options.get("multiple") && e.attr("aria-multiselectable", "true"), this.$results = e
        }, o.prototype.clear = function() {
            this.$results.empty()
        }, o.prototype.displayMessage = function(e) {
            var t = this.options.get("escapeMarkup"),
                i = (this.clear(), this.hideLoading(), u('<li role="alert" aria-live="assertive" class="select2-results__option"></li>')),
                o = this.options.get("translations").get(e.message);
            i.append(t(o(e.args))), i[0].className += " select2-results__message", this.$results.append(i)
        }, o.prototype.hideMessages = function() {
            this.$results.find(".select2-results__message").remove()
        }, o.prototype.append = function(e) {
            this.hideLoading();
            var t = [];
            if (null == e.results || 0 === e.results.length) 0 === this.$results.children().length && this.trigger("results:message", {
                message: "noResults"
            });
            else {
                e.results = this.sort(e.results);
                for (var i = 0; i < e.results.length; i++) {
                    var o = e.results[i],
                        o = this.option(o);
                    t.push(o)
                }
                this.$results.append(t)
            }
        }, o.prototype.position = function(e, t) {
            t.find(".select2-results").append(e)
        }, o.prototype.sort = function(e) {
            return this.options.get("sorter")(e)
        }, o.prototype.highlightFirstItem = function() {
            var e = this.$results.find(".select2-results__option--selectable"),
                t = e.filter(".select2-results__option--selected");
            (0 < t.length ? t : e).first().trigger("mouseenter"), this.ensureHighlightVisible()
        }, o.prototype.setClasses = function() {
            var t = this;
            this.data.current(function(e) {
                var o = e.map(function(e) {
                    return e.id.toString()
                });
                t.$results.find(".select2-results__option--selectable").each(function() {
                    var e = u(this),
                        t = p.GetData(this, "data"),
                        i = "" + t.id;
                    null != t.element && t.element.selected || null == t.element && -1 < o.indexOf(i) ? (this.classList.add("select2-results__option--selected"), e.attr("aria-selected", "true")) : (this.classList.remove("select2-results__option--selected"), e.attr("aria-selected", "false"))
                })
            })
        }, o.prototype.showLoading = function(e) {
            this.hideLoading();
            e = {
                disabled: !0,
                loading: !0,
                text: this.options.get("translations").get("searching")(e)
            }, e = this.option(e);
            e.className += " loading-results", this.$results.prepend(e)
        }, o.prototype.hideLoading = function() {
            this.$results.find(".loading-results").remove()
        }, o.prototype.option = function(e) {
            var t, i = document.createElement("li"),
                o = (i.classList.add("select2-results__option"), i.classList.add("select2-results__option--selectable"), {
                    role: "option"
                }),
                n = window.Element.prototype.matches || window.Element.prototype.msMatchesSelector || window.Element.prototype.webkitMatchesSelector;
            for (t in (null != e.element && n.call(e.element, ":disabled") || null == e.element && e.disabled) && (o["aria-disabled"] = "true", i.classList.remove("select2-results__option--selectable"), i.classList.add("select2-results__option--disabled")), null == e.id && i.classList.remove("select2-results__option--selectable"), null != e._resultId && (i.id = e._resultId), e.title && (i.title = e.title), e.children && (o.role = "group", o["aria-label"] = e.text, i.classList.remove("select2-results__option--selectable"), i.classList.add("select2-results__option--group")), o) {
                var s = o[t];
                i.setAttribute(t, s)
            }
            if (e.children) {
                for (var n = u(i), r = document.createElement("strong"), a = (r.className = "select2-results__group", this.template(e, r), []), l = 0; l < e.children.length; l++) {
                    var c = e.children[l],
                        c = this.option(c);
                    a.push(c)
                }
                var d = u("<ul></ul>", {
                    class: "select2-results__options select2-results__options--nested",
                    role: "none"
                });
                d.append(a), n.append(r), n.append(d)
            } else this.template(e, i);
            return p.StoreData(i, "data", e), i
        }, o.prototype.bind = function(t, e) {
            var n = this,
                i = t.id + "-results";
            this.$results.attr("id", i), t.on("results:all", function(e) {
                n.clear(), n.append(e.data), t.isOpen() && (n.setClasses(), n.highlightFirstItem())
            }), t.on("results:append", function(e) {
                n.append(e.data), t.isOpen() && n.setClasses()
            }), t.on("query", function(e) {
                n.hideMessages(), n.showLoading(e)
            }), t.on("select", function() {
                t.isOpen() && (n.setClasses(), n.options.get("scrollAfterSelect") && n.highlightFirstItem())
            }), t.on("unselect", function() {
                t.isOpen() && (n.setClasses(), n.options.get("scrollAfterSelect") && n.highlightFirstItem())
            }), t.on("open", function() {
                n.$results.attr("aria-expanded", "true"), n.$results.attr("aria-hidden", "false"), n.setClasses(), n.ensureHighlightVisible()
            }), t.on("close", function() {
                n.$results.attr("aria-expanded", "false"), n.$results.attr("aria-hidden", "true"), n.$results.removeAttr("aria-activedescendant")
            }), t.on("results:toggle", function() {
                var e = n.getHighlightedResults();
                0 !== e.length && e.trigger("mouseup")
            }), t.on("results:select", function() {
                var e, t = n.getHighlightedResults();
                0 !== t.length && (e = p.GetData(t[0], "data"), t.hasClass("select2-results__option--selected") ? n.trigger("close", {}) : n.trigger("select", {
                    data: e
                }))
            }), t.on("results:previous", function() {
                var e, t = n.getHighlightedResults(),
                    i = n.$results.find(".select2-results__option--selectable"),
                    o = i.index(t);
                o <= 0 || (o = o - 1, 0 === t.length && (o = 0), (t = i.eq(o)).trigger("mouseenter"), i = n.$results.offset().top, t = t.offset().top, e = n.$results.scrollTop() + (t - i), 0 === o ? n.$results.scrollTop(0) : t - i < 0 && n.$results.scrollTop(e))
            }), t.on("results:next", function() {
                var e, t, i = n.getHighlightedResults(),
                    o = n.$results.find(".select2-results__option--selectable"),
                    i = o.index(i) + 1;
                i >= o.length || ((o = o.eq(i)).trigger("mouseenter"), e = n.$results.offset().top + n.$results.outerHeight(!1), o = o.offset().top + o.outerHeight(!1), t = n.$results.scrollTop() + o - e, 0 === i ? n.$results.scrollTop(0) : e < o && n.$results.scrollTop(t))
            }), t.on("results:focus", function(e) {
                e.element[0].classList.add("select2-results__option--highlighted"), e.element[0].setAttribute("aria-selected", "true")
            }), t.on("results:message", function(e) {
                n.displayMessage(e)
            }), u.fn.mousewheel && this.$results.on("mousewheel", function(e) {
                var t = n.$results.scrollTop(),
                    i = n.$results.get(0).scrollHeight - t + e.deltaY,
                    t = 0 < e.deltaY && t - e.deltaY <= 0,
                    i = e.deltaY < 0 && i <= n.$results.height();
                t ? (n.$results.scrollTop(0), e.preventDefault(), e.stopPropagation()) : i && (n.$results.scrollTop(n.$results.get(0).scrollHeight - n.$results.height()), e.preventDefault(), e.stopPropagation())
            }), this.$results.on("mouseup", ".select2-results__option--selectable", function(e) {
                var t = u(this),
                    i = p.GetData(this, "data");
                t.hasClass("select2-results__option--selected") ? n.options.get("multiple") ? n.trigger("unselect", {
                    originalEvent: e,
                    data: i
                }) : n.trigger("close", {}) : n.trigger("select", {
                    originalEvent: e,
                    data: i
                })
            }), this.$results.on("mouseenter", ".select2-results__option--selectable", function(e) {
                var t = p.GetData(this, "data");
                n.getHighlightedResults().removeClass("select2-results__option--highlighted").attr("aria-selected", "false"), n.trigger("results:focus", {
                    data: t,
                    element: u(this)
                })
            })
        }, o.prototype.getHighlightedResults = function() {
            return this.$results.find(".select2-results__option--highlighted")
        }, o.prototype.destroy = function() {
            this.$results.remove()
        }, o.prototype.ensureHighlightVisible = function() {
            var e, t, i, o, n = this.getHighlightedResults();
            0 !== n.length && (e = this.$results.find(".select2-results__option--selectable").index(n), t = this.$results.offset().top, o = n.offset().top, i = this.$results.scrollTop() + (o - t), o = o - t, i -= 2 * n.outerHeight(!1), e <= 2 ? this.$results.scrollTop(0) : (o > this.$results.outerHeight() || o < 0) && this.$results.scrollTop(i))
        }, o.prototype.template = function(e, t) {
            var i = this.options.get("templateResult"),
                o = this.options.get("escapeMarkup"),
                i = i(e, t);
            null == i ? t.style.display = "none" : "string" == typeof i ? t.innerHTML = o(i) : u(t).append(i)
        }, o
    }), e.define("select2/keys", [], function() {
        return {
            BACKSPACE: 8,
            TAB: 9,
            ENTER: 13,
            SHIFT: 16,
            CTRL: 17,
            ALT: 18,
            ESC: 27,
            SPACE: 32,
            PAGE_UP: 33,
            PAGE_DOWN: 34,
            END: 35,
            HOME: 36,
            LEFT: 37,
            UP: 38,
            RIGHT: 39,
            DOWN: 40,
            DELETE: 46
        }
    }), e.define("select2/selection/base", ["jquery", "../utils", "../keys"], function(i, o, n) {
        function s(e, t) {
            this.$element = e, this.options = t, s.__super__.constructor.call(this)
        }
        return o.Extend(s, o.Observable), s.prototype.render = function() {
            var e = i('<span class="select2-selection" role="combobox"  aria-haspopup="true" aria-expanded="false"></span>');
            return this._tabindex = 0, null != o.GetData(this.$element[0], "old-tabindex") ? this._tabindex = o.GetData(this.$element[0], "old-tabindex") : null != this.$element.attr("tabindex") && (this._tabindex = this.$element.attr("tabindex")), e.attr("title", this.$element.attr("title")), e.attr("tabindex", this._tabindex), e.attr("aria-disabled", "false"), this.$selection = e
        }, s.prototype.bind = function(e, t) {
            var i = this,
                o = e.id + "-results";
            this.container = e, this.$selection.on("focus", function(e) {
                i.trigger("focus", e)
            }), this.$selection.on("blur", function(e) {
                i._handleBlur(e)
            }), this.$selection.on("keydown", function(e) {
                i.trigger("keypress", e), e.which === n.SPACE && e.preventDefault()
            }), e.on("results:focus", function(e) {
                i.$selection.attr("aria-activedescendant", e.data._resultId)
            }), e.on("selection:update", function(e) {
                i.update(e.data)
            }), e.on("open", function() {
                i.$selection.attr("aria-expanded", "true"), i.$selection.attr("aria-owns", o), i._attachCloseHandler(e)
            }), e.on("close", function() {
                i.$selection.attr("aria-expanded", "false"), i.$selection.removeAttr("aria-activedescendant"), i.$selection.removeAttr("aria-owns"), i.$selection.trigger("focus"), i._detachCloseHandler(e)
            }), e.on("enable", function() {
                i.$selection.attr("tabindex", i._tabindex), i.$selection.attr("aria-disabled", "false")
            }), e.on("disable", function() {
                i.$selection.attr("tabindex", "-1"), i.$selection.attr("aria-disabled", "true")
            })
        }, s.prototype._handleBlur = function(e) {
            var t = this;
            window.setTimeout(function() {
                document.activeElement == t.$selection[0] || i.contains(t.$selection[0], document.activeElement) || t.trigger("blur", e)
            }, 1)
        }, s.prototype._attachCloseHandler = function(e) {
            i(document.body).on("mousedown.select2." + e.id, function(e) {
                var t = i(e.target).closest(".select2");
                i(".select2.select2-container--open").each(function() {
                    this != t[0] && o.GetData(this, "element").select2("close")
                })
            })
        }, s.prototype._detachCloseHandler = function(e) {
            i(document.body).off("mousedown.select2." + e.id)
        }, s.prototype.position = function(e, t) {
            t.find(".selection").append(e)
        }, s.prototype.destroy = function() {
            this._detachCloseHandler(this.container)
        }, s.prototype.update = function(e) {
            throw new Error("The `update` method must be defined in child classes.")
        }, s.prototype.isEnabled = function() {
            return !this.isDisabled()
        }, s.prototype.isDisabled = function() {
            return this.options.get("disabled")
        }, s
    }), e.define("select2/selection/single", ["jquery", "./base", "../utils", "../keys"], function(e, t, i, o) {
        function n() {
            n.__super__.constructor.apply(this, arguments)
        }
        return i.Extend(n, t), n.prototype.render = function() {
            var e = n.__super__.render.call(this);
            return e[0].classList.add("select2-selection--single"), e.html('<span class="select2-selection__rendered"></span><span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span>'), e
        }, n.prototype.bind = function(t, e) {
            var i = this,
                o = (n.__super__.bind.apply(this, arguments), t.id + "-container");
            this.$selection.find(".select2-selection__rendered").attr("id", o).attr("role", "textbox").attr("aria-readonly", "true"), this.$selection.attr("aria-labelledby", o), this.$selection.attr("aria-controls", o), this.$selection.on("mousedown", function(e) {
                1 === e.which && i.trigger("toggle", {
                    originalEvent: e
                })
            }), this.$selection.on("focus", function(e) {}), this.$selection.on("blur", function(e) {}), t.on("focus", function(e) {
                t.isOpen() || i.$selection.trigger("focus")
            })
        }, n.prototype.clear = function() {
            var e = this.$selection.find(".select2-selection__rendered");
            e.empty(), e.removeAttr("title")
        }, n.prototype.display = function(e, t) {
            var i = this.options.get("templateSelection");
            return this.options.get("escapeMarkup")(i(e, t))
        }, n.prototype.selectionContainer = function() {
            return e("<span></span>")
        }, n.prototype.update = function(e) {
            var t, i;
            0 === e.length ? this.clear() : (e = e[0], t = this.$selection.find(".select2-selection__rendered"), i = this.display(e, t), t.empty().append(i), (i = e.title || e.text) ? t.attr("title", i) : t.removeAttr("title"))
        }, n
    }), e.define("select2/selection/multiple", ["jquery", "./base", "../utils"], function(n, e, c) {
        function s(e, t) {
            s.__super__.constructor.apply(this, arguments)
        }
        return c.Extend(s, e), s.prototype.render = function() {
            var e = s.__super__.render.call(this);
            return e[0].classList.add("select2-selection--multiple"), e.html('<ul class="select2-selection__rendered"></ul>'), e
        }, s.prototype.bind = function(e, t) {
            var i = this,
                o = (s.__super__.bind.apply(this, arguments), e.id + "-container");
            this.$selection.find(".select2-selection__rendered").attr("id", o), this.$selection.on("click", function(e) {
                i.trigger("toggle", {
                    originalEvent: e
                })
            }), this.$selection.on("click", ".select2-selection__choice__remove", function(e) {
                var t;
                i.isDisabled() || (t = n(this).parent(), t = c.GetData(t[0], "data"), i.trigger("unselect", {
                    originalEvent: e,
                    data: t
                }))
            }), this.$selection.on("keydown", ".select2-selection__choice__remove", function(e) {
                i.isDisabled() || e.stopPropagation()
            })
        }, s.prototype.clear = function() {
            var e = this.$selection.find(".select2-selection__rendered");
            e.empty(), e.removeAttr("title")
        }, s.prototype.display = function(e, t) {
            var i = this.options.get("templateSelection");
            return this.options.get("escapeMarkup")(i(e, t))
        }, s.prototype.selectionContainer = function() {
            return n('<li class="select2-selection__choice"><button type="button" class="select2-selection__choice__remove" tabindex="-1"><span aria-hidden="true">&times;</span></button><span class="select2-selection__choice__display"></span></li>')
        }, s.prototype.update = function(e) {
            if (this.clear(), 0 !== e.length) {
                for (var t = [], i = this.$selection.find(".select2-selection__rendered").attr("id") + "-choice-", o = 0; o < e.length; o++) {
                    var n = e[o],
                        s = this.selectionContainer(),
                        r = this.display(n, s),
                        a = i + c.generateChars(4) + "-",
                        r = (n.id ? a += n.id : a += c.generateChars(4), s.find(".select2-selection__choice__display").append(r).attr("id", a), n.title || n.text),
                        r = (r && s.attr("title", r), this.options.get("translations").get("removeItem")),
                        l = s.find(".select2-selection__choice__remove");
                    l.attr("title", r()), l.attr("aria-label", r()), l.attr("aria-describedby", a), c.StoreData(s[0], "data", n), t.push(s)
                }
                this.$selection.find(".select2-selection__rendered").append(t)
            }
        }, s
    }), e.define("select2/selection/placeholder", [], function() {
        function e(e, t, i) {
            this.placeholder = this.normalizePlaceholder(i.get("placeholder")), e.call(this, t, i)
        }
        return e.prototype.normalizePlaceholder = function(e, t) {
            return t = "string" == typeof t ? {
                id: "",
                text: t
            } : t
        }, e.prototype.createPlaceholder = function(e, t) {
            var i = this.selectionContainer(),
                t = (i.html(this.display(t)), i[0].classList.add("select2-selection__placeholder"), i[0].classList.remove("select2-selection__choice"), t.title || t.text || i.text());
            return this.$selection.find(".select2-selection__rendered").attr("title", t), i
        }, e.prototype.update = function(e, t) {
            var i = 1 == t.length && t[0].id != this.placeholder.id;
            if (1 < t.length || i) return e.call(this, t);
            this.clear();
            i = this.createPlaceholder(this.placeholder);
            this.$selection.find(".select2-selection__rendered").append(i)
        }, e
    }), e.define("select2/selection/allowClear", ["jquery", "../keys", "../utils"], function(n, o, a) {
        function e() {}
        return e.prototype.bind = function(e, t, i) {
            var o = this;
            e.call(this, t, i), null == this.placeholder && this.options.get("debug") && window.console && console.error && console.error("Select2: The `allowClear` option should be used in combination with the `placeholder` option."), this.$selection.on("mousedown", ".select2-selection__clear", function(e) {
                o._handleClear(e)
            }), t.on("keypress", function(e) {
                o._handleKeyboardClear(e, t)
            })
        }, e.prototype._handleClear = function(e, t) {
            if (!this.isDisabled()) {
                var i = this.$selection.find(".select2-selection__clear");
                if (0 !== i.length) {
                    t.stopPropagation();
                    var o = a.GetData(i[0], "data"),
                        n = this.$element.val(),
                        s = (this.$element.val(this.placeholder.id), {
                            data: o
                        });
                    if (this.trigger("clear", s), s.prevented) this.$element.val(n);
                    else {
                        for (var r = 0; r < o.length; r++)
                            if (s = {
                                    data: o[r]
                                }, this.trigger("unselect", s), s.prevented) return void this.$element.val(n);
                        this.$element.trigger("input").trigger("change"), this.trigger("toggle", {})
                    }
                }
            }
        }, e.prototype._handleKeyboardClear = function(e, t, i) {
            i.isOpen() || t.which != o.DELETE && t.which != o.BACKSPACE || this._handleClear(t)
        }, e.prototype.update = function(e, t) {
            var i, o;
            e.call(this, t), this.$selection.find(".select2-selection__clear").remove(), this.$selection[0].classList.remove("select2-selection--clearable"), 0 < this.$selection.find(".select2-selection__placeholder").length || 0 === t.length || (e = this.$selection.find(".select2-selection__rendered").attr("id"), i = this.options.get("translations").get("removeAllItems"), (o = n('<button type="button" class="select2-selection__clear" tabindex="-1"><span aria-hidden="true">&times;</span></button>')).attr("title", i()), o.attr("aria-label", i()), o.attr("aria-describedby", e), a.StoreData(o[0], "data", t), this.$selection.prepend(o), this.$selection[0].classList.add("select2-selection--clearable"))
        }, e
    }), e.define("select2/selection/search", ["jquery", "../utils", "../keys"], function(o, a, l) {
        function e(e, t, i) {
            e.call(this, t, i)
        }
        return e.prototype.render = function(e) {
            var t = this.options.get("translations").get("search"),
                i = o('<span class="select2-search select2-search--inline"><textarea class="select2-search__field" type="search" tabindex="-1" autocorrect="off" autocapitalize="none" spellcheck="false" role="searchbox" aria-autocomplete="list" ></textarea></span>'),
                i = (this.$searchContainer = i, this.$search = i.find("textarea"), this.$search.prop("autocomplete", this.options.get("autocomplete")), this.$search.attr("aria-label", t()), e.call(this));
            return this._transferTabIndex(), i.append(this.$searchContainer), i
        }, e.prototype.bind = function(e, t, i) {
            var o = this,
                n = t.id + "-results",
                s = t.id + "-container",
                e = (e.call(this, t, i), o.$search.attr("aria-describedby", s), t.on("open", function() {
                    o.$search.attr("aria-controls", n), o.$search.trigger("focus")
                }), t.on("close", function() {
                    o.$search.val(""), o.resizeSearch(), o.$search.removeAttr("aria-controls"), o.$search.removeAttr("aria-activedescendant"), o.$search.trigger("focus")
                }), t.on("enable", function() {
                    o.$search.prop("disabled", !1), o._transferTabIndex()
                }), t.on("disable", function() {
                    o.$search.prop("disabled", !0)
                }), t.on("focus", function(e) {
                    o.$search.trigger("focus")
                }), t.on("results:focus", function(e) {
                    e.data._resultId ? o.$search.attr("aria-activedescendant", e.data._resultId) : o.$search.removeAttr("aria-activedescendant")
                }), this.$selection.on("focusin", ".select2-search--inline", function(e) {
                    o.trigger("focus", e)
                }), this.$selection.on("focusout", ".select2-search--inline", function(e) {
                    o._handleBlur(e)
                }), this.$selection.on("keydown", ".select2-search--inline", function(e) {
                    var t;
                    e.stopPropagation(), o.trigger("keypress", e), o._keyUpPrevented = e.isDefaultPrevented(), e.which === l.BACKSPACE && "" === o.$search.val() && 0 < (t = o.$selection.find(".select2-selection__choice").last()).length && (t = a.GetData(t[0], "data"), o.searchRemoveChoice(t), e.preventDefault())
                }), this.$selection.on("click", ".select2-search--inline", function(e) {
                    o.$search.val() && e.stopPropagation()
                }), document.documentMode),
                r = e && e <= 11;
            this.$selection.on("input.searchcheck", ".select2-search--inline", function(e) {
                r ? o.$selection.off("input.search input.searchcheck") : o.$selection.off("keyup.search")
            }), this.$selection.on("keyup.search input.search", ".select2-search--inline", function(e) {
                var t;
                r && "input" === e.type ? o.$selection.off("input.search input.searchcheck") : (t = e.which) != l.SHIFT && t != l.CTRL && t != l.ALT && t != l.TAB && o.handleSearch(e)
            })
        }, e.prototype._transferTabIndex = function(e) {
            this.$search.attr("tabindex", this.$selection.attr("tabindex")), this.$selection.attr("tabindex", "-1")
        }, e.prototype.createPlaceholder = function(e, t) {
            this.$search.attr("placeholder", t.text)
        }, e.prototype.update = function(e, t) {
            var i = this.$search[0] == document.activeElement;
            this.$search.attr("placeholder", ""), e.call(this, t), this.resizeSearch(), i && this.$search.trigger("focus")
        }, e.prototype.handleSearch = function() {
            var e;
            this.resizeSearch(), this._keyUpPrevented || (e = this.$search.val(), this.trigger("query", {
                term: e
            })), this._keyUpPrevented = !1
        }, e.prototype.searchRemoveChoice = function(e, t) {
            this.trigger("unselect", {
                data: t
            }), this.$search.val(t.text), this.handleSearch()
        }, e.prototype.resizeSearch = function() {
            this.$search.css("width", "25px");
            var e = "100%";
            "" === this.$search.attr("placeholder") && (e = .75 * (this.$search.val().length + 1) + "em"), this.$search.css("width", e)
        }, e
    }), e.define("select2/selection/selectionCss", ["../utils"], function(i) {
        function e() {}
        return e.prototype.render = function(e) {
            var e = e.call(this),
                t = this.options.get("selectionCssClass") || "";
            return -1 !== t.indexOf(":all:") && (t = t.replace(":all:", ""), i.copyNonInternalCssClasses(e[0], this.$element[0])), e.addClass(t), e
        }, e
    }), e.define("select2/selection/eventRelay", ["jquery"], function(r) {
        function e() {}
        return e.prototype.bind = function(e, t, i) {
            var o = this,
                n = ["open", "opening", "close", "closing", "select", "selecting", "unselect", "unselecting", "clear", "clearing"],
                s = ["opening", "closing", "selecting", "unselecting", "clearing"];
            e.call(this, t, i), t.on("*", function(e, t) {
                var i; - 1 !== n.indexOf(e) && (i = r.Event("select2:" + e, {
                    params: t = t || {}
                }), o.$element.trigger(i), -1 !== s.indexOf(e) && (t.prevented = i.isDefaultPrevented()))
            })
        }, e
    }), e.define("select2/translation", ["jquery", "require"], function(t, i) {
        function o(e) {
            this.dict = e || {}
        }
        return o.prototype.all = function() {
            return this.dict
        }, o.prototype.get = function(e) {
            return this.dict[e]
        }, o.prototype.extend = function(e) {
            this.dict = t.extend({}, e.all(), this.dict)
        }, o._cache = {}, o.loadPath = function(e) {
            var t;
            return e in o._cache || (t = i(e), o._cache[e] = t), new o(o._cache[e])
        }, o
    }), e.define("select2/diacritics", [], function() {
        return {
            "Ⓐ": "A",
            "Ａ": "A",
            "À": "A",
            "Á": "A",
            "Â": "A",
            "Ầ": "A",
            "Ấ": "A",
            "Ẫ": "A",
            "Ẩ": "A",
            "Ã": "A",
            "Ā": "A",
            "Ă": "A",
            "Ằ": "A",
            "Ắ": "A",
            "Ẵ": "A",
            "Ẳ": "A",
            "Ȧ": "A",
            "Ǡ": "A",
            "Ä": "A",
            "Ǟ": "A",
            "Ả": "A",
            "Å": "A",
            "Ǻ": "A",
            "Ǎ": "A",
            "Ȁ": "A",
            "Ȃ": "A",
            "Ạ": "A",
            "Ậ": "A",
            "Ặ": "A",
            "Ḁ": "A",
            "Ą": "A",
            "Ⱥ": "A",
            "Ɐ": "A",
            "Ꜳ": "AA",
            "Æ": "AE",
            "Ǽ": "AE",
            "Ǣ": "AE",
            "Ꜵ": "AO",
            "Ꜷ": "AU",
            "Ꜹ": "AV",
            "Ꜻ": "AV",
            "Ꜽ": "AY",
            "Ⓑ": "B",
            "Ｂ": "B",
            "Ḃ": "B",
            "Ḅ": "B",
            "Ḇ": "B",
            "Ƀ": "B",
            "Ƃ": "B",
            "Ɓ": "B",
            "Ⓒ": "C",
            "Ｃ": "C",
            "Ć": "C",
            "Ĉ": "C",
            "Ċ": "C",
            "Č": "C",
            "Ç": "C",
            "Ḉ": "C",
            "Ƈ": "C",
            "Ȼ": "C",
            "Ꜿ": "C",
            "Ⓓ": "D",
            "Ｄ": "D",
            "Ḋ": "D",
            "Ď": "D",
            "Ḍ": "D",
            "Ḑ": "D",
            "Ḓ": "D",
            "Ḏ": "D",
            "Đ": "D",
            "Ƌ": "D",
            "Ɗ": "D",
            "Ɖ": "D",
            "Ꝺ": "D",
            "Ǳ": "DZ",
            "Ǆ": "DZ",
            "ǲ": "Dz",
            "ǅ": "Dz",
            "Ⓔ": "E",
            "Ｅ": "E",
            "È": "E",
            "É": "E",
            "Ê": "E",
            "Ề": "E",
            "Ế": "E",
            "Ễ": "E",
            "Ể": "E",
            "Ẽ": "E",
            "Ē": "E",
            "Ḕ": "E",
            "Ḗ": "E",
            "Ĕ": "E",
            "Ė": "E",
            "Ë": "E",
            "Ẻ": "E",
            "Ě": "E",
            "Ȅ": "E",
            "Ȇ": "E",
            "Ẹ": "E",
            "Ệ": "E",
            "Ȩ": "E",
            "Ḝ": "E",
            "Ę": "E",
            "Ḙ": "E",
            "Ḛ": "E",
            "Ɛ": "E",
            "Ǝ": "E",
            "Ⓕ": "F",
            "Ｆ": "F",
            "Ḟ": "F",
            "Ƒ": "F",
            "Ꝼ": "F",
            "Ⓖ": "G",
            "Ｇ": "G",
            "Ǵ": "G",
            "Ĝ": "G",
            "Ḡ": "G",
            "Ğ": "G",
            "Ġ": "G",
            "Ǧ": "G",
            "Ģ": "G",
            "Ǥ": "G",
            "Ɠ": "G",
            "Ꞡ": "G",
            "Ᵹ": "G",
            "Ꝿ": "G",
            "Ⓗ": "H",
            "Ｈ": "H",
            "Ĥ": "H",
            "Ḣ": "H",
            "Ḧ": "H",
            "Ȟ": "H",
            "Ḥ": "H",
            "Ḩ": "H",
            "Ḫ": "H",
            "Ħ": "H",
            "Ⱨ": "H",
            "Ⱶ": "H",
            "Ɥ": "H",
            "Ⓘ": "I",
            "Ｉ": "I",
            "Ì": "I",
            "Í": "I",
            "Î": "I",
            "Ĩ": "I",
            "Ī": "I",
            "Ĭ": "I",
            "İ": "I",
            "Ï": "I",
            "Ḯ": "I",
            "Ỉ": "I",
            "Ǐ": "I",
            "Ȉ": "I",
            "Ȋ": "I",
            "Ị": "I",
            "Į": "I",
            "Ḭ": "I",
            "Ɨ": "I",
            "Ⓙ": "J",
            "Ｊ": "J",
            "Ĵ": "J",
            "Ɉ": "J",
            "Ⓚ": "K",
            "Ｋ": "K",
            "Ḱ": "K",
            "Ǩ": "K",
            "Ḳ": "K",
            "Ķ": "K",
            "Ḵ": "K",
            "Ƙ": "K",
            "Ⱪ": "K",
            "Ꝁ": "K",
            "Ꝃ": "K",
            "Ꝅ": "K",
            "Ꞣ": "K",
            "Ⓛ": "L",
            "Ｌ": "L",
            "Ŀ": "L",
            "Ĺ": "L",
            "Ľ": "L",
            "Ḷ": "L",
            "Ḹ": "L",
            "Ļ": "L",
            "Ḽ": "L",
            "Ḻ": "L",
            "Ł": "L",
            "Ƚ": "L",
            "Ɫ": "L",
            "Ⱡ": "L",
            "Ꝉ": "L",
            "Ꝇ": "L",
            "Ꞁ": "L",
            "Ǉ": "LJ",
            "ǈ": "Lj",
            "Ⓜ": "M",
            "Ｍ": "M",
            "Ḿ": "M",
            "Ṁ": "M",
            "Ṃ": "M",
            "Ɱ": "M",
            "Ɯ": "M",
            "Ⓝ": "N",
            "Ｎ": "N",
            "Ǹ": "N",
            "Ń": "N",
            "Ñ": "N",
            "Ṅ": "N",
            "Ň": "N",
            "Ṇ": "N",
            "Ņ": "N",
            "Ṋ": "N",
            "Ṉ": "N",
            "Ƞ": "N",
            "Ɲ": "N",
            "Ꞑ": "N",
            "Ꞥ": "N",
            "Ǌ": "NJ",
            "ǋ": "Nj",
            "Ⓞ": "O",
            "Ｏ": "O",
            "Ò": "O",
            "Ó": "O",
            "Ô": "O",
            "Ồ": "O",
            "Ố": "O",
            "Ỗ": "O",
            "Ổ": "O",
            "Õ": "O",
            "Ṍ": "O",
            "Ȭ": "O",
            "Ṏ": "O",
            "Ō": "O",
            "Ṑ": "O",
            "Ṓ": "O",
            "Ŏ": "O",
            "Ȯ": "O",
            "Ȱ": "O",
            "Ö": "O",
            "Ȫ": "O",
            "Ỏ": "O",
            "Ő": "O",
            "Ǒ": "O",
            "Ȍ": "O",
            "Ȏ": "O",
            "Ơ": "O",
            "Ờ": "O",
            "Ớ": "O",
            "Ỡ": "O",
            "Ở": "O",
            "Ợ": "O",
            "Ọ": "O",
            "Ộ": "O",
            "Ǫ": "O",
            "Ǭ": "O",
            "Ø": "O",
            "Ǿ": "O",
            "Ɔ": "O",
            "Ɵ": "O",
            "Ꝋ": "O",
            "Ꝍ": "O",
            "Œ": "OE",
            "Ƣ": "OI",
            "Ꝏ": "OO",
            "Ȣ": "OU",
            "Ⓟ": "P",
            "Ｐ": "P",
            "Ṕ": "P",
            "Ṗ": "P",
            "Ƥ": "P",
            "Ᵽ": "P",
            "Ꝑ": "P",
            "Ꝓ": "P",
            "Ꝕ": "P",
            "Ⓠ": "Q",
            "Ｑ": "Q",
            "Ꝗ": "Q",
            "Ꝙ": "Q",
            "Ɋ": "Q",
            "Ⓡ": "R",
            "Ｒ": "R",
            "Ŕ": "R",
            "Ṙ": "R",
            "Ř": "R",
            "Ȑ": "R",
            "Ȓ": "R",
            "Ṛ": "R",
            "Ṝ": "R",
            "Ŗ": "R",
            "Ṟ": "R",
            "Ɍ": "R",
            "Ɽ": "R",
            "Ꝛ": "R",
            "Ꞧ": "R",
            "Ꞃ": "R",
            "Ⓢ": "S",
            "Ｓ": "S",
            "ẞ": "S",
            "Ś": "S",
            "Ṥ": "S",
            "Ŝ": "S",
            "Ṡ": "S",
            "Š": "S",
            "Ṧ": "S",
            "Ṣ": "S",
            "Ṩ": "S",
            "Ș": "S",
            "Ş": "S",
            "Ȿ": "S",
            "Ꞩ": "S",
            "Ꞅ": "S",
            "Ⓣ": "T",
            "Ｔ": "T",
            "Ṫ": "T",
            "Ť": "T",
            "Ṭ": "T",
            "Ț": "T",
            "Ţ": "T",
            "Ṱ": "T",
            "Ṯ": "T",
            "Ŧ": "T",
            "Ƭ": "T",
            "Ʈ": "T",
            "Ⱦ": "T",
            "Ꞇ": "T",
            "Ꜩ": "TZ",
            "Ⓤ": "U",
            "Ｕ": "U",
            "Ù": "U",
            "Ú": "U",
            "Û": "U",
            "Ũ": "U",
            "Ṹ": "U",
            "Ū": "U",
            "Ṻ": "U",
            "Ŭ": "U",
            "Ü": "U",
            "Ǜ": "U",
            "Ǘ": "U",
            "Ǖ": "U",
            "Ǚ": "U",
            "Ủ": "U",
            "Ů": "U",
            "Ű": "U",
            "Ǔ": "U",
            "Ȕ": "U",
            "Ȗ": "U",
            "Ư": "U",
            "Ừ": "U",
            "Ứ": "U",
            "Ữ": "U",
            "Ử": "U",
            "Ự": "U",
            "Ụ": "U",
            "Ṳ": "U",
            "Ų": "U",
            "Ṷ": "U",
            "Ṵ": "U",
            "Ʉ": "U",
            "Ⓥ": "V",
            "Ｖ": "V",
            "Ṽ": "V",
            "Ṿ": "V",
            "Ʋ": "V",
            "Ꝟ": "V",
            "Ʌ": "V",
            "Ꝡ": "VY",
            "Ⓦ": "W",
            "Ｗ": "W",
            "Ẁ": "W",
            "Ẃ": "W",
            "Ŵ": "W",
            "Ẇ": "W",
            "Ẅ": "W",
            "Ẉ": "W",
            "Ⱳ": "W",
            "Ⓧ": "X",
            "Ｘ": "X",
            "Ẋ": "X",
            "Ẍ": "X",
            "Ⓨ": "Y",
            "Ｙ": "Y",
            "Ỳ": "Y",
            "Ý": "Y",
            "Ŷ": "Y",
            "Ỹ": "Y",
            "Ȳ": "Y",
            "Ẏ": "Y",
            "Ÿ": "Y",
            "Ỷ": "Y",
            "Ỵ": "Y",
            "Ƴ": "Y",
            "Ɏ": "Y",
            "Ỿ": "Y",
            "Ⓩ": "Z",
            "Ｚ": "Z",
            "Ź": "Z",
            "Ẑ": "Z",
            "Ż": "Z",
            "Ž": "Z",
            "Ẓ": "Z",
            "Ẕ": "Z",
            "Ƶ": "Z",
            "Ȥ": "Z",
            "Ɀ": "Z",
            "Ⱬ": "Z",
            "Ꝣ": "Z",
            "ⓐ": "a",
            "ａ": "a",
            "ẚ": "a",
            "à": "a",
            "á": "a",
            "â": "a",
            "ầ": "a",
            "ấ": "a",
            "ẫ": "a",
            "ẩ": "a",
            "ã": "a",
            "ā": "a",
            "ă": "a",
            "ằ": "a",
            "ắ": "a",
            "ẵ": "a",
            "ẳ": "a",
            "ȧ": "a",
            "ǡ": "a",
            "ä": "a",
            "ǟ": "a",
            "ả": "a",
            "å": "a",
            "ǻ": "a",
            "ǎ": "a",
            "ȁ": "a",
            "ȃ": "a",
            "ạ": "a",
            "ậ": "a",
            "ặ": "a",
            "ḁ": "a",
            "ą": "a",
            "ⱥ": "a",
            "ɐ": "a",
            "ꜳ": "aa",
            "æ": "ae",
            "ǽ": "ae",
            "ǣ": "ae",
            "ꜵ": "ao",
            "ꜷ": "au",
            "ꜹ": "av",
            "ꜻ": "av",
            "ꜽ": "ay",
            "ⓑ": "b",
            "ｂ": "b",
            "ḃ": "b",
            "ḅ": "b",
            "ḇ": "b",
            "ƀ": "b",
            "ƃ": "b",
            "ɓ": "b",
            "ⓒ": "c",
            "ｃ": "c",
            "ć": "c",
            "ĉ": "c",
            "ċ": "c",
            "č": "c",
            "ç": "c",
            "ḉ": "c",
            "ƈ": "c",
            "ȼ": "c",
            "ꜿ": "c",
            "ↄ": "c",
            "ⓓ": "d",
            "ｄ": "d",
            "ḋ": "d",
            "ď": "d",
            "ḍ": "d",
            "ḑ": "d",
            "ḓ": "d",
            "ḏ": "d",
            "đ": "d",
            "ƌ": "d",
            "ɖ": "d",
            "ɗ": "d",
            "ꝺ": "d",
            "ǳ": "dz",
            "ǆ": "dz",
            "ⓔ": "e",
            "ｅ": "e",
            "è": "e",
            "é": "e",
            "ê": "e",
            "ề": "e",
            "ế": "e",
            "ễ": "e",
            "ể": "e",
            "ẽ": "e",
            "ē": "e",
            "ḕ": "e",
            "ḗ": "e",
            "ĕ": "e",
            "ė": "e",
            "ë": "e",
            "ẻ": "e",
            "ě": "e",
            "ȅ": "e",
            "ȇ": "e",
            "ẹ": "e",
            "ệ": "e",
            "ȩ": "e",
            "ḝ": "e",
            "ę": "e",
            "ḙ": "e",
            "ḛ": "e",
            "ɇ": "e",
            "ɛ": "e",
            "ǝ": "e",
            "ⓕ": "f",
            "ｆ": "f",
            "ḟ": "f",
            "ƒ": "f",
            "ꝼ": "f",
            "ⓖ": "g",
            "ｇ": "g",
            "ǵ": "g",
            "ĝ": "g",
            "ḡ": "g",
            "ğ": "g",
            "ġ": "g",
            "ǧ": "g",
            "ģ": "g",
            "ǥ": "g",
            "ɠ": "g",
            "ꞡ": "g",
            "ᵹ": "g",
            "ꝿ": "g",
            "ⓗ": "h",
            "ｈ": "h",
            "ĥ": "h",
            "ḣ": "h",
            "ḧ": "h",
            "ȟ": "h",
            "ḥ": "h",
            "ḩ": "h",
            "ḫ": "h",
            "ẖ": "h",
            "ħ": "h",
            "ⱨ": "h",
            "ⱶ": "h",
            "ɥ": "h",
            "ƕ": "hv",
            "ⓘ": "i",
            "ｉ": "i",
            "ì": "i",
            "í": "i",
            "î": "i",
            "ĩ": "i",
            "ī": "i",
            "ĭ": "i",
            "ï": "i",
            "ḯ": "i",
            "ỉ": "i",
            "ǐ": "i",
            "ȉ": "i",
            "ȋ": "i",
            "ị": "i",
            "į": "i",
            "ḭ": "i",
            "ɨ": "i",
            "ı": "i",
            "ⓙ": "j",
            "ｊ": "j",
            "ĵ": "j",
            "ǰ": "j",
            "ɉ": "j",
            "ⓚ": "k",
            "ｋ": "k",
            "ḱ": "k",
            "ǩ": "k",
            "ḳ": "k",
            "ķ": "k",
            "ḵ": "k",
            "ƙ": "k",
            "ⱪ": "k",
            "ꝁ": "k",
            "ꝃ": "k",
            "ꝅ": "k",
            "ꞣ": "k",
            "ⓛ": "l",
            "ｌ": "l",
            "ŀ": "l",
            "ĺ": "l",
            "ľ": "l",
            "ḷ": "l",
            "ḹ": "l",
            "ļ": "l",
            "ḽ": "l",
            "ḻ": "l",
            "ſ": "l",
            "ł": "l",
            "ƚ": "l",
            "ɫ": "l",
            "ⱡ": "l",
            "ꝉ": "l",
            "ꞁ": "l",
            "ꝇ": "l",
            "ǉ": "lj",
            "ⓜ": "m",
            "ｍ": "m",
            "ḿ": "m",
            "ṁ": "m",
            "ṃ": "m",
            "ɱ": "m",
            "ɯ": "m",
            "ⓝ": "n",
            "ｎ": "n",
            "ǹ": "n",
            "ń": "n",
            "ñ": "n",
            "ṅ": "n",
            "ň": "n",
            "ṇ": "n",
            "ņ": "n",
            "ṋ": "n",
            "ṉ": "n",
            "ƞ": "n",
            "ɲ": "n",
            "ŉ": "n",
            "ꞑ": "n",
            "ꞥ": "n",
            "ǌ": "nj",
            "ⓞ": "o",
            "ｏ": "o",
            "ò": "o",
            "ó": "o",
            "ô": "o",
            "ồ": "o",
            "ố": "o",
            "ỗ": "o",
            "ổ": "o",
            "õ": "o",
            "ṍ": "o",
            "ȭ": "o",
            "ṏ": "o",
            "ō": "o",
            "ṑ": "o",
            "ṓ": "o",
            "ŏ": "o",
            "ȯ": "o",
            "ȱ": "o",
            "ö": "o",
            "ȫ": "o",
            "ỏ": "o",
            "ő": "o",
            "ǒ": "o",
            "ȍ": "o",
            "ȏ": "o",
            "ơ": "o",
            "ờ": "o",
            "ớ": "o",
            "ỡ": "o",
            "ở": "o",
            "ợ": "o",
            "ọ": "o",
            "ộ": "o",
            "ǫ": "o",
            "ǭ": "o",
            "ø": "o",
            "ǿ": "o",
            "ɔ": "o",
            "ꝋ": "o",
            "ꝍ": "o",
            "ɵ": "o",
            "œ": "oe",
            "ƣ": "oi",
            "ȣ": "ou",
            "ꝏ": "oo",
            "ⓟ": "p",
            "ｐ": "p",
            "ṕ": "p",
            "ṗ": "p",
            "ƥ": "p",
            "ᵽ": "p",
            "ꝑ": "p",
            "ꝓ": "p",
            "ꝕ": "p",
            "ⓠ": "q",
            "ｑ": "q",
            "ɋ": "q",
            "ꝗ": "q",
            "ꝙ": "q",
            "ⓡ": "r",
            "ｒ": "r",
            "ŕ": "r",
            "ṙ": "r",
            "ř": "r",
            "ȑ": "r",
            "ȓ": "r",
            "ṛ": "r",
            "ṝ": "r",
            "ŗ": "r",
            "ṟ": "r",
            "ɍ": "r",
            "ɽ": "r",
            "ꝛ": "r",
            "ꞧ": "r",
            "ꞃ": "r",
            "ⓢ": "s",
            "ｓ": "s",
            "ß": "s",
            "ś": "s",
            "ṥ": "s",
            "ŝ": "s",
            "ṡ": "s",
            "š": "s",
            "ṧ": "s",
            "ṣ": "s",
            "ṩ": "s",
            "ș": "s",
            "ş": "s",
            "ȿ": "s",
            "ꞩ": "s",
            "ꞅ": "s",
            "ẛ": "s",
            "ⓣ": "t",
            "ｔ": "t",
            "ṫ": "t",
            "ẗ": "t",
            "ť": "t",
            "ṭ": "t",
            "ț": "t",
            "ţ": "t",
            "ṱ": "t",
            "ṯ": "t",
            "ŧ": "t",
            "ƭ": "t",
            "ʈ": "t",
            "ⱦ": "t",
            "ꞇ": "t",
            "ꜩ": "tz",
            "ⓤ": "u",
            "ｕ": "u",
            "ù": "u",
            "ú": "u",
            "û": "u",
            "ũ": "u",
            "ṹ": "u",
            "ū": "u",
            "ṻ": "u",
            "ŭ": "u",
            "ü": "u",
            "ǜ": "u",
            "ǘ": "u",
            "ǖ": "u",
            "ǚ": "u",
            "ủ": "u",
            "ů": "u",
            "ű": "u",
            "ǔ": "u",
            "ȕ": "u",
            "ȗ": "u",
            "ư": "u",
            "ừ": "u",
            "ứ": "u",
            "ữ": "u",
            "ử": "u",
            "ự": "u",
            "ụ": "u",
            "ṳ": "u",
            "ų": "u",
            "ṷ": "u",
            "ṵ": "u",
            "ʉ": "u",
            "ⓥ": "v",
            "ｖ": "v",
            "ṽ": "v",
            "ṿ": "v",
            "ʋ": "v",
            "ꝟ": "v",
            "ʌ": "v",
            "ꝡ": "vy",
            "ⓦ": "w",
            "ｗ": "w",
            "ẁ": "w",
            "ẃ": "w",
            "ŵ": "w",
            "ẇ": "w",
            "ẅ": "w",
            "ẘ": "w",
            "ẉ": "w",
            "ⱳ": "w",
            "ⓧ": "x",
            "ｘ": "x",
            "ẋ": "x",
            "ẍ": "x",
            "ⓨ": "y",
            "ｙ": "y",
            "ỳ": "y",
            "ý": "y",
            "ŷ": "y",
            "ỹ": "y",
            "ȳ": "y",
            "ẏ": "y",
            "ÿ": "y",
            "ỷ": "y",
            "ẙ": "y",
            "ỵ": "y",
            "ƴ": "y",
            "ɏ": "y",
            "ỿ": "y",
            "ⓩ": "z",
            "ｚ": "z",
            "ź": "z",
            "ẑ": "z",
            "ż": "z",
            "ž": "z",
            "ẓ": "z",
            "ẕ": "z",
            "ƶ": "z",
            "ȥ": "z",
            "ɀ": "z",
            "ⱬ": "z",
            "ꝣ": "z",
            "Ά": "Α",
            "Έ": "Ε",
            "Ή": "Η",
            "Ί": "Ι",
            "Ϊ": "Ι",
            "Ό": "Ο",
            "Ύ": "Υ",
            "Ϋ": "Υ",
            "Ώ": "Ω",
            "ά": "α",
            "έ": "ε",
            "ή": "η",
            "ί": "ι",
            "ϊ": "ι",
            "ΐ": "ι",
            "ό": "ο",
            "ύ": "υ",
            "ϋ": "υ",
            "ΰ": "υ",
            "ώ": "ω",
            "ς": "σ",
            "’": "'"
        }
    }), e.define("select2/data/base", ["../utils"], function(i) {
        function o(e, t) {
            o.__super__.constructor.call(this)
        }
        return i.Extend(o, i.Observable), o.prototype.current = function(e) {
            throw new Error("The `current` method must be defined in child classes.")
        }, o.prototype.query = function(e, t) {
            throw new Error("The `query` method must be defined in child classes.")
        }, o.prototype.bind = function(e, t) {}, o.prototype.destroy = function() {}, o.prototype.generateResultId = function(e, t) {
            e = e.id + "-result-";
            return e += i.generateChars(4), null != t.id ? e += "-" + t.id.toString() : e += "-" + i.generateChars(4), e
        }, o
    }), e.define("select2/data/select", ["./base", "../utils", "jquery"], function(e, a, l) {
        function i(e, t) {
            this.$element = e, this.options = t, i.__super__.constructor.call(this)
        }
        return a.Extend(i, e), i.prototype.current = function(e) {
            var t = this;
            e(Array.prototype.map.call(this.$element[0].querySelectorAll(":checked"), function(e) {
                return t.item(l(e))
            }))
        }, i.prototype.select = function(n) {
            var e, s = this;
            if (n.selected = !0, null != n.element && "option" === n.element.tagName.toLowerCase()) return n.element.selected = !0, void this.$element.trigger("input").trigger("change");
            this.$element.prop("multiple") ? this.current(function(e) {
                var t = [];
                (n = [n]).push.apply(n, e);
                for (var i = 0; i < n.length; i++) {
                    var o = n[i].id; - 1 === t.indexOf(o) && t.push(o)
                }
                s.$element.val(t), s.$element.trigger("input").trigger("change")
            }) : (e = n.id, this.$element.val(e), this.$element.trigger("input").trigger("change"))
        }, i.prototype.unselect = function(n) {
            var s = this;
            if (this.$element.prop("multiple")) {
                if (n.selected = !1, null != n.element && "option" === n.element.tagName.toLowerCase()) return n.element.selected = !1, void this.$element.trigger("input").trigger("change");
                this.current(function(e) {
                    for (var t = [], i = 0; i < e.length; i++) {
                        var o = e[i].id;
                        o !== n.id && -1 === t.indexOf(o) && t.push(o)
                    }
                    s.$element.val(t), s.$element.trigger("input").trigger("change")
                })
            }
        }, i.prototype.bind = function(e, t) {
            var i = this;
            (this.container = e).on("select", function(e) {
                i.select(e.data)
            }), e.on("unselect", function(e) {
                i.unselect(e.data)
            })
        }, i.prototype.destroy = function() {
            this.$element.find("*").each(function() {
                a.RemoveData(this)
            })
        }, i.prototype.query = function(t, e) {
            var i = [],
                o = this;
            this.$element.children().each(function() {
                var e;
                "option" !== this.tagName.toLowerCase() && "optgroup" !== this.tagName.toLowerCase() || (e = l(this), e = o.item(e), null !== (e = o.matches(t, e)) && i.push(e))
            }), e({
                results: i
            })
        }, i.prototype.addOptions = function(e) {
            this.$element.append(e)
        }, i.prototype.option = function(e) {
            e.children ? (t = document.createElement("optgroup")).label = e.text : void 0 !== (t = document.createElement("option")).textContent ? t.textContent = e.text : t.innerText = e.text, void 0 !== e.id && (t.value = e.id), e.disabled && (t.disabled = !0), e.selected && (t.selected = !0), e.title && (t.title = e.title);
            var t, e = this._normalizeItem(e);
            return e.element = t, a.StoreData(t, "data", e), l(t)
        }, i.prototype.item = function(e) {
            var t = {};
            if (null != (t = a.GetData(e[0], "data"))) return t;
            var i = e[0];
            if ("option" === i.tagName.toLowerCase()) t = {
                id: e.val(),
                text: e.text(),
                disabled: e.prop("disabled"),
                selected: e.prop("selected"),
                title: e.prop("title")
            };
            else if ("optgroup" === i.tagName.toLowerCase()) {
                for (var t = {
                        text: e.prop("label"),
                        children: [],
                        title: e.prop("title")
                    }, o = e.children("option"), n = [], s = 0; s < o.length; s++) {
                    var r = l(o[s]),
                        r = this.item(r);
                    n.push(r)
                }
                t.children = n
            }
            return (t = this._normalizeItem(t)).element = e[0], a.StoreData(e[0], "data", t), t
        }, i.prototype._normalizeItem = function(e) {
            e !== Object(e) && (e = {
                id: e,
                text: e
            });
            return null != (e = l.extend({}, {
                text: ""
            }, e)).id && (e.id = e.id.toString()), null != e.text && (e.text = e.text.toString()), null == e._resultId && e.id && null != this.container && (e._resultId = this.generateResultId(this.container, e)), l.extend({}, {
                selected: !1,
                disabled: !1
            }, e)
        }, i.prototype.matches = function(e, t) {
            return this.options.get("matcher")(e, t)
        }, i
    }), e.define("select2/data/array", ["./select", "../utils", "jquery"], function(e, t, c) {
        function o(e, t) {
            this._dataToConvert = t.get("data") || [], o.__super__.constructor.call(this, e, t)
        }
        return t.Extend(o, e), o.prototype.bind = function(e, t) {
            o.__super__.bind.call(this, e, t), this.addOptions(this.convertToOptions(this._dataToConvert))
        }, o.prototype.select = function(i) {
            var e;
            0 === this.$element.find("option").filter(function(e, t) {
                return t.value == i.id.toString()
            }).length && (e = this.option(i), this.addOptions(e)), o.__super__.select.call(this, i)
        }, o.prototype.convertToOptions = function(e) {
            var t = this,
                i = this.$element.find("option"),
                o = i.map(function() {
                    return t.item(c(this)).id
                }).get(),
                n = [];
            for (var s = 0; s < e.length; s++) {
                var r, a, l = this._normalizeItem(e[s]);
                0 <= o.indexOf(l.id) ? (r = i.filter(function(e) {
                    return function() {
                        return c(this).val() == e.id
                    }
                }(l)), a = this.item(r), a = c.extend(!0, {}, l, a), a = this.option(a), r.replaceWith(a)) : (r = this.option(l), l.children && (a = this.convertToOptions(l.children), r.append(a)), n.push(r))
            }
            return n
        }, o
    }), e.define("select2/data/ajax", ["./array", "../utils", "jquery"], function(e, t, s) {
        function i(e, t) {
            this.ajaxOptions = this._applyDefaults(t.get("ajax")), null != this.ajaxOptions.processResults && (this.processResults = this.ajaxOptions.processResults), i.__super__.constructor.call(this, e, t)
        }
        return t.Extend(i, e), i.prototype._applyDefaults = function(e) {
            return s.extend({}, {
                data: function(e) {
                    return s.extend({}, e, {
                        q: e.term
                    })
                },
                transport: function(e, t, i) {
                    e = s.ajax(e);
                    return e.then(t), e.fail(i), e
                }
            }, e, !0)
        }, i.prototype.processResults = function(e) {
            return e
        }, i.prototype.query = function(t, i) {
            var o = this,
                n = (null != this._request && ("function" == typeof this._request.abort && this._request.abort(), this._request = null), s.extend({
                    type: "GET"
                }, this.ajaxOptions));

            function e() {
                var e = n.transport(n, function(e) {
                    e = o.processResults(e, t);
                    o.options.get("debug") && window.console && console.error && (e && e.results && Array.isArray(e.results) || console.error("Select2: The AJAX results did not return an array in the `results` key of the response.")), i(e)
                }, function() {
                    "status" in e && (0 === e.status || "0" === e.status) || o.trigger("results:message", {
                        message: "errorLoading"
                    })
                });
                o._request = e
            }
            "function" == typeof n.url && (n.url = n.url.call(this.$element, t)), "function" == typeof n.data && (n.data = n.data.call(this.$element, t)), this.ajaxOptions.delay && null != t.term ? (this._queryTimeout && window.clearTimeout(this._queryTimeout), this._queryTimeout = window.setTimeout(e, this.ajaxOptions.delay)) : e()
        }, i
    }), e.define("select2/data/tags", ["jquery"], function(t) {
        function e(e, t, i) {
            var o = i.get("tags"),
                n = i.get("createTag"),
                n = (void 0 !== n && (this.createTag = n), i.get("insertTag"));
            if (void 0 !== n && (this.insertTag = n), e.call(this, t, i), Array.isArray(o))
                for (var s = 0; s < o.length; s++) {
                    var r = o[s],
                        r = this._normalizeItem(r),
                        r = this.option(r);
                    this.$element.append(r)
                }
        }
        return e.prototype.query = function(e, c, d) {
            var u = this;
            this._removeOldTags(), null == c.term || null != c.page ? e.call(this, c, d) : e.call(this, c, function e(t, i) {
                for (var o = t.results, n = 0; n < o.length; n++) {
                    var s = o[n],
                        r = null != s.children && !e({
                            results: s.children
                        }, !0);
                    if ((s.text || "").toUpperCase() === (c.term || "").toUpperCase() || r) return !i && (t.data = o, void d(t))
                }
                if (i) return !0;
                var a, l = u.createTag(c);
                null != l && ((a = u.option(l)).attr("data-select2-tag", "true"), u.addOptions([a]), u.insertTag(o, l)), t.results = o, d(t)
            })
        }, e.prototype.createTag = function(e, t) {
            if (null == t.term) return null;
            t = t.term.trim();
            return "" === t ? null : {
                id: t,
                text: t
            }
        }, e.prototype.insertTag = function(e, t, i) {
            t.unshift(i)
        }, e.prototype._removeOldTags = function(e) {
            this.$element.find("option[data-select2-tag]").each(function() {
                this.selected || t(this).remove()
            })
        }, e
    }), e.define("select2/data/tokenizer", ["jquery"], function(c) {
        function e(e, t, i) {
            var o = i.get("tokenizer");
            void 0 !== o && (this.tokenizer = o), e.call(this, t, i)
        }
        return e.prototype.bind = function(e, t, i) {
            e.call(this, t, i), this.$search = t.dropdown.$search || t.selection.$search || i.find(".select2-search__field")
        }, e.prototype.query = function(e, t, i) {
            var o = this;
            t.term = t.term || "";
            var n = this.tokenizer(t, this.options, function(e) {
                var t = o._normalizeItem(e);
                o.$element.find("option").filter(function() {
                    return c(this).val() === t.id
                }).length || ((e = o.option(t)).attr("data-select2-tag", !0), o._removeOldTags(), o.addOptions([e])), o.trigger("select", {
                    data: t
                })
            });
            n.term !== t.term && (this.$search.length && (this.$search.val(n.term), this.$search.trigger("focus")), t.term = n.term), e.call(this, t, i)
        }, e.prototype.tokenizer = function(e, t, i, o) {
            for (var n = i.get("tokenSeparators") || [], s = t.term, r = 0, a = this.createTag || function(e) {
                    return {
                        id: e.term,
                        text: e.term
                    }
                }; r < s.length;) {
                var l = s[r]; - 1 === n.indexOf(l) ? r++ : (l = s.substr(0, r), null == (l = a(c.extend({}, t, {
                    term: l
                }))) ? r++ : (o(l), s = s.substr(r + 1) || "", r = 0))
            }
            return {
                term: s
            }
        }, e
    }), e.define("select2/data/minimumInputLength", [], function() {
        function e(e, t, i) {
            this.minimumInputLength = i.get("minimumInputLength"), e.call(this, t, i)
        }
        return e.prototype.query = function(e, t, i) {
            t.term = t.term || "", t.term.length < this.minimumInputLength ? this.trigger("results:message", {
                message: "inputTooShort",
                args: {
                    minimum: this.minimumInputLength,
                    input: t.term,
                    params: t
                }
            }) : e.call(this, t, i)
        }, e
    }), e.define("select2/data/maximumInputLength", [], function() {
        function e(e, t, i) {
            this.maximumInputLength = i.get("maximumInputLength"), e.call(this, t, i)
        }
        return e.prototype.query = function(e, t, i) {
            t.term = t.term || "", 0 < this.maximumInputLength && t.term.length > this.maximumInputLength ? this.trigger("results:message", {
                message: "inputTooLong",
                args: {
                    maximum: this.maximumInputLength,
                    input: t.term,
                    params: t
                }
            }) : e.call(this, t, i)
        }, e
    }), e.define("select2/data/maximumSelectionLength", [], function() {
        function e(e, t, i) {
            this.maximumSelectionLength = i.get("maximumSelectionLength"), e.call(this, t, i)
        }
        return e.prototype.bind = function(e, t, i) {
            var o = this;
            e.call(this, t, i), t.on("select", function() {
                o._checkIfMaximumSelected()
            })
        }, e.prototype.query = function(e, t, i) {
            var o = this;
            this._checkIfMaximumSelected(function() {
                e.call(o, t, i)
            })
        }, e.prototype._checkIfMaximumSelected = function(e, t) {
            var i = this;
            this.current(function(e) {
                e = null != e ? e.length : 0;
                0 < i.maximumSelectionLength && e >= i.maximumSelectionLength ? i.trigger("results:message", {
                    message: "maximumSelected",
                    args: {
                        maximum: i.maximumSelectionLength
                    }
                }) : t && t()
            })
        }, e
    }), e.define("select2/dropdown", ["jquery", "./utils"], function(t, e) {
        function i(e, t) {
            this.$element = e, this.options = t, i.__super__.constructor.call(this)
        }
        return e.Extend(i, e.Observable), i.prototype.render = function() {
            var e = t('<span class="select2-dropdown"><span class="select2-results"></span></span>');
            return e.attr("dir", this.options.get("dir")), this.$dropdown = e
        }, i.prototype.bind = function() {}, i.prototype.position = function(e, t) {}, i.prototype.destroy = function() {
            this.$dropdown.remove()
        }, i
    }), e.define("select2/dropdown/search", ["jquery"], function(s) {
        function e() {}
        return e.prototype.render = function(e) {
            var e = e.call(this),
                t = this.options.get("translations").get("search"),
                i = s('<span class="select2-search select2-search--dropdown"><input class="select2-search__field" type="search" tabindex="-1" autocorrect="off" autocapitalize="none" spellcheck="false" role="searchbox" aria-autocomplete="list" /></span>');
            return this.$searchContainer = i, this.$search = i.find("input"), this.$search.prop("autocomplete", this.options.get("autocomplete")), this.$search.attr("aria-label", t()), e.prepend(i), e
        }, e.prototype.bind = function(e, t, i) {
            var o = this,
                n = t.id + "-results";
            e.call(this, t, i), this.$search.on("keydown", function(e) {
                o.trigger("keypress", e), o._keyUpPrevented = e.isDefaultPrevented()
            }), this.$search.on("input", function(e) {
                s(this).off("keyup")
            }), this.$search.on("keyup input", function(e) {
                o.handleSearch(e)
            }), t.on("open", function() {
                o.$search.attr("tabindex", 0), o.$search.attr("aria-controls", n), o.$search.trigger("focus"), window.setTimeout(function() {
                    o.$search.trigger("focus")
                }, 0)
            }), t.on("close", function() {
                o.$search.attr("tabindex", -1), o.$search.removeAttr("aria-controls"), o.$search.removeAttr("aria-activedescendant"), o.$search.val(""), o.$search.trigger("blur")
            }), t.on("focus", function() {
                t.isOpen() || o.$search.trigger("focus")
            }), t.on("results:all", function(e) {
                null != e.query.term && "" !== e.query.term || (o.showSearch(e) ? o.$searchContainer[0].classList.remove("select2-search--hide") : o.$searchContainer[0].classList.add("select2-search--hide"))
            }), t.on("results:focus", function(e) {
                e.data._resultId ? o.$search.attr("aria-activedescendant", e.data._resultId) : o.$search.removeAttr("aria-activedescendant")
            })
        }, e.prototype.handleSearch = function(e) {
            var t;
            this._keyUpPrevented || (t = this.$search.val(), this.trigger("query", {
                term: t
            })), this._keyUpPrevented = !1
        }, e.prototype.showSearch = function(e, t) {
            return !0
        }, e
    }), e.define("select2/dropdown/hidePlaceholder", [], function() {
        function e(e, t, i, o) {
            this.placeholder = this.normalizePlaceholder(i.get("placeholder")), e.call(this, t, i, o)
        }
        return e.prototype.append = function(e, t) {
            t.results = this.removePlaceholder(t.results), e.call(this, t)
        }, e.prototype.normalizePlaceholder = function(e, t) {
            return t = "string" == typeof t ? {
                id: "",
                text: t
            } : t
        }, e.prototype.removePlaceholder = function(e, t) {
            for (var i = t.slice(0), o = t.length - 1; 0 <= o; o--) {
                var n = t[o];
                this.placeholder.id === n.id && i.splice(o, 1)
            }
            return i
        }, e
    }), e.define("select2/dropdown/infiniteScroll", ["jquery"], function(i) {
        function e(e, t, i, o) {
            this.lastParams = {}, e.call(this, t, i, o), this.$loadingMore = this.createLoadingMore(), this.loading = !1
        }
        return e.prototype.append = function(e, t) {
            this.$loadingMore.remove(), this.loading = !1, e.call(this, t), this.showLoadingMore(t) && (this.$results.append(this.$loadingMore), this.loadMoreIfNeeded())
        }, e.prototype.bind = function(e, t, i) {
            var o = this;
            e.call(this, t, i), t.on("query", function(e) {
                o.lastParams = e, o.loading = !0
            }), t.on("query:append", function(e) {
                o.lastParams = e, o.loading = !0
            }), this.$results.on("scroll", this.loadMoreIfNeeded.bind(this))
        }, e.prototype.loadMoreIfNeeded = function() {
            var e = i.contains(document.documentElement, this.$loadingMore[0]);
            !this.loading && e && (e = this.$results.offset().top + this.$results.outerHeight(!1), this.$loadingMore.offset().top + this.$loadingMore.outerHeight(!1) <= e + 50 && this.loadMore())
        }, e.prototype.loadMore = function() {
            this.loading = !0;
            var e = i.extend({}, {
                page: 1
            }, this.lastParams);
            e.page++, this.trigger("query:append", e)
        }, e.prototype.showLoadingMore = function(e, t) {
            return t.pagination && t.pagination.more
        }, e.prototype.createLoadingMore = function() {
            var e = i('<li class="select2-results__option select2-results__option--load-more"role="option" aria-disabled="true"></li>'),
                t = this.options.get("translations").get("loadingMore");
            return e.html(t(this.lastParams)), e
        }, e
    }), e.define("select2/dropdown/attachBody", ["jquery", "../utils"], function(d, r) {
        function e(e, t, i) {
            this.$dropdownParent = d(i.get("dropdownParent") || document.body), e.call(this, t, i)
        }
        return e.prototype.bind = function(e, t, i) {
            var o = this;
            e.call(this, t, i), t.on("open", function() {
                o._showDropdown(), o._attachPositioningHandler(t), o._bindContainerResultHandlers(t)
            }), t.on("close", function() {
                o._hideDropdown(), o._detachPositioningHandler(t)
            }), this.$dropdownContainer.on("mousedown", function(e) {
                e.stopPropagation()
            })
        }, e.prototype.destroy = function(e) {
            e.call(this), this.$dropdownContainer.remove()
        }, e.prototype.position = function(e, t, i) {
            t.attr("class", i.attr("class")), t[0].classList.remove("select2"), t[0].classList.add("select2-container--open"), t.css({
                position: "absolute",
                top: -999999
            }), this.$container = i
        }, e.prototype.render = function(e) {
            var t = d("<span></span>"),
                e = e.call(this);
            return t.append(e), this.$dropdownContainer = t
        }, e.prototype._hideDropdown = function(e) {
            this.$dropdownContainer.detach()
        }, e.prototype._bindContainerResultHandlers = function(e, t) {
            var i;
            this._containerResultsHandlersBound || (i = this, t.on("results:all", function() {
                i._positionDropdown(), i._resizeDropdown()
            }), t.on("results:append", function() {
                i._positionDropdown(), i._resizeDropdown()
            }), t.on("results:message", function() {
                i._positionDropdown(), i._resizeDropdown()
            }), t.on("select", function() {
                i._positionDropdown(), i._resizeDropdown()
            }), t.on("unselect", function() {
                i._positionDropdown(), i._resizeDropdown()
            }), this._containerResultsHandlersBound = !0)
        }, e.prototype._attachPositioningHandler = function(e, t) {
            var i = this,
                o = "scroll.select2." + t.id,
                n = "resize.select2." + t.id,
                t = "orientationchange.select2." + t.id,
                s = this.$container.parents().filter(r.hasScroll);
            s.each(function() {
                r.StoreData(this, "select2-scroll-position", {
                    x: d(this).scrollLeft(),
                    y: d(this).scrollTop()
                })
            }), s.on(o, function(e) {
                var t = r.GetData(this, "select2-scroll-position");
                d(this).scrollTop(t.y)
            }), d(window).on(o + " " + n + " " + t, function(e) {
                i._positionDropdown(), i._resizeDropdown()
            })
        }, e.prototype._detachPositioningHandler = function(e, t) {
            var i = "scroll.select2." + t.id,
                o = "resize.select2." + t.id,
                t = "orientationchange.select2." + t.id;
            this.$container.parents().filter(r.hasScroll).off(i), d(window).off(i + " " + o + " " + t)
        }, e.prototype._positionDropdown = function() {
            var e = d(window),
                t = this.$dropdown[0].classList.contains("select2-dropdown--above"),
                i = this.$dropdown[0].classList.contains("select2-dropdown--below"),
                o = null,
                n = this.$container.offset(),
                s = (n.bottom = n.top + this.$container.outerHeight(!1), {
                    height: this.$container.outerHeight(!1)
                });
            s.top = n.top, s.bottom = n.top + s.height;
            var r = this.$dropdown.outerHeight(!1),
                a = e.scrollTop(),
                e = e.scrollTop() + e.height(),
                a = a < n.top - r,
                e = e > n.bottom + r,
                n = {
                    left: n.left,
                    top: s.bottom
                },
                l = this.$dropdownParent,
                c = ("static" === l.css("position") && (l = l.offsetParent()), {
                    top: 0,
                    left: 0
                });
            (d.contains(document.body, l[0]) || l[0].isConnected) && (c = l.offset()), n.top -= c.top, n.left -= c.left, t || i || (o = "below"), e || !a || t ? !a && e && t && (o = "below") : o = "above", ("above" == o || t && "below" !== o) && (n.top = s.top - c.top - r), null != o && (this.$dropdown[0].classList.remove("select2-dropdown--below"), this.$dropdown[0].classList.remove("select2-dropdown--above"), this.$dropdown[0].classList.add("select2-dropdown--" + o), this.$container[0].classList.remove("select2-container--below"), this.$container[0].classList.remove("select2-container--above"), this.$container[0].classList.add("select2-container--" + o)), this.$dropdownContainer.css(n)
        }, e.prototype._resizeDropdown = function() {
            var e = {
                width: this.$container.outerWidth(!1) + "px"
            };
            this.options.get("dropdownAutoWidth") && (e.minWidth = e.width, e.position = "relative", e.width = "auto"), this.$dropdown.css(e)
        }, e.prototype._showDropdown = function(e) {
            this.$dropdownContainer.appendTo(this.$dropdownParent), this._positionDropdown(), this._resizeDropdown()
        }, e
    }), e.define("select2/dropdown/minimumResultsForSearch", [], function() {
        function e(e, t, i, o) {
            this.minimumResultsForSearch = i.get("minimumResultsForSearch"), this.minimumResultsForSearch < 0 && (this.minimumResultsForSearch = 1 / 0), e.call(this, t, i, o)
        }
        return e.prototype.showSearch = function(e, t) {
            return !(function e(t) {
                for (var i = 0, o = 0; o < t.length; o++) {
                    var n = t[o];
                    n.children ? i += e(n.children) : i++
                }
                return i
            }(t.data.results) < this.minimumResultsForSearch) && e.call(this, t)
        }, e
    }), e.define("select2/dropdown/selectOnClose", ["../utils"], function(i) {
        function e() {}
        return e.prototype.bind = function(e, t, i) {
            var o = this;
            e.call(this, t, i), t.on("close", function(e) {
                o._handleSelectOnClose(e)
            })
        }, e.prototype._handleSelectOnClose = function(e, t) {
            if (t && null != t.originalSelect2Event) {
                t = t.originalSelect2Event;
                if ("select" === t._type || "unselect" === t._type) return
            }
            var t = this.getHighlightedResults();
            t.length < 1 || (null != (t = i.GetData(t[0], "data")).element && t.element.selected || null == t.element && t.selected || this.trigger("select", {
                data: t
            }))
        }, e
    }), e.define("select2/dropdown/closeOnSelect", [], function() {
        function e() {}
        return e.prototype.bind = function(e, t, i) {
            var o = this;
            e.call(this, t, i), t.on("select", function(e) {
                o._selectTriggered(e)
            }), t.on("unselect", function(e) {
                o._selectTriggered(e)
            })
        }, e.prototype._selectTriggered = function(e, t) {
            var i = t.originalEvent;
            i && (i.ctrlKey || i.metaKey) || this.trigger("close", {
                originalEvent: i,
                originalSelect2Event: t
            })
        }, e
    }), e.define("select2/dropdown/dropdownCss", ["../utils"], function(i) {
        function e() {}
        return e.prototype.render = function(e) {
            var e = e.call(this),
                t = this.options.get("dropdownCssClass") || "";
            return -1 !== t.indexOf(":all:") && (t = t.replace(":all:", ""), i.copyNonInternalCssClasses(e[0], this.$element[0])), e.addClass(t), e
        }, e
    }), e.define("select2/dropdown/tagsSearchHighlight", ["../utils"], function(o) {
        function e() {}
        return e.prototype.highlightFirstItem = function(e) {
            var t = this.$results.find(".select2-results__option--selectable:not(.select2-results__option--selected)");
            if (0 < t.length) {
                var t = t.first(),
                    i = o.GetData(t[0], "data").element;
                if (i && i.getAttribute && "true" === i.getAttribute("data-select2-tag")) return void t.trigger("mouseenter")
            }
            e.call(this)
        }, e
    }), e.define("select2/i18n/en", [], function() {
        return {
            errorLoading: function() {
                return "The results could not be loaded."
            },
            inputTooLong: function(e) {
                var e = e.input.length - e.maximum,
                    t = "Please delete " + e + " character";
                return 1 != e && (t += "s"), t
            },
            inputTooShort: function(e) {
                return "Please enter " + (e.minimum - e.input.length) + " or more characters"
            },
            loadingMore: function() {
                return "Loading more results…"
            },
            maximumSelected: function(e) {
                var t = "You can only select " + e.maximum + " item";
                return 1 != e.maximum && (t += "s"), t
            },
            noResults: function() {
                return "No results found"
            },
            searching: function() {
                return "Searching…"
            },
            removeAllItems: function() {
                return "Remove all items"
            },
            removeItem: function() {
                return "Remove item"
            },
            search: function() {
                return "Search"
            }
        }
    }), e.define("select2/defaults", ["jquery", "./results", "./selection/single", "./selection/multiple", "./selection/placeholder", "./selection/allowClear", "./selection/search", "./selection/selectionCss", "./selection/eventRelay", "./utils", "./translation", "./diacritics", "./data/select", "./data/array", "./data/ajax", "./data/tags", "./data/tokenizer", "./data/minimumInputLength", "./data/maximumInputLength", "./data/maximumSelectionLength", "./dropdown", "./dropdown/search", "./dropdown/hidePlaceholder", "./dropdown/infiniteScroll", "./dropdown/attachBody", "./dropdown/minimumResultsForSearch", "./dropdown/selectOnClose", "./dropdown/closeOnSelect", "./dropdown/dropdownCss", "./dropdown/tagsSearchHighlight", "./i18n/en"], function(l, s, r, a, c, d, u, p, h, f, m, t, g, v, y, w, b, k, C, $, S, T, x, _, A, O, E, D, I, L, e) {
        function i() {
            this.reset()
        }
        return i.prototype.apply = function(e) {
            null == (e = l.extend(!0, {}, this.defaults, e)).dataAdapter && (null != e.ajax ? e.dataAdapter = y : null != e.data ? e.dataAdapter = v : e.dataAdapter = g, 0 < e.minimumInputLength && (e.dataAdapter = f.Decorate(e.dataAdapter, k)), 0 < e.maximumInputLength && (e.dataAdapter = f.Decorate(e.dataAdapter, C)), 0 < e.maximumSelectionLength && (e.dataAdapter = f.Decorate(e.dataAdapter, $)), e.tags && (e.dataAdapter = f.Decorate(e.dataAdapter, w)), null == e.tokenSeparators && null == e.tokenizer || (e.dataAdapter = f.Decorate(e.dataAdapter, b))), null == e.resultsAdapter && (e.resultsAdapter = s, null != e.ajax && (e.resultsAdapter = f.Decorate(e.resultsAdapter, _)), null != e.placeholder && (e.resultsAdapter = f.Decorate(e.resultsAdapter, x)), e.selectOnClose && (e.resultsAdapter = f.Decorate(e.resultsAdapter, E)), e.tags && (e.resultsAdapter = f.Decorate(e.resultsAdapter, L))), null == e.dropdownAdapter && (e.multiple ? e.dropdownAdapter = S : (t = f.Decorate(S, T), e.dropdownAdapter = t), 0 !== e.minimumResultsForSearch && (e.dropdownAdapter = f.Decorate(e.dropdownAdapter, O)), e.closeOnSelect && (e.dropdownAdapter = f.Decorate(e.dropdownAdapter, D)), null != e.dropdownCssClass && (e.dropdownAdapter = f.Decorate(e.dropdownAdapter, I)), e.dropdownAdapter = f.Decorate(e.dropdownAdapter, A)), null == e.selectionAdapter && (e.multiple ? e.selectionAdapter = a : e.selectionAdapter = r, null != e.placeholder && (e.selectionAdapter = f.Decorate(e.selectionAdapter, c)), e.allowClear && (e.selectionAdapter = f.Decorate(e.selectionAdapter, d)), e.multiple && (e.selectionAdapter = f.Decorate(e.selectionAdapter, u)), null != e.selectionCssClass && (e.selectionAdapter = f.Decorate(e.selectionAdapter, p)), e.selectionAdapter = f.Decorate(e.selectionAdapter, h)), e.language = this._resolveLanguage(e.language), e.language.push("en");
            for (var t, i = [], o = 0; o < e.language.length; o++) {
                var n = e.language[o]; - 1 === i.indexOf(n) && i.push(n)
            }
            return e.language = i, e.translations = this._processTranslations(e.language, e.debug), e
        }, i.prototype.reset = function() {
            function a(e) {
                return e.replace(/[^\u0000-\u007E]/g, function(e) {
                    return t[e] || e
                })
            }
            this.defaults = {
                amdLanguageBase: "./i18n/",
                autocomplete: "off",
                closeOnSelect: !0,
                debug: !1,
                dropdownAutoWidth: !1,
                escapeMarkup: f.escapeMarkup,
                language: {},
                matcher: function e(t, i) {
                    if (null == t.term || "" === t.term.trim()) return i;
                    if (i.children && 0 < i.children.length) {
                        for (var o = l.extend(!0, {}, i), n = i.children.length - 1; 0 <= n; n--) null == e(t, i.children[n]) && o.children.splice(n, 1);
                        return 0 < o.children.length ? o : e(t, o)
                    }
                    var s = a(i.text).toUpperCase(),
                        r = a(t.term).toUpperCase();
                    return -1 < s.indexOf(r) ? i : null
                },
                minimumInputLength: 0,
                maximumInputLength: 0,
                maximumSelectionLength: 0,
                minimumResultsForSearch: 0,
                selectOnClose: !1,
                scrollAfterSelect: !1,
                sorter: function(e) {
                    return e
                },
                templateResult: function(e) {
                    return e.text
                },
                templateSelection: function(e) {
                    return e.text
                },
                theme: "default",
                width: "resolve"
            }
        }, i.prototype.applyFromElement = function(e, t) {
            var i = e.language,
                o = this.defaults.language,
                n = t.prop("lang"),
                t = t.closest("[lang]").prop("lang"),
                n = Array.prototype.concat.call(this._resolveLanguage(n), this._resolveLanguage(i), this._resolveLanguage(o), this._resolveLanguage(t));
            return e.language = n, e
        }, i.prototype._resolveLanguage = function(e) {
            if (!e) return [];
            if (l.isEmptyObject(e)) return [];
            if (l.isPlainObject(e)) return [e];
            for (var t, i = Array.isArray(e) ? e : [e], o = [], n = 0; n < i.length; n++) o.push(i[n]), "string" == typeof i[n] && 0 < i[n].indexOf("-") && (t = i[n].split("-")[0], o.push(t));
            return o
        }, i.prototype._processTranslations = function(e, t) {
            for (var i = new m, o = 0; o < e.length; o++) {
                var n = new m,
                    s = e[o];
                if ("string" == typeof s) try {
                    n = m.loadPath(s)
                } catch (e) {
                    try {
                        s = this.defaults.amdLanguageBase + s, n = m.loadPath(s)
                    } catch (e) {
                        t && window.console && console.warn && console.warn('Select2: The language file for "' + s + '" could not be automatically loaded. A fallback will be used instead.')
                    }
                } else n = l.isPlainObject(s) ? new m(s) : s;
                i.extend(n)
            }
            return i
        }, i.prototype.set = function(e, t) {
            var i = {},
                e = (i[l.camelCase(e)] = t, f._convertData(i));
            l.extend(!0, this.defaults, e)
        }, new i
    }), e.define("select2/options", ["jquery", "./defaults", "./utils"], function(c, i, d) {
        function e(e, t) {
            this.options = e, null != t && this.fromElement(t), null != t && (this.options = i.applyFromElement(this.options, t)), this.options = i.apply(this.options)
        }
        return e.prototype.fromElement = function(e) {
            var t = ["select2"],
                i = (null == this.options.multiple && (this.options.multiple = e.prop("multiple")), null == this.options.disabled && (this.options.disabled = e.prop("disabled")), null == this.options.autocomplete && e.prop("autocomplete") && (this.options.autocomplete = e.prop("autocomplete")), null == this.options.dir && (e.prop("dir") ? this.options.dir = e.prop("dir") : e.closest("[dir]").prop("dir") ? this.options.dir = e.closest("[dir]").prop("dir") : this.options.dir = "ltr"), e.prop("disabled", this.options.disabled), e.prop("multiple", this.options.multiple), d.GetData(e[0], "select2Tags") && (this.options.debug && window.console && console.warn && console.warn('Select2: The `data-select2-tags` attribute has been changed to use the `data-data` and `data-tags="true"` attributes and will be removed in future versions of Select2.'), d.StoreData(e[0], "data", d.GetData(e[0], "select2Tags")), d.StoreData(e[0], "tags", !0)), d.GetData(e[0], "ajaxUrl") && (this.options.debug && window.console && console.warn && console.warn("Select2: The `data-ajax-url` attribute has been changed to `data-ajax--url` and support for the old attribute will be removed in future versions of Select2."), e.attr("ajax--url", d.GetData(e[0], "ajaxUrl")), d.StoreData(e[0], "ajax-Url", d.GetData(e[0], "ajaxUrl"))), {});

            function o(e, t) {
                return t.toUpperCase()
            }
            for (var n = 0; n < e[0].attributes.length; n++) {
                var s = e[0].attributes[n].name,
                    r = "data-";
                s.substr(0, r.length) == r && (s = s.substring(r.length), r = d.GetData(e[0], s), i[s.replace(/-([a-z])/g, o)] = r)
            }
            c.fn.jquery && "1." == c.fn.jquery.substr(0, 2) && e[0].dataset && (i = c.extend(!0, {}, e[0].dataset, i));
            var a, l = c.extend(!0, {}, d.GetData(e[0]), i);
            for (a in l = d._convertData(l)) - 1 < t.indexOf(a) || (c.isPlainObject(this.options[a]) ? c.extend(this.options[a], l[a]) : this.options[a] = l[a]);
            return this
        }, e.prototype.get = function(e) {
            return this.options[e]
        }, e.prototype.set = function(e, t) {
            this.options[e] = t
        }, e
    }), e.define("select2/core", ["jquery", "./options", "./utils", "./keys"], function(t, n, s, o) {
        function r(e, t) {
            null != s.GetData(e[0], "select2") && s.GetData(e[0], "select2").destroy(), this.$element = e, this.id = this._generateId(e), this.options = new n(t = t || {}, e), r.__super__.constructor.call(this);
            var t = e.attr("tabindex") || 0,
                t = (s.StoreData(e[0], "old-tabindex", t), e.attr("tabindex", "-1"), this.options.get("dataAdapter")),
                t = (this.dataAdapter = new t(e, this.options), this.render()),
                i = (this._placeContainer(t), this.options.get("selectionAdapter")),
                i = (this.selection = new i(e, this.options), this.$selection = this.selection.render(), this.selection.position(this.$selection, t), this.options.get("dropdownAdapter")),
                i = (this.dropdown = new i(e, this.options), this.$dropdown = this.dropdown.render(), this.dropdown.position(this.$dropdown, t), this.options.get("resultsAdapter")),
                o = (this.results = new i(e, this.options, this.dataAdapter), this.$results = this.results.render(), this.results.position(this.$results, this.$dropdown), this);
            this._bindAdapters(), this._registerDomEvents(), this._registerDataEvents(), this._registerSelectionEvents(), this._registerDropdownEvents(), this._registerResultsEvents(), this._registerEvents(), this.dataAdapter.current(function(e) {
                o.trigger("selection:update", {
                    data: e
                })
            }), e[0].classList.add("select2-hidden-accessible"), e.attr("aria-hidden", "true"), this._syncAttributes(), s.StoreData(e[0], "select2", this), e.data("select2", this)
        }
        return s.Extend(r, s.Observable), r.prototype._generateId = function(e) {
            return "select2-" + (null != e.attr("id") ? e.attr("id") : null != e.attr("name") ? e.attr("name") + "-" + s.generateChars(2) : s.generateChars(4)).replace(/(:|\.|\[|\]|,)/g, "")
        }, r.prototype._placeContainer = function(e) {
            e.insertAfter(this.$element);
            var t = this._resolveWidth(this.$element, this.options.get("width"));
            null != t && e.css("width", t)
        }, r.prototype._resolveWidth = function(e, t) {
            var i = /^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i;
            if ("resolve" == t) return null != (o = this._resolveWidth(e, "style")) ? o : this._resolveWidth(e, "element");
            if ("element" == t) return (o = e.outerWidth(!1)) <= 0 ? "auto" : o + "px";
            if ("style" != t) return "computedstyle" == t ? window.getComputedStyle(e[0]).width : t;
            var o = e.attr("style");
            if ("string" != typeof o) return null;
            for (var n = o.split(";"), s = 0, r = n.length; s < r; s += 1) {
                var a = n[s].replace(/\s/g, "").match(i);
                if (null !== a && 1 <= a.length) return a[1]
            }
            return null
        }, r.prototype._bindAdapters = function() {
            this.dataAdapter.bind(this, this.$container), this.selection.bind(this, this.$container), this.dropdown.bind(this, this.$container), this.results.bind(this, this.$container)
        }, r.prototype._registerDomEvents = function() {
            var t = this;
            this.$element.on("change.select2", function() {
                t.dataAdapter.current(function(e) {
                    t.trigger("selection:update", {
                        data: e
                    })
                })
            }), this.$element.on("focus.select2", function(e) {
                t.trigger("focus", e)
            }), this._syncA = s.bind(this._syncAttributes, this), this._syncS = s.bind(this._syncSubtree, this), this._observer = new window.MutationObserver(function(e) {
                t._syncA(), t._syncS(e)
            }), this._observer.observe(this.$element[0], {
                attributes: !0,
                childList: !0,
                subtree: !1
            })
        }, r.prototype._registerDataEvents = function() {
            var i = this;
            this.dataAdapter.on("*", function(e, t) {
                i.trigger(e, t)
            })
        }, r.prototype._registerSelectionEvents = function() {
            var i = this,
                o = ["toggle", "focus"];
            this.selection.on("toggle", function() {
                i.toggleDropdown()
            }), this.selection.on("focus", function(e) {
                i.focus(e)
            }), this.selection.on("*", function(e, t) {
                -1 === o.indexOf(e) && i.trigger(e, t)
            })
        }, r.prototype._registerDropdownEvents = function() {
            var i = this;
            this.dropdown.on("*", function(e, t) {
                i.trigger(e, t)
            })
        }, r.prototype._registerResultsEvents = function() {
            var i = this;
            this.results.on("*", function(e, t) {
                i.trigger(e, t)
            })
        }, r.prototype._registerEvents = function() {
            var i = this;
            this.on("open", function() {
                i.$container[0].classList.add("select2-container--open")
            }), this.on("close", function() {
                i.$container[0].classList.remove("select2-container--open")
            }), this.on("enable", function() {
                i.$container[0].classList.remove("select2-container--disabled")
            }), this.on("disable", function() {
                i.$container[0].classList.add("select2-container--disabled")
            }), this.on("blur", function() {
                i.$container[0].classList.remove("select2-container--focus")
            }), this.on("query", function(t) {
                i.isOpen() || i.trigger("open", {}), this.dataAdapter.query(t, function(e) {
                    i.trigger("results:all", {
                        data: e,
                        query: t
                    })
                })
            }), this.on("query:append", function(t) {
                this.dataAdapter.query(t, function(e) {
                    i.trigger("results:append", {
                        data: e,
                        query: t
                    })
                })
            }), this.on("keypress", function(e) {
                var t = e.which;
                i.isOpen() ? t === o.ESC || t === o.UP && e.altKey ? (i.close(e), e.preventDefault()) : t === o.ENTER || t === o.TAB ? (i.trigger("results:select", {}), e.preventDefault()) : t === o.SPACE && e.ctrlKey ? (i.trigger("results:toggle", {}), e.preventDefault()) : t === o.UP ? (i.trigger("results:previous", {}), e.preventDefault()) : t === o.DOWN && (i.trigger("results:next", {}), e.preventDefault()) : (t === o.ENTER || t === o.SPACE || t === o.DOWN && e.altKey) && (i.open(), e.preventDefault())
            })
        }, r.prototype._syncAttributes = function() {
            this.options.set("disabled", this.$element.prop("disabled")), this.isDisabled() ? (this.isOpen() && this.close(), this.trigger("disable", {})) : this.trigger("enable", {})
        }, r.prototype._isChangeMutation = function(e) {
            var t = this;
            if (e.addedNodes && 0 < e.addedNodes.length) {
                for (var i = 0; i < e.addedNodes.length; i++)
                    if (e.addedNodes[i].selected) return !0
            } else {
                if (e.removedNodes && 0 < e.removedNodes.length) return !0;
                if (Array.isArray(e)) return e.some(function(e) {
                    return t._isChangeMutation(e)
                })
            }
            return !1
        }, r.prototype._syncSubtree = function(e) {
            var e = this._isChangeMutation(e),
                t = this;
            e && this.dataAdapter.current(function(e) {
                t.trigger("selection:update", {
                    data: e
                })
            })
        }, r.prototype.trigger = function(e, t) {
            var i = r.__super__.trigger,
                o = {
                    open: "opening",
                    close: "closing",
                    select: "selecting",
                    unselect: "unselecting",
                    clear: "clearing"
                };
            if (void 0 === t && (t = {}), e in o) {
                var n = {
                    prevented: !1,
                    name: e,
                    args: t
                };
                if (i.call(this, o[e], n), n.prevented) return void(t.prevented = !0)
            }
            i.call(this, e, t)
        }, r.prototype.toggleDropdown = function() {
            this.isDisabled() || (this.isOpen() ? this.close() : this.open())
        }, r.prototype.open = function() {
            this.isOpen() || this.isDisabled() || this.trigger("query", {})
        }, r.prototype.close = function(e) {
            this.isOpen() && this.trigger("close", {
                originalEvent: e
            })
        }, r.prototype.isEnabled = function() {
            return !this.isDisabled()
        }, r.prototype.isDisabled = function() {
            return this.options.get("disabled")
        }, r.prototype.isOpen = function() {
            return this.$container[0].classList.contains("select2-container--open")
        }, r.prototype.hasFocus = function() {
            return this.$container[0].classList.contains("select2-container--focus")
        }, r.prototype.focus = function(e) {
            this.hasFocus() || (this.$container[0].classList.add("select2-container--focus"), this.trigger("focus", {}))
        }, r.prototype.enable = function(e) {
            this.options.get("debug") && window.console && console.warn && console.warn('Select2: The `select2("enable")` method has been deprecated and will be removed in later Select2 versions. Use $element.prop("disabled") instead.');
            e = !(e = null != e && 0 !== e.length ? e : [!0])[0];
            this.$element.prop("disabled", e)
        }, r.prototype.data = function() {
            this.options.get("debug") && 0 < arguments.length && window.console && console.warn && console.warn('Select2: Data can no longer be set using `select2("data")`. You should consider setting the value instead using `$element.val()`.');
            var t = [];
            return this.dataAdapter.current(function(e) {
                t = e
            }), t
        }, r.prototype.val = function(e) {
            if (this.options.get("debug") && window.console && console.warn && console.warn('Select2: The `select2("val")` method has been deprecated and will be removed in later Select2 versions. Use $element.val() instead.'), null == e || 0 === e.length) return this.$element.val();
            e = e[0];
            Array.isArray(e) && (e = e.map(function(e) {
                return e.toString()
            })), this.$element.val(e).trigger("input").trigger("change")
        }, r.prototype.destroy = function() {
            s.RemoveData(this.$container[0]), this.$container.remove(), this._observer.disconnect(), this._observer = null, this._syncA = null, this._syncS = null, this.$element.off(".select2"), this.$element.attr("tabindex", s.GetData(this.$element[0], "old-tabindex")), this.$element[0].classList.remove("select2-hidden-accessible"), this.$element.attr("aria-hidden", "false"), s.RemoveData(this.$element[0]), this.$element.removeData("select2"), this.dataAdapter.destroy(), this.selection.destroy(), this.dropdown.destroy(), this.results.destroy(), this.dataAdapter = null, this.selection = null, this.dropdown = null, this.results = null
        }, r.prototype.render = function() {
            var e = t('<span class="select2 select2-container"><span class="selection"></span><span class="dropdown-wrapper" aria-hidden="true"></span></span>');
            return e.attr("dir", this.options.get("dir")), this.$container = e, this.$container[0].classList.add("select2-container--" + this.options.get("theme")), s.StoreData(e[0], "element", this.$element), e
        }, r
    }), e.define("jquery-mousewheel", ["jquery"], function(e) {
        return e
    }), e.define("jquery.select2", ["jquery", "jquery-mousewheel", "./select2/core", "./select2/defaults", "./select2/utils"], function(n, e, s, t, r) {
        var a;
        return null == n.fn.select2 && (a = ["open", "close", "destroy"], n.fn.select2 = function(t) {
            if ("object" == typeof(t = t || {})) return this.each(function() {
                var e = n.extend(!0, {}, t);
                new s(n(this), e)
            }), this;
            var i, o;
            if ("string" == typeof t) return o = Array.prototype.slice.call(arguments, 1), this.each(function() {
                var e = r.GetData(this, "select2");
                null == e && window.console && console.error && console.error("The select2('" + t + "') method was called on an element that is not using Select2."), i = e[t].apply(e, o)
            }), -1 < a.indexOf(t) ? this : i;
            throw new Error("Invalid arguments for Select2: " + t)
        }), null == n.fn.select2.defaults && (n.fn.select2.defaults = t), s
    });
    var e, i, p, s, r, h, f, m, g, v, y, o, n, w, a = {
        define: e.define,
        require: e.require
    };

    function b(e, t) {
        return o.call(e, t)
    }

    function l(e, t) {
        var i, o, n, s, r, a, l, c, d, u, p = t && t.split("/"),
            h = v.map,
            f = h && h["*"] || {};
        if (e) {
            for (t = (e = e.split("/")).length - 1, v.nodeIdCompat && w.test(e[t]) && (e[t] = e[t].replace(w, "")), "." === e[0].charAt(0) && p && (e = p.slice(0, p.length - 1).concat(e)), c = 0; c < e.length; c++) "." === (u = e[c]) ? (e.splice(c, 1), --c) : ".." !== u || 0 === c || 1 === c && ".." === e[2] || ".." === e[c - 1] || 0 < c && (e.splice(c - 1, 2), c -= 2);
            e = e.join("/")
        }
        if ((p || f) && h) {
            for (c = (i = e.split("/")).length; 0 < c; --c) {
                if (o = i.slice(0, c).join("/"), p)
                    for (d = p.length; 0 < d; --d)
                        if (n = (n = h[p.slice(0, d).join("/")]) && n[o]) {
                            s = n, r = c;
                            break
                        } if (s) break;
                !a && f && f[o] && (a = f[o], l = c)
            }!s && a && (s = a, r = l), s && (i.splice(0, r, s), e = i.join("/"))
        }
        return e
    }

    function k(t, i) {
        return function() {
            var e = n.call(arguments, 0);
            return "string" != typeof e[0] && 1 === e.length && e.push(null), r.apply(p, e.concat([t, i]))
        }
    }

    function C(e) {
        var t;
        if (b(g, e) && (t = g[e], delete g[e], y[e] = !0, s.apply(p, t)), b(m, e) || b(y, e)) return m[e];
        throw new Error("No " + e)
    }

    function c(e) {
        var t, i = e ? e.indexOf("!") : -1;
        return -1 < i && (t = e.substring(0, i), e = e.substring(i + 1, e.length)), [t, e]
    }

    function S(e) {
        return e ? c(e) : []
    }
    var d = a.require("jquery.select2");
    return t.fn.select2.amd = a, d
}),
function(e) {
    "use strict";
    "function" == typeof define && define.amd ? define(["jquery"], e) : "undefined" != typeof exports ? module.exports = e(require("jquery")) : e(jQuery)
}(function(c) {
    "use strict";
    var o, r = window.Slick || {};
    o = 0, (r = function(e, t) {
        var i = this;
        i.defaults = {
            accessibility: !0,
            adaptiveHeight: !1,
            appendArrows: c(e),
            appendDots: c(e),
            arrows: !0,
            asNavFor: null,
            prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
            nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
            autoplay: !1,
            autoplaySpeed: 3e3,
            centerMode: !1,
            centerPadding: "50px",
            cssEase: "ease",
            customPaging: function(e, t) {
                return c('<button type="button" />').text(t + 1)
            },
            dots: !1,
            dotsClass: "slick-dots",
            draggable: !0,
            easing: "linear",
            edgeFriction: .35,
            fade: !1,
            focusOnSelect: !1,
            focusOnChange: !1,
            infinite: !0,
            initialSlide: 0,
            lazyLoad: "ondemand",
            mobileFirst: !1,
            pauseOnHover: !0,
            pauseOnFocus: !0,
            pauseOnDotsHover: !1,
            respondTo: "window",
            responsive: null,
            rows: 1,
            rtl: !1,
            slide: "",
            slidesPerRow: 1,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 500,
            swipe: !0,
            swipeToSlide: !1,
            touchMove: !0,
            touchThreshold: 5,
            useCSS: !0,
            useTransform: !0,
            variableWidth: !1,
            vertical: !1,
            verticalSwiping: !1,
            waitForAnimate: !0,
            zIndex: 1e3
        }, i.initials = {
            animating: !1,
            dragging: !1,
            autoPlayTimer: null,
            currentDirection: 0,
            currentLeft: null,
            currentSlide: 0,
            direction: 1,
            $dots: null,
            listWidth: null,
            listHeight: null,
            loadIndex: 0,
            $nextArrow: null,
            $prevArrow: null,
            scrolling: !1,
            slideCount: null,
            slideWidth: null,
            $slideTrack: null,
            $slides: null,
            sliding: !1,
            slideOffset: 0,
            swipeLeft: null,
            swiping: !1,
            $list: null,
            touchObject: {},
            transformsEnabled: !1,
            unslicked: !1
        }, c.extend(i, i.initials), i.activeBreakpoint = null, i.animType = null, i.animProp = null, i.breakpoints = [], i.breakpointSettings = [], i.cssTransitions = !1, i.focussed = !1, i.interrupted = !1, i.hidden = "hidden", i.paused = !0, i.positionProp = null, i.respondTo = null, i.rowCount = 1, i.shouldClick = !0, i.$slider = c(e), i.$slidesCache = null, i.transformType = null, i.transitionType = null, i.visibilityChange = "visibilitychange", i.windowWidth = 0, i.windowTimer = null, e = c(e).data("slick") || {}, i.options = c.extend({}, i.defaults, t, e), i.currentSlide = i.options.initialSlide, i.originalSettings = i.options, void 0 !== document.mozHidden ? (i.hidden = "mozHidden", i.visibilityChange = "mozvisibilitychange") : void 0 !== document.webkitHidden && (i.hidden = "webkitHidden", i.visibilityChange = "webkitvisibilitychange"), i.autoPlay = c.proxy(i.autoPlay, i), i.autoPlayClear = c.proxy(i.autoPlayClear, i), i.autoPlayIterator = c.proxy(i.autoPlayIterator, i), i.changeSlide = c.proxy(i.changeSlide, i), i.clickHandler = c.proxy(i.clickHandler, i), i.selectHandler = c.proxy(i.selectHandler, i), i.setPosition = c.proxy(i.setPosition, i), i.swipeHandler = c.proxy(i.swipeHandler, i), i.dragHandler = c.proxy(i.dragHandler, i), i.keyHandler = c.proxy(i.keyHandler, i), i.instanceUid = o++, i.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/, i.registerBreakpoints(), i.init(!0)
    }).prototype.activateADA = function() {
        this.$slideTrack.find(".slick-active").attr({
            "aria-hidden": "false"
        }).find("a, input, button, select").attr({
            tabindex: "0"
        })
    }, r.prototype.addSlide = r.prototype.slickAdd = function(e, t, i) {
        var o = this;
        if ("boolean" == typeof t) i = t, t = null;
        else if (t < 0 || t >= o.slideCount) return !1;
        o.unload(), "number" == typeof t ? 0 === t && 0 === o.$slides.length ? c(e).appendTo(o.$slideTrack) : i ? c(e).insertBefore(o.$slides.eq(t)) : c(e).insertAfter(o.$slides.eq(t)) : !0 === i ? c(e).prependTo(o.$slideTrack) : c(e).appendTo(o.$slideTrack), o.$slides = o.$slideTrack.children(this.options.slide), o.$slideTrack.children(this.options.slide).detach(), o.$slideTrack.append(o.$slides), o.$slides.each(function(e, t) {
            c(t).attr("data-slick-index", e)
        }), o.$slidesCache = o.$slides, o.reinit()
    }, r.prototype.animateHeight = function() {
        var e, t = this;
        1 === t.options.slidesToShow && !0 === t.options.adaptiveHeight && !1 === t.options.vertical && (e = t.$slides.eq(t.currentSlide).outerHeight(!0), t.$list.animate({
            height: e
        }, t.options.speed))
    }, r.prototype.animateSlide = function(e, t) {
        var i = {},
            o = this;
        o.animateHeight(), !0 === o.options.rtl && !1 === o.options.vertical && (e = -e), !1 === o.transformsEnabled ? !1 === o.options.vertical ? o.$slideTrack.animate({
            left: e
        }, o.options.speed, o.options.easing, t) : o.$slideTrack.animate({
            top: e
        }, o.options.speed, o.options.easing, t) : !1 === o.cssTransitions ? (!0 === o.options.rtl && (o.currentLeft = -o.currentLeft), c({
            animStart: o.currentLeft
        }).animate({
            animStart: e
        }, {
            duration: o.options.speed,
            easing: o.options.easing,
            step: function(e) {
                e = Math.ceil(e), !1 === o.options.vertical ? i[o.animType] = "translate(" + e + "px, 0px)" : i[o.animType] = "translate(0px," + e + "px)", o.$slideTrack.css(i)
            },
            complete: function() {
                t && t.call()
            }
        })) : (o.applyTransition(), e = Math.ceil(e), !1 === o.options.vertical ? i[o.animType] = "translate3d(" + e + "px, 0px, 0px)" : i[o.animType] = "translate3d(0px," + e + "px, 0px)", o.$slideTrack.css(i), t && setTimeout(function() {
            o.disableTransition(), t.call()
        }, o.options.speed))
    }, r.prototype.getNavTarget = function() {
        var e = this.options.asNavFor;
        return e = e && null !== e ? c(e).not(this.$slider) : e
    }, r.prototype.asNavFor = function(t) {
        var e = this.getNavTarget();
        null !== e && "object" == typeof e && e.each(function() {
            var e = c(this).slick("getSlick");
            e.unslicked || e.slideHandler(t, !0)
        })
    }, r.prototype.applyTransition = function(e) {
        var t = this,
            i = {};
        !1 === t.options.fade ? i[t.transitionType] = t.transformType + " " + t.options.speed + "ms " + t.options.cssEase : i[t.transitionType] = "opacity " + t.options.speed + "ms " + t.options.cssEase, (!1 === t.options.fade ? t.$slideTrack : t.$slides.eq(e)).css(i)
    }, r.prototype.autoPlay = function() {
        var e = this;
        e.autoPlayClear(), e.slideCount > e.options.slidesToShow && (e.autoPlayTimer = setInterval(e.autoPlayIterator, e.options.autoplaySpeed))
    }, r.prototype.autoPlayClear = function() {
        this.autoPlayTimer && clearInterval(this.autoPlayTimer)
    }, r.prototype.autoPlayIterator = function() {
        var e = this,
            t = e.currentSlide + e.options.slidesToScroll;
        e.paused || e.interrupted || e.focussed || (!1 === e.options.infinite && (1 === e.direction && e.currentSlide + 1 === e.slideCount - 1 ? e.direction = 0 : 0 === e.direction && (t = e.currentSlide - e.options.slidesToScroll, e.currentSlide - 1 == 0 && (e.direction = 1))), e.slideHandler(t))
    }, r.prototype.buildArrows = function() {
        var e = this;
        !0 === e.options.arrows && (e.$prevArrow = c(e.options.prevArrow).addClass("slick-arrow"), e.$nextArrow = c(e.options.nextArrow).addClass("slick-arrow"), e.slideCount > e.options.slidesToShow ? (e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.prependTo(e.options.appendArrows), e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.appendTo(e.options.appendArrows), !0 !== e.options.infinite && e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")) : e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({
            "aria-disabled": "true",
            tabindex: "-1"
        }))
    }, r.prototype.buildDots = function() {
        var e, t, i = this;
        if (!0 === i.options.dots && i.slideCount > i.options.slidesToShow) {
            for (i.$slider.addClass("slick-dotted"), t = c("<ul />").addClass(i.options.dotsClass), e = 0; e <= i.getDotCount(); e += 1) t.append(c("<li />").append(i.options.customPaging.call(this, i, e)));
            i.$dots = t.appendTo(i.options.appendDots), i.$dots.find("li").first().addClass("slick-active")
        }
    }, r.prototype.buildOut = function() {
        var e = this;
        e.$slides = e.$slider.children(e.options.slide + ":not(.slick-cloned)").addClass("slick-slide"), e.slideCount = e.$slides.length, e.$slides.each(function(e, t) {
            c(t).attr("data-slick-index", e).data("originalStyling", c(t).attr("style") || "")
        }), e.$slider.addClass("slick-slider"), e.$slideTrack = 0 === e.slideCount ? c('<div class="slick-track"/>').appendTo(e.$slider) : e.$slides.wrapAll('<div class="slick-track"/>').parent(), e.$list = e.$slideTrack.wrap('<div class="slick-list"/>').parent(), e.$slideTrack.css("opacity", 0), !0 !== e.options.centerMode && !0 !== e.options.swipeToSlide || (e.options.slidesToScroll = 1), c("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"), e.setupInfinite(), e.buildArrows(), e.buildDots(), e.updateDots(), e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0), !0 === e.options.draggable && e.$list.addClass("draggable")
    }, r.prototype.buildRows = function() {
        var e, t, i, o = this,
            n = document.createDocumentFragment(),
            s = o.$slider.children();
        if (0 < o.options.rows) {
            for (i = o.options.slidesPerRow * o.options.rows, t = Math.ceil(s.length / i), e = 0; e < t; e++) {
                for (var r = document.createElement("div"), a = 0; a < o.options.rows; a++) {
                    for (var l = document.createElement("div"), c = 0; c < o.options.slidesPerRow; c++) {
                        var d = e * i + (a * o.options.slidesPerRow + c);
                        s.get(d) && l.appendChild(s.get(d))
                    }
                    r.appendChild(l)
                }
                n.appendChild(r)
            }
            o.$slider.empty().append(n), o.$slider.children().children().children().css({
                width: 100 / o.options.slidesPerRow + "%",
                display: "inline-block"
            })
        }
    }, r.prototype.checkResponsive = function(e, t) {
        var i, o, n, s = this,
            r = !1,
            a = s.$slider.width(),
            l = window.innerWidth || c(window).width();
        if ("window" === s.respondTo ? n = l : "slider" === s.respondTo ? n = a : "min" === s.respondTo && (n = Math.min(l, a)), s.options.responsive && s.options.responsive.length && null !== s.options.responsive) {
            for (i in o = null, s.breakpoints) s.breakpoints.hasOwnProperty(i) && (!1 === s.originalSettings.mobileFirst ? n < s.breakpoints[i] && (o = s.breakpoints[i]) : n > s.breakpoints[i] && (o = s.breakpoints[i]));
            null !== o ? null !== s.activeBreakpoint && o === s.activeBreakpoint && !t || (s.activeBreakpoint = o, "unslick" === s.breakpointSettings[o] ? s.unslick(o) : (s.options = c.extend({}, s.originalSettings, s.breakpointSettings[o]), !0 === e && (s.currentSlide = s.options.initialSlide), s.refresh(e)), r = o) : null !== s.activeBreakpoint && (s.activeBreakpoint = null, s.options = s.originalSettings, !0 === e && (s.currentSlide = s.options.initialSlide), s.refresh(e), r = o), e || !1 === r || s.$slider.trigger("breakpoint", [s, r])
        }
    }, r.prototype.changeSlide = function(e, t) {
        var i, o = this,
            n = c(e.currentTarget);
        switch (n.is("a") && e.preventDefault(), n.is("li") || (n = n.closest("li")), i = o.slideCount % o.options.slidesToScroll != 0 ? 0 : (o.slideCount - o.currentSlide) % o.options.slidesToScroll, e.data.message) {
            case "previous":
                s = 0 == i ? o.options.slidesToScroll : o.options.slidesToShow - i, o.slideCount > o.options.slidesToShow && o.slideHandler(o.currentSlide - s, !1, t);
                break;
            case "next":
                s = 0 == i ? o.options.slidesToScroll : i, o.slideCount > o.options.slidesToShow && o.slideHandler(o.currentSlide + s, !1, t);
                break;
            case "index":
                var s = 0 === e.data.index ? 0 : e.data.index || n.index() * o.options.slidesToScroll;
                o.slideHandler(o.checkNavigable(s), !1, t), n.children().trigger("focus");
                break;
            default:
                return
        }
    }, r.prototype.checkNavigable = function(e) {
        var t = this.getNavigableIndexes(),
            i = 0;
        if (e > t[t.length - 1]) e = t[t.length - 1];
        else
            for (var o in t) {
                if (e < t[o]) {
                    e = i;
                    break
                }
                i = t[o]
            }
        return e
    }, r.prototype.cleanUpEvents = function() {
        var e = this;
        e.options.dots && null !== e.$dots && (c("li", e.$dots).off("click.slick", e.changeSlide).off("mouseenter.slick", c.proxy(e.interrupt, e, !0)).off("mouseleave.slick", c.proxy(e.interrupt, e, !1)), !0 === e.options.accessibility && e.$dots.off("keydown.slick", e.keyHandler)), e.$slider.off("focus.slick blur.slick"), !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide), e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide), !0 === e.options.accessibility && (e.$prevArrow && e.$prevArrow.off("keydown.slick", e.keyHandler), e.$nextArrow && e.$nextArrow.off("keydown.slick", e.keyHandler))), e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler), e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler), e.$list.off("touchend.slick mouseup.slick", e.swipeHandler), e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler), e.$list.off("click.slick", e.clickHandler), c(document).off(e.visibilityChange, e.visibility), e.cleanUpSlideEvents(), !0 === e.options.accessibility && e.$list.off("keydown.slick", e.keyHandler), !0 === e.options.focusOnSelect && c(e.$slideTrack).children().off("click.slick", e.selectHandler), c(window).off("orientationchange.slick.slick-" + e.instanceUid, e.orientationChange), c(window).off("resize.slick.slick-" + e.instanceUid, e.resize), c("[draggable!=true]", e.$slideTrack).off("dragstart", e.preventDefault), c(window).off("load.slick.slick-" + e.instanceUid, e.setPosition)
    }, r.prototype.cleanUpSlideEvents = function() {
        var e = this;
        e.$list.off("mouseenter.slick", c.proxy(e.interrupt, e, !0)), e.$list.off("mouseleave.slick", c.proxy(e.interrupt, e, !1))
    }, r.prototype.cleanUpRows = function() {
        var e;
        0 < this.options.rows && ((e = this.$slides.children().children()).removeAttr("style"), this.$slider.empty().append(e))
    }, r.prototype.clickHandler = function(e) {
        !1 === this.shouldClick && (e.stopImmediatePropagation(), e.stopPropagation(), e.preventDefault())
    }, r.prototype.destroy = function(e) {
        var t = this;
        t.autoPlayClear(), t.touchObject = {}, t.cleanUpEvents(), c(".slick-cloned", t.$slider).detach(), t.$dots && t.$dots.remove(), t.$prevArrow && t.$prevArrow.length && (t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove()), t.$nextArrow && t.$nextArrow.length && (t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove()), t.$slides && (t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function() {
            c(this).attr("style", c(this).data("originalStyling"))
        }), t.$slideTrack.children(this.options.slide).detach(), t.$slideTrack.detach(), t.$list.detach(), t.$slider.append(t.$slides)), t.cleanUpRows(), t.$slider.removeClass("slick-slider"), t.$slider.removeClass("slick-initialized"), t.$slider.removeClass("slick-dotted"), t.unslicked = !0, e || t.$slider.trigger("destroy", [t])
    }, r.prototype.disableTransition = function(e) {
        var t = {};
        t[this.transitionType] = "", (!1 === this.options.fade ? this.$slideTrack : this.$slides.eq(e)).css(t)
    }, r.prototype.fadeSlide = function(e, t) {
        var i = this;
        !1 === i.cssTransitions ? (i.$slides.eq(e).css({
            zIndex: i.options.zIndex
        }), i.$slides.eq(e).animate({
            opacity: 1
        }, i.options.speed, i.options.easing, t)) : (i.applyTransition(e), i.$slides.eq(e).css({
            opacity: 1,
            zIndex: i.options.zIndex
        }), t && setTimeout(function() {
            i.disableTransition(e), t.call()
        }, i.options.speed))
    }, r.prototype.fadeSlideOut = function(e) {
        var t = this;
        !1 === t.cssTransitions ? t.$slides.eq(e).animate({
            opacity: 0,
            zIndex: t.options.zIndex - 2
        }, t.options.speed, t.options.easing) : (t.applyTransition(e), t.$slides.eq(e).css({
            opacity: 0,
            zIndex: t.options.zIndex - 2
        }))
    }, r.prototype.filterSlides = r.prototype.slickFilter = function(e) {
        var t = this;
        null !== e && (t.$slidesCache = t.$slides, t.unload(), t.$slideTrack.children(this.options.slide).detach(), t.$slidesCache.filter(e).appendTo(t.$slideTrack), t.reinit())
    }, r.prototype.focusHandler = function() {
        var i = this;
        i.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*", function(e) {
            e.stopImmediatePropagation();
            var t = c(this);
            setTimeout(function() {
                i.options.pauseOnFocus && (i.focussed = t.is(":focus"), i.autoPlay())
            }, 0)
        })
    }, r.prototype.getCurrent = r.prototype.slickCurrentSlide = function() {
        return this.currentSlide
    }, r.prototype.getDotCount = function() {
        var e = this,
            t = 0,
            i = 0,
            o = 0;
        if (!0 === e.options.infinite)
            if (e.slideCount <= e.options.slidesToShow) ++o;
            else
                for (; t < e.slideCount;) ++o, t = i + e.options.slidesToScroll, i += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
        else if (!0 === e.options.centerMode) o = e.slideCount;
        else if (e.options.asNavFor)
            for (; t < e.slideCount;) ++o, t = i + e.options.slidesToScroll, i += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
        else o = 1 + Math.ceil((e.slideCount - e.options.slidesToShow) / e.options.slidesToScroll);
        return o - 1
    }, r.prototype.getLeft = function(e) {
        var t, i, o = this,
            n = 0;
        return o.slideOffset = 0, t = o.$slides.first().outerHeight(!0), !0 === o.options.infinite ? (o.slideCount > o.options.slidesToShow && (o.slideOffset = o.slideWidth * o.options.slidesToShow * -1, i = -1, !0 === o.options.vertical && !0 === o.options.centerMode && (2 === o.options.slidesToShow ? i = -1.5 : 1 === o.options.slidesToShow && (i = -2)), n = t * o.options.slidesToShow * i), o.slideCount % o.options.slidesToScroll != 0 && e + o.options.slidesToScroll > o.slideCount && o.slideCount > o.options.slidesToShow && (n = e > o.slideCount ? (o.slideOffset = (o.options.slidesToShow - (e - o.slideCount)) * o.slideWidth * -1, (o.options.slidesToShow - (e - o.slideCount)) * t * -1) : (o.slideOffset = o.slideCount % o.options.slidesToScroll * o.slideWidth * -1, o.slideCount % o.options.slidesToScroll * t * -1))) : e + o.options.slidesToShow > o.slideCount && (o.slideOffset = (e + o.options.slidesToShow - o.slideCount) * o.slideWidth, n = (e + o.options.slidesToShow - o.slideCount) * t), o.slideCount <= o.options.slidesToShow && (n = o.slideOffset = 0), !0 === o.options.centerMode && o.slideCount <= o.options.slidesToShow ? o.slideOffset = o.slideWidth * Math.floor(o.options.slidesToShow) / 2 - o.slideWidth * o.slideCount / 2 : !0 === o.options.centerMode && !0 === o.options.infinite ? o.slideOffset += o.slideWidth * Math.floor(o.options.slidesToShow / 2) - o.slideWidth : !0 === o.options.centerMode && (o.slideOffset = 0, o.slideOffset += o.slideWidth * Math.floor(o.options.slidesToShow / 2)), i = !1 === o.options.vertical ? e * o.slideWidth * -1 + o.slideOffset : e * t * -1 + n, !0 === o.options.variableWidth && (t = o.slideCount <= o.options.slidesToShow || !1 === o.options.infinite ? o.$slideTrack.children(".slick-slide").eq(e) : o.$slideTrack.children(".slick-slide").eq(e + o.options.slidesToShow), i = !0 === o.options.rtl ? t[0] ? -1 * (o.$slideTrack.width() - t[0].offsetLeft - t.width()) : 0 : t[0] ? -1 * t[0].offsetLeft : 0, !0 === o.options.centerMode && (t = o.slideCount <= o.options.slidesToShow || !1 === o.options.infinite ? o.$slideTrack.children(".slick-slide").eq(e) : o.$slideTrack.children(".slick-slide").eq(e + o.options.slidesToShow + 1), i = !0 === o.options.rtl ? t[0] ? -1 * (o.$slideTrack.width() - t[0].offsetLeft - t.width()) : 0 : t[0] ? -1 * t[0].offsetLeft : 0, i += (o.$list.width() - t.outerWidth()) / 2)), i
    }, r.prototype.getOption = r.prototype.slickGetOption = function(e) {
        return this.options[e]
    }, r.prototype.getNavigableIndexes = function() {
        for (var e = this, t = 0, i = 0, o = [], n = !1 === e.options.infinite ? e.slideCount : (t = -1 * e.options.slidesToScroll, i = -1 * e.options.slidesToScroll, 2 * e.slideCount); t < n;) o.push(t), t = i + e.options.slidesToScroll, i += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
        return o
    }, r.prototype.getSlick = function() {
        return this
    }, r.prototype.getSlideCount = function() {
        var i, o = this,
            n = !0 === o.options.centerMode ? o.slideWidth * Math.floor(o.options.slidesToShow / 2) : 0;
        return !0 === o.options.swipeToSlide ? (o.$slideTrack.find(".slick-slide").each(function(e, t) {
            if (t.offsetLeft - n + c(t).outerWidth() / 2 > -1 * o.swipeLeft) return i = t, !1
        }), Math.abs(c(i).attr("data-slick-index") - o.currentSlide) || 1) : o.options.slidesToScroll
    }, r.prototype.goTo = r.prototype.slickGoTo = function(e, t) {
        this.changeSlide({
            data: {
                message: "index",
                index: parseInt(e)
            }
        }, t)
    }, r.prototype.init = function(e) {
        var t = this;
        c(t.$slider).hasClass("slick-initialized") || (c(t.$slider).addClass("slick-initialized"), t.buildRows(), t.buildOut(), t.setProps(), t.startLoad(), t.loadSlider(), t.initializeEvents(), t.updateArrows(), t.updateDots(), t.checkResponsive(!0), t.focusHandler()), e && t.$slider.trigger("init", [t]), !0 === t.options.accessibility && t.initADA(), t.options.autoplay && (t.paused = !1, t.autoPlay())
    }, r.prototype.initADA = function() {
        var i = this,
            o = Math.ceil(i.slideCount / i.options.slidesToShow),
            n = i.getNavigableIndexes().filter(function(e) {
                return 0 <= e && e < i.slideCount
            });
        i.$slides.add(i.$slideTrack.find(".slick-cloned")).attr({
            "aria-hidden": "true",
            tabindex: "-1"
        }).find("a, input, button, select").attr({
            tabindex: "-1"
        }), null !== i.$dots && (i.$slides.not(i.$slideTrack.find(".slick-cloned")).each(function(e) {
            var t = n.indexOf(e);
            c(this).attr({
                role: "tabpanel",
                id: "slick-slide" + i.instanceUid + e,
                tabindex: -1
            }), -1 !== t && (e = "slick-slide-control" + i.instanceUid + t, c("#" + e).length && c(this).attr({
                "aria-describedby": e
            }))
        }), i.$dots.attr("role", "tablist").find("li").each(function(e) {
            var t = n[e];
            c(this).attr({
                role: "presentation"
            }), c(this).find("button").first().attr({
                role: "tab",
                id: "slick-slide-control" + i.instanceUid + e,
                "aria-controls": "slick-slide" + i.instanceUid + t,
                "aria-label": e + 1 + " of " + o,
                "aria-selected": null,
                tabindex: "-1"
            })
        }).eq(i.currentSlide).find("button").attr({
            "aria-selected": "true",
            tabindex: "0"
        }).end());
        for (var e = i.currentSlide, t = e + i.options.slidesToShow; e < t; e++) i.options.focusOnChange ? i.$slides.eq(e).attr({
            tabindex: "0"
        }) : i.$slides.eq(e).removeAttr("tabindex");
        i.activateADA()
    }, r.prototype.initArrowEvents = function() {
        var e = this;
        !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow.off("click.slick").on("click.slick", {
            message: "previous"
        }, e.changeSlide), e.$nextArrow.off("click.slick").on("click.slick", {
            message: "next"
        }, e.changeSlide), !0 === e.options.accessibility && (e.$prevArrow.on("keydown.slick", e.keyHandler), e.$nextArrow.on("keydown.slick", e.keyHandler)))
    }, r.prototype.initDotEvents = function() {
        var e = this;
        !0 === e.options.dots && e.slideCount > e.options.slidesToShow && (c("li", e.$dots).on("click.slick", {
            message: "index"
        }, e.changeSlide), !0 === e.options.accessibility && e.$dots.on("keydown.slick", e.keyHandler)), !0 === e.options.dots && !0 === e.options.pauseOnDotsHover && e.slideCount > e.options.slidesToShow && c("li", e.$dots).on("mouseenter.slick", c.proxy(e.interrupt, e, !0)).on("mouseleave.slick", c.proxy(e.interrupt, e, !1))
    }, r.prototype.initSlideEvents = function() {
        var e = this;
        e.options.pauseOnHover && (e.$list.on("mouseenter.slick", c.proxy(e.interrupt, e, !0)), e.$list.on("mouseleave.slick", c.proxy(e.interrupt, e, !1)))
    }, r.prototype.initializeEvents = function() {
        var e = this;
        e.initArrowEvents(), e.initDotEvents(), e.initSlideEvents(), e.$list.on("touchstart.slick mousedown.slick", {
            action: "start"
        }, e.swipeHandler), e.$list.on("touchmove.slick mousemove.slick", {
            action: "move"
        }, e.swipeHandler), e.$list.on("touchend.slick mouseup.slick", {
            action: "end"
        }, e.swipeHandler), e.$list.on("touchcancel.slick mouseleave.slick", {
            action: "end"
        }, e.swipeHandler), e.$list.on("click.slick", e.clickHandler), c(document).on(e.visibilityChange, c.proxy(e.visibility, e)), !0 === e.options.accessibility && e.$list.on("keydown.slick", e.keyHandler), !0 === e.options.focusOnSelect && c(e.$slideTrack).children().on("click.slick", e.selectHandler), c(window).on("orientationchange.slick.slick-" + e.instanceUid, c.proxy(e.orientationChange, e)), c(window).on("resize.slick.slick-" + e.instanceUid, c.proxy(e.resize, e)), c("[draggable!=true]", e.$slideTrack).on("dragstart", e.preventDefault), c(window).on("load.slick.slick-" + e.instanceUid, e.setPosition), c(e.setPosition)
    }, r.prototype.initUI = function() {
        var e = this;
        !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow.show(), e.$nextArrow.show()), !0 === e.options.dots && e.slideCount > e.options.slidesToShow && e.$dots.show()
    }, r.prototype.keyHandler = function(e) {
        var t = this;
        e.target.tagName.match("TEXTAREA|INPUT|SELECT") || (37 === e.keyCode && !0 === t.options.accessibility ? t.changeSlide({
            data: {
                message: !0 === t.options.rtl ? "next" : "previous"
            }
        }) : 39 === e.keyCode && !0 === t.options.accessibility && t.changeSlide({
            data: {
                message: !0 === t.options.rtl ? "previous" : "next"
            }
        }))
    }, r.prototype.lazyLoad = function() {
        var e, t, i, s = this;

        function o(e) {
            c("img[data-lazy]", e).each(function() {
                var e = c(this),
                    t = c(this).attr("data-lazy"),
                    i = c(this).attr("data-srcset"),
                    o = c(this).attr("data-sizes") || s.$slider.attr("data-sizes"),
                    n = document.createElement("img");
                n.onload = function() {
                    e.animate({
                        opacity: 0
                    }, 100, function() {
                        i && (e.attr("srcset", i), o && e.attr("sizes", o)), e.attr("src", t).animate({
                            opacity: 1
                        }, 200, function() {
                            e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")
                        }), s.$slider.trigger("lazyLoaded", [s, e, t])
                    })
                }, n.onerror = function() {
                    e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), s.$slider.trigger("lazyLoadError", [s, e, t])
                }, n.src = t
            })
        }
        if (!0 === s.options.centerMode ? i = !0 === s.options.infinite ? (t = s.currentSlide + (s.options.slidesToShow / 2 + 1)) + s.options.slidesToShow + 2 : (t = Math.max(0, s.currentSlide - (s.options.slidesToShow / 2 + 1)), s.options.slidesToShow / 2 + 1 + 2 + s.currentSlide) : (t = s.options.infinite ? s.options.slidesToShow + s.currentSlide : s.currentSlide, i = Math.ceil(t + s.options.slidesToShow), !0 === s.options.fade && (0 < t && t--, i <= s.slideCount && i++)), e = s.$slider.find(".slick-slide").slice(t, i), "anticipated" === s.options.lazyLoad)
            for (var n = t - 1, r = i, a = s.$slider.find(".slick-slide"), l = 0; l < s.options.slidesToScroll; l++) n < 0 && (n = s.slideCount - 1), e = (e = e.add(a.eq(n))).add(a.eq(r)), n--, r++;
        o(e), s.slideCount <= s.options.slidesToShow ? o(s.$slider.find(".slick-slide")) : s.currentSlide >= s.slideCount - s.options.slidesToShow ? o(s.$slider.find(".slick-cloned").slice(0, s.options.slidesToShow)) : 0 === s.currentSlide && o(s.$slider.find(".slick-cloned").slice(-1 * s.options.slidesToShow))
    }, r.prototype.loadSlider = function() {
        var e = this;
        e.setPosition(), e.$slideTrack.css({
            opacity: 1
        }), e.$slider.removeClass("slick-loading"), e.initUI(), "progressive" === e.options.lazyLoad && e.progressiveLazyLoad()
    }, r.prototype.next = r.prototype.slickNext = function() {
        this.changeSlide({
            data: {
                message: "next"
            }
        })
    }, r.prototype.orientationChange = function() {
        this.checkResponsive(), this.setPosition()
    }, r.prototype.pause = r.prototype.slickPause = function() {
        this.autoPlayClear(), this.paused = !0
    }, r.prototype.play = r.prototype.slickPlay = function() {
        var e = this;
        e.autoPlay(), e.options.autoplay = !0, e.paused = !1, e.focussed = !1, e.interrupted = !1
    }, r.prototype.postSlide = function(e) {
        var t = this;
        t.unslicked || (t.$slider.trigger("afterChange", [t, e]), t.animating = !1, t.slideCount > t.options.slidesToShow && t.setPosition(), t.swipeLeft = null, t.options.autoplay && t.autoPlay(), !0 === t.options.accessibility && (t.initADA(), t.options.focusOnChange && c(t.$slides.get(t.currentSlide)).attr("tabindex", 0).focus()))
    }, r.prototype.prev = r.prototype.slickPrev = function() {
        this.changeSlide({
            data: {
                message: "previous"
            }
        })
    }, r.prototype.preventDefault = function(e) {
        e.preventDefault()
    }, r.prototype.progressiveLazyLoad = function(e) {
        e = e || 1;
        var t, i, o, n, s = this,
            r = c("img[data-lazy]", s.$slider);
        r.length ? (t = r.first(), i = t.attr("data-lazy"), o = t.attr("data-srcset"), n = t.attr("data-sizes") || s.$slider.attr("data-sizes"), (r = document.createElement("img")).onload = function() {
            o && (t.attr("srcset", o), n && t.attr("sizes", n)), t.attr("src", i).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"), !0 === s.options.adaptiveHeight && s.setPosition(), s.$slider.trigger("lazyLoaded", [s, t, i]), s.progressiveLazyLoad()
        }, r.onerror = function() {
            e < 3 ? setTimeout(function() {
                s.progressiveLazyLoad(e + 1)
            }, 500) : (t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), s.$slider.trigger("lazyLoadError", [s, t, i]), s.progressiveLazyLoad())
        }, r.src = i) : s.$slider.trigger("allImagesLoaded", [s])
    }, r.prototype.refresh = function(e) {
        var t = this,
            i = t.slideCount - t.options.slidesToShow;
        !t.options.infinite && t.currentSlide > i && (t.currentSlide = i), t.slideCount <= t.options.slidesToShow && (t.currentSlide = 0), i = t.currentSlide, t.destroy(!0), c.extend(t, t.initials, {
            currentSlide: i
        }), t.init(), e || t.changeSlide({
            data: {
                message: "index",
                index: i
            }
        }, !1)
    }, r.prototype.registerBreakpoints = function() {
        var e, t, i, o = this,
            n = o.options.responsive || null;
        if ("array" === c.type(n) && n.length) {
            for (e in o.respondTo = o.options.respondTo || "window", n)
                if (i = o.breakpoints.length - 1, n.hasOwnProperty(e)) {
                    for (t = n[e].breakpoint; 0 <= i;) o.breakpoints[i] && o.breakpoints[i] === t && o.breakpoints.splice(i, 1), i--;
                    o.breakpoints.push(t), o.breakpointSettings[t] = n[e].settings
                } o.breakpoints.sort(function(e, t) {
                return o.options.mobileFirst ? e - t : t - e
            })
        }
    }, r.prototype.reinit = function() {
        var e = this;
        e.$slides = e.$slideTrack.children(e.options.slide).addClass("slick-slide"), e.slideCount = e.$slides.length, e.currentSlide >= e.slideCount && 0 !== e.currentSlide && (e.currentSlide = e.currentSlide - e.options.slidesToScroll), e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0), e.registerBreakpoints(), e.setProps(), e.setupInfinite(), e.buildArrows(), e.updateArrows(), e.initArrowEvents(), e.buildDots(), e.updateDots(), e.initDotEvents(), e.cleanUpSlideEvents(), e.initSlideEvents(), e.checkResponsive(!1, !0), !0 === e.options.focusOnSelect && c(e.$slideTrack).children().on("click.slick", e.selectHandler), e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0), e.setPosition(), e.focusHandler(), e.paused = !e.options.autoplay, e.autoPlay(), e.$slider.trigger("reInit", [e])
    }, r.prototype.resize = function() {
        var e = this;
        c(window).width() !== e.windowWidth && (clearTimeout(e.windowDelay), e.windowDelay = window.setTimeout(function() {
            e.windowWidth = c(window).width(), e.checkResponsive(), e.unslicked || e.setPosition()
        }, 50))
    }, r.prototype.removeSlide = r.prototype.slickRemove = function(e, t, i) {
        var o = this;
        if (e = "boolean" == typeof e ? !0 === (t = e) ? 0 : o.slideCount - 1 : !0 === t ? --e : e, o.slideCount < 1 || e < 0 || e > o.slideCount - 1) return !1;
        o.unload(), (!0 === i ? o.$slideTrack.children() : o.$slideTrack.children(this.options.slide).eq(e)).remove(), o.$slides = o.$slideTrack.children(this.options.slide), o.$slideTrack.children(this.options.slide).detach(), o.$slideTrack.append(o.$slides), o.$slidesCache = o.$slides, o.reinit()
    }, r.prototype.setCSS = function(e) {
        var t, i, o = this,
            n = {};
        !0 === o.options.rtl && (e = -e), t = "left" == o.positionProp ? Math.ceil(e) + "px" : "0px", i = "top" == o.positionProp ? Math.ceil(e) + "px" : "0px", n[o.positionProp] = e, !1 !== o.transformsEnabled && (!(n = {}) === o.cssTransitions ? n[o.animType] = "translate(" + t + ", " + i + ")" : n[o.animType] = "translate3d(" + t + ", " + i + ", 0px)"), o.$slideTrack.css(n)
    }, r.prototype.setDimensions = function() {
        var e = this,
            t = (!1 === e.options.vertical ? !0 === e.options.centerMode && e.$list.css({
                padding: "0px " + e.options.centerPadding
            }) : (e.$list.height(e.$slides.first().outerHeight(!0) * e.options.slidesToShow), !0 === e.options.centerMode && e.$list.css({
                padding: e.options.centerPadding + " 0px"
            })), e.listWidth = e.$list.width(), e.listHeight = e.$list.height(), !1 === e.options.vertical && !1 === e.options.variableWidth ? (e.slideWidth = Math.ceil(e.listWidth / e.options.slidesToShow), e.$slideTrack.width(Math.ceil(e.slideWidth * e.$slideTrack.children(".slick-slide").length))) : !0 === e.options.variableWidth ? e.$slideTrack.width(5e3 * e.slideCount) : (e.slideWidth = Math.ceil(e.listWidth), e.$slideTrack.height(Math.ceil(e.$slides.first().outerHeight(!0) * e.$slideTrack.children(".slick-slide").length))), e.$slides.first().outerWidth(!0) - e.$slides.first().width());
        !1 === e.options.variableWidth && e.$slideTrack.children(".slick-slide").width(e.slideWidth - t)
    }, r.prototype.setFade = function() {
        var i, o = this;
        o.$slides.each(function(e, t) {
            i = o.slideWidth * e * -1, !0 === o.options.rtl ? c(t).css({
                position: "relative",
                right: i,
                top: 0,
                zIndex: o.options.zIndex - 2,
                opacity: 0
            }) : c(t).css({
                position: "relative",
                left: i,
                top: 0,
                zIndex: o.options.zIndex - 2,
                opacity: 0
            })
        }), o.$slides.eq(o.currentSlide).css({
            zIndex: o.options.zIndex - 1,
            opacity: 1
        })
    }, r.prototype.setHeight = function() {
        var e, t = this;
        1 === t.options.slidesToShow && !0 === t.options.adaptiveHeight && !1 === t.options.vertical && (e = t.$slides.eq(t.currentSlide).outerHeight(!0), t.$list.css("height", e))
    }, r.prototype.setOption = r.prototype.slickSetOption = function() {
        var e, t, i, o, n, s = this,
            r = !1;
        if ("object" === c.type(arguments[0]) ? (i = arguments[0], r = arguments[1], n = "multiple") : "string" === c.type(arguments[0]) && (i = arguments[0], o = arguments[1], r = arguments[2], "responsive" === arguments[0] && "array" === c.type(arguments[1]) ? n = "responsive" : void 0 !== arguments[1] && (n = "single")), "single" === n) s.options[i] = o;
        else if ("multiple" === n) c.each(i, function(e, t) {
            s.options[e] = t
        });
        else if ("responsive" === n)
            for (t in o)
                if ("array" !== c.type(s.options.responsive)) s.options.responsive = [o[t]];
                else {
                    for (e = s.options.responsive.length - 1; 0 <= e;) s.options.responsive[e].breakpoint === o[t].breakpoint && s.options.responsive.splice(e, 1), e--;
                    s.options.responsive.push(o[t])
                } r && (s.unload(), s.reinit())
    }, r.prototype.setPosition = function() {
        var e = this;
        e.setDimensions(), e.setHeight(), !1 === e.options.fade ? e.setCSS(e.getLeft(e.currentSlide)) : e.setFade(), e.$slider.trigger("setPosition", [e])
    }, r.prototype.setProps = function() {
        var e = this,
            t = document.body.style;
        e.positionProp = !0 === e.options.vertical ? "top" : "left", "top" === e.positionProp ? e.$slider.addClass("slick-vertical") : e.$slider.removeClass("slick-vertical"), void 0 === t.WebkitTransition && void 0 === t.MozTransition && void 0 === t.msTransition || !0 === e.options.useCSS && (e.cssTransitions = !0), e.options.fade && ("number" == typeof e.options.zIndex ? e.options.zIndex < 3 && (e.options.zIndex = 3) : e.options.zIndex = e.defaults.zIndex), void 0 !== t.OTransform && (e.animType = "OTransform", e.transformType = "-o-transform", e.transitionType = "OTransition", void 0 === t.perspectiveProperty && void 0 === t.webkitPerspective && (e.animType = !1)), void 0 !== t.MozTransform && (e.animType = "MozTransform", e.transformType = "-moz-transform", e.transitionType = "MozTransition", void 0 === t.perspectiveProperty && void 0 === t.MozPerspective && (e.animType = !1)), void 0 !== t.webkitTransform && (e.animType = "webkitTransform", e.transformType = "-webkit-transform", e.transitionType = "webkitTransition", void 0 === t.perspectiveProperty && void 0 === t.webkitPerspective && (e.animType = !1)), void 0 !== t.msTransform && (e.animType = "msTransform", e.transformType = "-ms-transform", e.transitionType = "msTransition", void 0 === t.msTransform && (e.animType = !1)), void 0 !== t.transform && !1 !== e.animType && (e.animType = "transform", e.transformType = "transform", e.transitionType = "transition"), e.transformsEnabled = e.options.useTransform && null !== e.animType && !1 !== e.animType
    }, r.prototype.setSlideClasses = function(e) {
        var t, i, o, n = this,
            s = n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true");
        n.$slides.eq(e).addClass("slick-current"), !0 === n.options.centerMode ? (i = n.options.slidesToShow % 2 == 0 ? 1 : 0, o = Math.floor(n.options.slidesToShow / 2), !0 === n.options.infinite && (o <= e && e <= n.slideCount - 1 - o ? n.$slides.slice(e - o + i, e + o + 1).addClass("slick-active").attr("aria-hidden", "false") : (t = n.options.slidesToShow + e, s.slice(t - o + 1 + i, t + o + 2).addClass("slick-active").attr("aria-hidden", "false")), 0 === e ? s.eq(s.length - 1 - n.options.slidesToShow).addClass("slick-center") : e === n.slideCount - 1 && s.eq(n.options.slidesToShow).addClass("slick-center")), n.$slides.eq(e).addClass("slick-center")) : 0 <= e && e <= n.slideCount - n.options.slidesToShow ? n.$slides.slice(e, e + n.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : s.length <= n.options.slidesToShow ? s.addClass("slick-active").attr("aria-hidden", "false") : (i = n.slideCount % n.options.slidesToShow, t = !0 === n.options.infinite ? n.options.slidesToShow + e : e, (n.options.slidesToShow == n.options.slidesToScroll && n.slideCount - e < n.options.slidesToShow ? s.slice(t - (n.options.slidesToShow - i), t + i) : s.slice(t, t + n.options.slidesToShow)).addClass("slick-active").attr("aria-hidden", "false")), "ondemand" !== n.options.lazyLoad && "anticipated" !== n.options.lazyLoad || n.lazyLoad()
    }, r.prototype.setupInfinite = function() {
        var e, t, i, o = this;
        if (!0 === o.options.fade && (o.options.centerMode = !1), !0 === o.options.infinite && !1 === o.options.fade && (t = null, o.slideCount > o.options.slidesToShow)) {
            for (i = !0 === o.options.centerMode ? o.options.slidesToShow + 1 : o.options.slidesToShow, e = o.slideCount; e > o.slideCount - i; --e) c(o.$slides[t = e - 1]).clone(!0).attr("id", "").attr("data-slick-index", t - o.slideCount).prependTo(o.$slideTrack).addClass("slick-cloned");
            for (e = 0; e < i + o.slideCount; e += 1) t = e, c(o.$slides[t]).clone(!0).attr("id", "").attr("data-slick-index", t + o.slideCount).appendTo(o.$slideTrack).addClass("slick-cloned");
            o.$slideTrack.find(".slick-cloned").find("[id]").each(function() {
                c(this).attr("id", "")
            })
        }
    }, r.prototype.interrupt = function(e) {
        e || this.autoPlay(), this.interrupted = e
    }, r.prototype.selectHandler = function(e) {
        e = c(e.target).is(".slick-slide") ? c(e.target) : c(e.target).parents(".slick-slide"), e = parseInt(e.attr("data-slick-index")) || 0;
        this.slideCount <= this.options.slidesToShow ? this.slideHandler(e, !1, !0) : this.slideHandler(e)
    }, r.prototype.slideHandler = function(e, t, i) {
        var o, n, s, r = this;
        if (t = t || !1, !(!0 === r.animating && !0 === r.options.waitForAnimate || !0 === r.options.fade && r.currentSlide === e))
            if (!1 === t && r.asNavFor(e), o = e, t = r.getLeft(o), s = r.getLeft(r.currentSlide), r.currentLeft = null === r.swipeLeft ? s : r.swipeLeft, !1 === r.options.infinite && !1 === r.options.centerMode && (e < 0 || e > r.getDotCount() * r.options.slidesToScroll)) !1 === r.options.fade && (o = r.currentSlide, !0 !== i && r.slideCount > r.options.slidesToShow ? r.animateSlide(s, function() {
                r.postSlide(o)
            }) : r.postSlide(o));
            else if (!1 === r.options.infinite && !0 === r.options.centerMode && (e < 0 || e > r.slideCount - r.options.slidesToScroll)) !1 === r.options.fade && (o = r.currentSlide, !0 !== i && r.slideCount > r.options.slidesToShow ? r.animateSlide(s, function() {
            r.postSlide(o)
        }) : r.postSlide(o));
        else {
            if (r.options.autoplay && clearInterval(r.autoPlayTimer), n = o < 0 ? r.slideCount % r.options.slidesToScroll != 0 ? r.slideCount - r.slideCount % r.options.slidesToScroll : r.slideCount + o : o >= r.slideCount ? r.slideCount % r.options.slidesToScroll != 0 ? 0 : o - r.slideCount : o, r.animating = !0, r.$slider.trigger("beforeChange", [r, r.currentSlide, n]), e = r.currentSlide, r.currentSlide = n, r.setSlideClasses(r.currentSlide), r.options.asNavFor && (s = (s = r.getNavTarget()).slick("getSlick")).slideCount <= s.options.slidesToShow && s.setSlideClasses(r.currentSlide), r.updateDots(), r.updateArrows(), !0 === r.options.fade) return !0 !== i ? (r.fadeSlideOut(e), r.fadeSlide(n, function() {
                r.postSlide(n)
            })) : r.postSlide(n), void r.animateHeight();
            !0 !== i && r.slideCount > r.options.slidesToShow ? r.animateSlide(t, function() {
                r.postSlide(n)
            }) : r.postSlide(n)
        }
    }, r.prototype.startLoad = function() {
        var e = this;
        !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow.hide(), e.$nextArrow.hide()), !0 === e.options.dots && e.slideCount > e.options.slidesToShow && e.$dots.hide(), e.$slider.addClass("slick-loading")
    }, r.prototype.swipeDirection = function() {
        var e = this,
            t = e.touchObject.startX - e.touchObject.curX,
            i = e.touchObject.startY - e.touchObject.curY,
            i = Math.atan2(i, t),
            t = Math.round(180 * i / Math.PI);
        return (t = t < 0 ? 360 - Math.abs(t) : t) <= 45 && 0 <= t || t <= 360 && 315 <= t ? !1 === e.options.rtl ? "left" : "right" : 135 <= t && t <= 225 ? !1 === e.options.rtl ? "right" : "left" : !0 === e.options.verticalSwiping ? 35 <= t && t <= 135 ? "down" : "up" : "vertical"
    }, r.prototype.swipeEnd = function(e) {
        var t, i, o = this;
        if (o.dragging = !1, o.swiping = !1, o.scrolling) return o.scrolling = !1;
        if (o.interrupted = !1, o.shouldClick = !(10 < o.touchObject.swipeLength), void 0 === o.touchObject.curX) return !1;
        if (!0 === o.touchObject.edgeHit && o.$slider.trigger("edge", [o, o.swipeDirection()]), o.touchObject.swipeLength >= o.touchObject.minSwipe) {
            switch (i = o.swipeDirection()) {
                case "left":
                case "down":
                    t = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide + o.getSlideCount()) : o.currentSlide + o.getSlideCount(), o.currentDirection = 0;
                    break;
                case "right":
                case "up":
                    t = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide - o.getSlideCount()) : o.currentSlide - o.getSlideCount(), o.currentDirection = 1
            }
            "vertical" != i && (o.slideHandler(t), o.touchObject = {}, o.$slider.trigger("swipe", [o, i]))
        } else o.touchObject.startX !== o.touchObject.curX && (o.slideHandler(o.currentSlide), o.touchObject = {})
    }, r.prototype.swipeHandler = function(e) {
        var t = this;
        if (!(!1 === t.options.swipe || "ontouchend" in document && !1 === t.options.swipe || !1 === t.options.draggable && -1 !== e.type.indexOf("mouse"))) switch (t.touchObject.fingerCount = e.originalEvent && void 0 !== e.originalEvent.touches ? e.originalEvent.touches.length : 1, t.touchObject.minSwipe = t.listWidth / t.options.touchThreshold, !0 === t.options.verticalSwiping && (t.touchObject.minSwipe = t.listHeight / t.options.touchThreshold), e.data.action) {
            case "start":
                t.swipeStart(e);
                break;
            case "move":
                t.swipeMove(e);
                break;
            case "end":
                t.swipeEnd(e)
        }
    }, r.prototype.swipeMove = function(e) {
        var t, i, o = this,
            n = void 0 !== e.originalEvent ? e.originalEvent.touches : null;
        return !(!o.dragging || o.scrolling || n && 1 !== n.length) && (t = o.getLeft(o.currentSlide), o.touchObject.curX = void 0 !== n ? n[0].pageX : e.clientX, o.touchObject.curY = void 0 !== n ? n[0].pageY : e.clientY, o.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(o.touchObject.curX - o.touchObject.startX, 2))), n = Math.round(Math.sqrt(Math.pow(o.touchObject.curY - o.touchObject.startY, 2))), !o.options.verticalSwiping && !o.swiping && 4 < n ? !(o.scrolling = !0) : (!0 === o.options.verticalSwiping && (o.touchObject.swipeLength = n), n = o.swipeDirection(), void 0 !== e.originalEvent && 4 < o.touchObject.swipeLength && (o.swiping = !0, e.preventDefault()), e = (!1 === o.options.rtl ? 1 : -1) * (o.touchObject.curX > o.touchObject.startX ? 1 : -1), !0 === o.options.verticalSwiping && (e = o.touchObject.curY > o.touchObject.startY ? 1 : -1), i = o.touchObject.swipeLength, (o.touchObject.edgeHit = !1) === o.options.infinite && (0 === o.currentSlide && "right" === n || o.currentSlide >= o.getDotCount() && "left" === n) && (i = o.touchObject.swipeLength * o.options.edgeFriction, o.touchObject.edgeHit = !0), !1 === o.options.vertical ? o.swipeLeft = t + i * e : o.swipeLeft = t + i * (o.$list.height() / o.listWidth) * e, !0 === o.options.verticalSwiping && (o.swipeLeft = t + i * e), !0 !== o.options.fade && !1 !== o.options.touchMove && (!0 === o.animating ? (o.swipeLeft = null, !1) : void o.setCSS(o.swipeLeft))))
    }, r.prototype.swipeStart = function(e) {
        var t, i = this;
        if (i.interrupted = !0, 1 !== i.touchObject.fingerCount || i.slideCount <= i.options.slidesToShow) return !(i.touchObject = {});
        void 0 !== e.originalEvent && void 0 !== e.originalEvent.touches && (t = e.originalEvent.touches[0]), i.touchObject.startX = i.touchObject.curX = void 0 !== t ? t.pageX : e.clientX, i.touchObject.startY = i.touchObject.curY = void 0 !== t ? t.pageY : e.clientY, i.dragging = !0
    }, r.prototype.unfilterSlides = r.prototype.slickUnfilter = function() {
        var e = this;
        null !== e.$slidesCache && (e.unload(), e.$slideTrack.children(this.options.slide).detach(), e.$slidesCache.appendTo(e.$slideTrack), e.reinit())
    }, r.prototype.unload = function() {
        var e = this;
        c(".slick-cloned", e.$slider).remove(), e.$dots && e.$dots.remove(), e.$prevArrow && e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove(), e.$nextArrow && e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove(), e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "")
    }, r.prototype.unslick = function(e) {
        this.$slider.trigger("unslick", [this, e]), this.destroy()
    }, r.prototype.updateArrows = function() {
        var e = this;
        Math.floor(e.options.slidesToShow / 2);
        !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && !e.options.infinite && (e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), 0 === e.currentSlide ? (e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : (e.currentSlide >= e.slideCount - e.options.slidesToShow && !1 === e.options.centerMode || e.currentSlide >= e.slideCount - 1 && !0 === e.options.centerMode) && (e.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")))
    }, r.prototype.updateDots = function() {
        var e = this;
        null !== e.$dots && (e.$dots.find("li").removeClass("slick-active").end(), e.$dots.find("li").eq(Math.floor(e.currentSlide / e.options.slidesToScroll)).addClass("slick-active"))
    }, r.prototype.visibility = function() {
        this.options.autoplay && (document[this.hidden] ? this.interrupted = !0 : this.interrupted = !1)
    }, c.fn.slick = function() {
        for (var e, t = this, i = arguments[0], o = Array.prototype.slice.call(arguments, 1), n = t.length, s = 0; s < n; s++)
            if ("object" == typeof i || void 0 === i ? t[s].slick = new r(t[s], i) : e = t[s].slick[i].apply(t[s].slick, o), void 0 !== e) return e;
        return t
    }
});